const en = {
	storeManagement: {
		onvkg: 'Please select the seller for inventory',
		hginvlg: 'please choose',
		gnivn: 'Please choose a seller',
		ggru: 'Please select warehouse type',
		yhgnmv: 'Number of remaining products',
		okmv: 'Total remaining volume',
		hvkfb: 'Total remaining weight',
		rjbjh: 'Number of reviewed (not shipped out)',
		trbv: 'Unshipped quantity',
		ggdfj: 'Transfer now',
		cancel: 'Cancel',
		yriunv: 'confirm',
		ivnkf: 'Modify product inventory',
		ikgkvj: 'Please enter the reason for modifying the inventory (required)',
		plhjkv: 'Fully open',
		tjbvl: 'Collapse all',
		uhjvhjf: 'Search warehouse code，sku，product name',
		oknvk: 'Whole warehouse export',
		ivlionr: 'Warehouse inventory',
		uymbk: 'Warehouse library mother Sku：',
		oknhgh: 'Expand / Collapse',
		kfiuhkg: 'Number of warehouse sku：',
		rhukfh: 'Total remaining inventory：',
		yttnkv: 'Seller name：',
		ighkv: 'volume：',
		ibvnkf: 'Position：',
		oplmg: 'Warehouse sub sku：',
		iomnlgn: 'Save',
		fiklnmv: 'edit',
		ouhkngj: 'View inventory log',
		thbjv: 'Inventory log',
		kihk: 'Total number of order changes',
		ponkn: 'Inventory changes',
		dfggjk: 'Reason for change',
		kgnmv: 'Change time',
		fihgk: 'The latest inventory in stock',
		oooou: 'closure',
		opmngh: 'Inventory management',
		ijkj: 'Single product library',
		oikl: 'Combinatorial library',
		ppki: 'Gift library'




	},

	distrustOrder: {
		returnMangement: 'Return and exchange management',
		scan: 'order number，Waybill number scanning area',
		status: 'Return status：',
		sellerConfirm: 'Pending the seller to verify the return',
		hasConfirm: 'Seller has confirmed',
		aleadyAudit: 'Processed',
		orderSearch: 'Order number search',
		serach: 'search',
		orderId: 'order number',
		orderStatus: 'Order Status',
		createdTimed: 'order time',
		tosellerconfirm: 'To be confirmed by the seller',
		delete: 'delete',
		position: 'Position：',
		cuscode: 'Warehouse code',
		originsku: 'Owned single product',
		purchaseNum: 'Purchase quantity',
		jvknf: 'Number of configurations',
		inlnv: 'Seller request processing method：',
		konmkf: 'Quantity on shelves：',
		lkndv: 'The actual processing method of the warehouse：',
		oknlv: 'Number of configurations：',
		knvtr: 'received a package',
		knvfvtr: 'To be confirmed by the seller',
		pkjnmg: 'To be confirmed by the warehouse',
		bbnkf: 'Warehouse notes:',
		pombkg: 'Seller notes:',
		bbvmkmg: 'Fill in the received return information',
		okjnmv: 'Message to seller',
		momf: 'Click upload',
		gytnv: 'Only jpg/png files can be uploaded, and no more than 8M',
		cancel: 'delete',
		confirmBtn: 'confirm',
		okgnv: 'Return package',
		loknv: 'submit',
		kvnkf: 'Message to seller(Not required)',
		ovbhkng: 'No orders,Please scan and enter！',


	},
	scanIntoStoreage: {
		ivnfiln: 'Inbound order number：',
		vklnf: 'Seller：',
		oeknv: 'Total purchases by sellers：',
		oevlknv: 'Total warehouse check：',
		obvpkf: 'Additional additional costs for the warehouse：',
		mmnnkv: 'Reset receipt',
		wiubvm: 'Recheck',
		ornkf: 'Confirm storage',
		wecbdk: 'Warehouse confirmed',
		ovmoinv: 'Seller reminder',
		ytbm: 'Abnormal quantity',
		rebcd: 'Seller Message',
		rebcj: 'Product length/width/height，Weight is required',
		nnbhg: 'The number entered by the seller is inconsistent with the actual number of receipts，Confirm receipt？',
		trbvcm: 'Yes',
		pomv: 'Cancel',
		aswvcx: 'Confirm receipt？',
		dthj: 'Has been successfully submitted to the seller for confirmation！',
		efhn: 'There is no purchase of this product in the current warehousing order！',
		treybvc: 'Please scan the receipt number',
		qwefc: 'Please scan the product barcode',

	},
	processed: {
		cargoflow: 'Self-built single cargo flow',
		Thesellernote: 'The seller note',
		Chooselogistics: 'Choose the logistics',
		bulk: 'bulk/cm',
		length: 'length/cm',
		width: 'width/cm',
		height: 'height/cm',
		weight: 'weight/kg',
		actualfreight: 'actual freight',
		waybillnumber: 'waybill number',
		cancel: 'Cancel',
		confirm: 'Confirm',
		Scanningoutbound: 'Scanning outbound',
		Orderarea: 'Order number or waybill number scan area',
		Dateofpackaging: 'Date of packaging',
		outboundorders: 'Total number of outbound orders',
		Themodified: 'The order that the user has modified',
		enterheight: 'Please enter height',
		enterlength: 'Please enter length',
		enterwidth: 'Please enter width',
		selectlogistics: 'Please select logistics',
		enterweight: 'Please enter weight',
		Logisticsdelivery: 'Logistics delivery information of self-built order has been submitted!',
		redasterisk: 'The red asterisk is mandatory, please fill in!',
		remarkspresent: "No seller's remarks at present",
		details: ', please check the order details!',
		hint: 'hint',
		Isee: 'I see',
		Processedorder: 'Processed order',
		optiondate: 'Option Date',
		startdate: 'start date',
		dateclosed: 'date closed',
		ordernumber: 'Order Number',
		Findnumber: 'Find the order number',
		find: 'Find',
		Warehouse: 'Warehouse scan out (for use in overseas warehouses)',
		Quantity: 'Quantity of outbound orders',
		Numberof: 'Number of cancellations after outgoing',
		Expresscollection: 'Express collection',
		money: 'Money',
		deliveryfee: 'The delivery fee',
		operation: 'Operation',
		ViewOrder: 'View Order',
		Exportorders: 'Export orders',
		Print: 'Print the express receipt',
		all: 'ALL',
		Platformtype: 'Platform type:',
		single: 'Self-built single',
		Select: 'Select warehouse:',
		Typofseller: 'Type of seller:',
		Logisticstype: 'Logistics type:',
		Thegetsall: 'The seller gets all processed orders',
		RecordDetails: 'Packing Record Details',
		Couriername: 'Courier name',
		firstheavy: 'The first heavy/kg',
		heavycost: 'The first heavy cost rmb/kg',
		Continuedheavy: 'Continued heavy',
		chargemode: 'Charge mode',
		volumeweight: 'volume weight',
		Takeofboth: 'Take the maximum of both',
		actualweight: 'Actual Weight',
		actualvolume: 'Actual Volume',
		actualcharges: 'Actual Charges',
		integral: 'integral',
		Actualexpressfee: 'Actual express fee',
		currency: 'currency',
		Totalorders: 'Total number of orders',
		Reprintthesheet: 'Reprint the sheet',
		once: 'once',
		Unscannedoutgoing: 'Unscanned outgoing',
		LanShoutime: 'LanShou time',
		NotLanShou: 'Not LanShou',
		Printcode: 'Print product SKU bar code',
		Printentry: 'Print the bar code of the entry',
		Barcodeprinting: 'Bar code printing',
		printingquantity: 'printing quantity',
		Scanincoming: 'Scan incoming',
		Thesellerside: 'The seller side',
		Estimatedvolume: 'Estimated total volume',
		viewdetails: 'view details',
		Guidethe: 'Guide the',
		Checkcurrency: 'Check the currency',
		summary: 'Summary',
		local: 'Platform fee and delivery fee have been deducted, including additional commission fee for platform activities, etc. (that is, actual revenue of store wallet in RMB, the specific exchange rate can be set by users themselves)',
		localt: 'Have minus platform cost and delivery cost, including platform activity extra commission fee, etc (namely shop purse real income, and as the renminbi, specific exchange rate can be set up the users own procurement costs, freight, in accordance with the first-in, first-out accounting gross profit (namely different batches Air occupy different sea freight costs, and for the yuan, specific exchange rate can be set up the users own)',
		localth: 'According to accounting value, the actual purchase price and road transportation cost are distinguished (the value of goods transported to different countries will increase due to transportation, and the value is IN RMB, and the specific exchange rate can be set by the user)',
		shopId: 'shopId',
		shopName: 'shopName',
		country: 'country',
		platform: 'platform',
		turnover: 'turnover',
		advCost: 'advCost',
		returnAmount: 'returnAmount',
		orderCount: 'orderCount',
		orderItemCount: 'orderItemCount',
		outboundCount: 'outboundCount',
		outboundItemCount: 'outboundItemCount',
		shipCost: 'shipCost',
		costCount: 'costCount',
		Warehousestatus: 'Warehouse - Inventory status',
		storeid: 'storeId',
		storeName: 'storeName',
		volume: 'volume(m³)',
		cost: 'cost',
		unshipped: 'unshipped',
		skunum: 'skunum',
		storenum: 'storenum',
		weight: 'weight(kg)',
		auditedstock: 'auditedstock',
		expenditurecc: 'Summary of point income and expenditure',
		payType: 'payType',
		changeIntegral: 'changeIntegral',
		operation: 'operation',
		chart: 'Trend Chart',
		exchangerate: 'exchange rate',
		Modifyrate: 'Modify the rate',
		latestcurrency: 'The latest currency',
		newexchange: 'Please enter the new exchange rate',
		wechat: 'Payment of wechat recharge',
		Wechatincome: 'Wechat recharge income',
		Spendingorder: 'Spending on the order',
		Orderincome: 'Order income',
		expenditure: 'Warehouse entry expenditure',
		alipay: 'Payment of alipay recharge',
		Alipayincome: 'Alipay recharge income',
		Receiptentry: 'Receipt of warehouse entry',
		rentalexpenses: 'Warehouse rental expenses',
		SMSscore: 'SMS score expenditure',
		Smart: 'Smart customer service expenses',
		Spendingtranslation: 'Spending on translation',
		handlingexpenses: 'Return handling expenses',
		Returnincome: 'Return processing income',
		rentalincome: 'Warehouse rental income',
		freightexpenses: 'First trip freight expenses',
		revenue: 'First shipment revenue',
		Preferentia: 'Preferential spending',
		Preferentialincome: 'Preferential income',
		SMSrevenue: 'SMS integral revenue',
		Inventory: 'Inventory product expenses',
		productincome: 'Inventory product cost income',
		Customerexpenses: 'Customer complaint expenses',
		complaintrevenue: 'Customer complaint fee revenue',
		Revenueservice: 'Revenue from intelligent customer service',
		Translationincome: 'Translation income',
		Logisticsexpenses: 'Logistics expenses of self-established order',
		Logisticsfee: 'Logistics fee income of self-established order',
		Cashspending: 'Cash back spending',
		Cashbackincome: 'Cashback income',
		Cashspending: 'Cash spending',
		Cashincome: 'Cash income',
		temporalinterval: 'Date Interval',

	},
	chat: {
		Allthequery: 'All the query',
		Querymessage: 'Query message',
		QueryingCustomername: 'Querying a Customer name',
		Authorizedshops: 'Authorized shops',
		Allunreadmessages: 'All unread messages',
		Topnews: 'Top news',
		Thailand: 'Thailand',
		thePhilippines: 'Philippines',
		Malaysia: 'Malaysia',
		Indonesia: 'Indonesia',
		Singapore: 'Singapore',
		Taiwan: 'Taiwan',
		Vietnam: 'Vietnam',
		Pleasefirst: 'Please authorize the shop first',
		Managementgroup: 'Management group',
		Synchronizesessions: 'Synchronize shopee sessions',
		Clickon: 'Click on the message to translate it',
		Chinese: 'Chinese',
		English: 'English',
		intoEnglish: 'Translate into English',
		intoVietnamese: 'Translated into Vietnamese',
		intoChinese: 'Translate into Chinese',
		intoIndonesian: 'Translated into Indonesian',
		intoSpanish: 'Translated into Spanish',
		intoPortuguese: 'Translated into Portuguese',
		original: 'Original',
		commodity: 'Commodity',
		order: 'Order',
		product: 'Prodect',
		Ordercreationtime: 'Order creation time',
		DatetoPull: 'Date to Pull',
		deliverytime: 'Delivery time',
		why: 'Why use authorized Shopee multi-store chat?',
		reply: 'Auto-Response',
		response: 'Auto Reply',
		Automaticsetting: 'Automatic reply date setting',
		Modifyreply: 'Modify the automatic reply',
		Addcontent: 'Add automatic reply content',
		Pleasereply: 'Please enter an automatic reply',
		cancel: 'Cancel',
		confirm: 'Confirm',
		Recommended: 'Recommended',
		Fastreply: 'Qick reply',
		Machineresponse: 'Machine learning response',
		beenmatched: 'No reply has been matched',
		searchresult: 'Search result',
		copy: 'Copy',
		back: 'Back',
		Monday: 'Monday',
		Tuesday: 'Tuesday',
		Wednesday: 'Wednesday',
		Thursday: 'Thursday',
		Friday: 'Friday',
		Saturday: 'Saturday',
		Sunday: 'Sunday',
		CreateReply: 'Create quick Reply',
		issueofstandards: 'Issue of standards',
		messagetranslation: 'Automatic Translation',
		language: 'Language',
		send: 'Send',
		translate: 'Translate',
		original: 'Original',
		Orderdata: 'Order data',
		completed: 'COMPLETED',
		canceled: 'CANCELLED',
		transport: 'SHIPPED',
		uNPAID: 'UNPAID',
		rEADY_TO_SHIP: 'READY_TO_SHIP',
		tO_CONFIRM_RECEIVE: 'TO_CONFIRM_RECEIVE',
		pROCESSED: 'PROCESSED',
		pending: 'Is cancelled',
		stepone: 'step 1',
		modification: 'Amend',
		entercontent: 'Please enter content',
		cancellationorder: 'cancellation of order',
		cause: 'Cause',
		Nouser: 'No user order data is available',
		Nouserportrai: 'No user portrait data is available',
		category: 'Category',
		powerofconsumption: 'Power of consumption',
		Totalconsumption: 'Total consumption',
		common: 'common',
		Priceinsensitive: 'Price insensitive',
		pricesensitive: 'price sensitive',
		Highspendingpower: 'high spending power',
		lowconsumption: 'low consumption',
		Loyalty: 'Loyalty',
		Numbeconsumption: 'Number of consumption',
		rejectedorders: 'Number of rejected orders',
		consumptioninterval: 'Average consumption interval',
		Consumptioratio: 'Consumption premium ratio',
		Lastdate: 'Last consumption to date',
		day: 'day',
		Qamanagement: 'Q&a management',
		Selectgroup: 'Group',
		questions: 'Questions',
		searchquestion: 'Please enter a search question',
		operationexecutive: 'Operation',
		search: 'Search',
		groupingmanagement: 'Grouping management',
		Thenewgrouping: 'The new grouping',
		grouping: 'Grouping',
		compile: 'Compile',
		delete: 'Delete',
		Addanswer: 'Add a question and answer',
		groupname: 'Please enter a group name',
		Pleaseentername: 'Please enter a new group name',
		Thenewanswers: 'The new questions and answers',
		enterthekeyword: 'Please enter a keyword to find the problem',
		Thai: 'Thai',
		Malay: 'Malay',
		Similarproblems: 'Similar problems',
		add: 'Add',
		answer: 'Answer',
		revert: 'Revert',
		thecurrentgroup: 'Adds a q&A for the current group',
		Modifytheq: 'Modify the q&a',
		issue: 'Issue',
		Addanewcustomgroup: 'Add a new custom group',
		Groupdescription: 'Group description',
		Addtogroup: 'Add to group',
		Pleaseselectgroup: 'Please select group(required )',
		Addgroup: 'Add a group',
		AddingaNewGroup: 'Adding a New Group',
		Userstories: 'User stories',
		hint: 'Hint',
		Vietnamese: 'Vietnamese',
		Indonesian: 'Indonesian',
		spanish: 'Spanish',
		Portuguese: 'Portuguese',
		image: '[image]',
		order: '[order]',
		item: '[item]',
		sticker: '[sticker]',
		successfullyadded: 'successfully added',
		successfullyset: 'successfully set',
		tips: 'The automatic reply function has been enabled, and the answer will be automatically matched with the question management. If the answer cannot be matched, the answer will be "Automatic reply content"',
		hasbeendisabled: 'Automatic reply has been disabled',
		Sessionsucceeded: 'Session synchronization succeeded',
		additionfailed: 'addition failed',
		Noisavailable: 'No matching result is available',
		modifysuccessfully: 'modify successfully',
		changefailed: 'change failed',
		cancelledsuccessfully: 'Order cancelled successfully',
		Copysuccess: 'Copy success',
		successfullydelete: 'successfully delete',
		failtodelete: 'fail to delete',
		beempty: 'Questions and answers cannot be empty',
		Confirmtoclose: 'Confirm to close?',
		Pleaseenterandmodify: 'Please enter and modify',
		succeed: 'succeed',
		sentsuccessfully: 'The product information was sent successfully',
		Failepicture: 'Failed to upload picture',
		Cancelledsend: 'Cancelled send',
		stick: 'Stick',
		Setasunread: 'Set as unread',
		Deletethesession: 'Delete the session',
		cancelauthorization: 'Cancel authorization',
		Suretomodify: 'Sure to modify',
		AddquickReplies: 'Add quick Replies',
	},//多店聊模块
	allorders: {
		verification: '999',
		notbound: "Dear, you haven't tied shopee's store yet",
		shopx: 'Head to the Bound shopee store',
		allorder: 'All orders',
		rengtime: 'Order time range',
		regions: 'Countries and regions',
		Platform: 'Platform type',
		Sestore: 'Select the store',
		Ordertype: 'Order type',
		orderscheduling: 'Order scheduling',
		Orderfind: 'Order to find',
		SHOPEE: 'SHOPEE',
		LAZADA: 'LAZADA',
		manualorder: 'Self-built manual order',
		all: 'ALL',
		nopayment: 'Non-Payment',
		audit: 'To audit',
		insanity: 'Insanity',
		collected: 'Express has been collected',
		until: 'To',
		starttime: 'Start time',
		endtime: 'End time',
		find: 'Find',
		lookup: 'Enter the order number lookup',
		Batcorders: 'Batch export of orders',
		modified: 'The order that the user has modified',
		item: 'SKU',
		setmeal: 'Set Meal',
		theitem: 'Subordinate to the item',
		quantity: 'Purchase quantity',
		description: 'No data',
		Morehere: 'More down here',
		Hideup: 'Hide up',
		latestweek: 'In the latest week',
		Lastmonth: 'Last month',
		Lastthreemonths: 'Last three months',
		phonenumber: 'Phone number',
		detailedaddress: 'Detailed address',
		particulars: 'Sku particulars',
		SkuNumbers: 'Sku Numbers',
		officialreceipts: 'Official receipts',
		timepayment: 'Time of payment',
		paydelivery: 'Pay on delivery',
		feature: 'Click to turn off the Tooltip feature',
		Steamquantity: 'Steam quantity',
		Onlineinventory: 'Online inventory',
		understock: 'Understock',
		Shopchoose: 'Shop to choose',
		Theshipment: 'The remaining shipment',
		Thecontaining: 'The order containing',
		pleasechoose: 'Please choose',
		show: 'Show',
		hide: 'Hide',
		Themarks: 'The order marks',
		nomarks: 'No marks',
		Themultiple: 'Multiselect mode',
		Isee: 'I see',
		Therepository: 'The currently selected audit repository',
		typegoods: 'Type of goods',
		warehouse: 'Required when the audit type is test warehouse',
		pastesheet: 'Whether to paste the sheet',
		Batchopen: 'Batch open',
		cause: 'Cause',
		Synchronizingorder: 'Synchronizing a single order',
		can: 'Can be set according to the store automatic audit orders to the specified warehouse',
		payondelivery: 'Pay on delivery(COD)',
		Unboundproduct: 'Unbound warehouse product',
		relationship: 'Changing the binding relationship',
		Tobind: 'To bind',
		emptyproducts: 'An empty bag products',
		Deleteorder: 'Delete the self-built order',
		Hiddenorder: 'Hidden order',
		Accordingorder: 'According to the order',
		Restoreorder: 'Restore order',

	},
	homeTwo: {
		title: 'shop/warehouse-Overview',
		width: 'width',
		Wholewarehousetransferinventoryandcorrespondingrelationship: 'Whole warehouse transfer inventory and corresponding relationship',
		whitelist: 'whitelist',
		weight: 'weight',
		Waybillnumber: 'Waybill number',
		Warehousetype: 'Warehouse type',
		Warehousescanout: 'Warehouse scan out of the warehouse (used in overseas warehouses)',
		Warehousemothersku: 'Warehouse mother sku',
		Warehousemother: 'Warehouse mother',
		Warehousemessage: 'Warehouse message',
		Warehousecode: 'Warehouse code',
		Warehouse: 'Warehouse',
		volume: 'volume',
		vkf: 'Operation help',
		Viewselleroffers: 'View seller offers',
		Viewpreaccountedpointsdetails: 'View pre-accounted points details',
		Viewpointsdetails: 'View points details',
		Viewinventorydiary: 'View inventory diary',
		View: 'View/Edit',
		Userportrait: 'User portrait',
		Unpaid: 'Unpaid',
		Unmarked: 'Unmarked',
		Unfold: 'unfold/Put away',
		Turnonautomaticmessagetranslation: 'Turn on automatic message translation',
		Turnon: 'Turn on',
		Transportationcosts: 'Transportation costs',
		translation: 'translation',
		Totalsales: 'Total sales',
		Totalremaininginventory: 'Total remaining inventory',
		totalpoints: 'total points',
		Totalpayment: 'Total payment',
		Totalinventory: 'Total inventory',
		Totalcurrentpurchases: 'Total current purchases',
		Totalconsumptionamount: 'Total consumption amount',
		ToProcess: 'Thailand warehouse',
		ToCheck: 'Pending order',
		Tobeconfirmedbytheseller: 'To be confirmed by the seller',
		Thesellerhasbeendetermined: 'The seller has been determined',
		Theintervalbetweenthelastconsumptionandthepresent: 'The interval between the last consumption and the present',
		Thaiselleruser: 'Thai seller user',
		Thailandwarehouse: 'Thailand warehouse',
		Thailandtestwarehouse: 'Thailand test warehouse',
		Thailanddistributionwarehouse: 'Thailand distribution warehouse (test)',
		Thailand: 'Thailand',
		Thail: 'Thailand',
		Testingwarehouse: 'Testing warehouse',
		TechnicalSupport: 'Technical Support',
		Synchronizeshopeeconversation: 'Synchronize shopee conversation',
		Successfullyreceived: 'Successfully received',
		Successfullypaidtheorder: 'Successfully paid the order',
		Successfullyclaimedorder: 'Successfully claimed-order',
		Successful: 'Successful order has been claimed',
		Subwarehouse: 'Sub-cang',
		SubInspection: 'order number',
		StoreName: 'Store Name',
		Stockreceipt: 'Inbound order management',
		Stockmanage: 'Inventory management',
		Spotinventory: 'Spot inventory',
		Spendingpower: 'Spending power',
		Specificationname: 'Specification name',
		SmartChat: 'Management group',
		Singleproductlibrary: 'Single product library',
		Singleproduct: 'Single product/Set meal',
		signout: 'sign out',
		Signforreminder: 'Sign for reminder',
		Showresults: 'Show results',
		Shopfilter: 'Shop filter',
		Shop: 'shop',
		Shippingwarehouse: 'Shipping warehouse',
		Shipmentreminder: 'Shipment reminder',
		Setupselleroffers: 'Set up seller offers',
		Setupanemptypackage: 'Set up an empty package',
		Setmeal: 'Set meal',
		Senttogether: 'Sent together',
		Sensitivegoodsbyland: 'Sensitive goods by land',
		send: 'send',
		Sellingprice: 'Selling price',
		Sellerusercurrentlybound: 'Seller user currently bound',
		Sellertype: 'Seller type',
		Sellerside: 'Seller side',
		Sellerpurchasequantity: 'Seller purchase quantity',
		Sellernotes: 'Seller notes',
		SellerMessage: 'Seller Message',
		Selleraccount: 'Seller account',
		Seller: 'Seller',
		Selfbuiltorder: 'Self-built order',
		Selfbuiltmanualorder: 'Self-built manual order',
		Selectstorage: 'Select storage',
		Selectdate: 'Select date',
		selectall: 'select all/Reverse election',
		seedetails: 'see details',
		Search: 'Search warehouse code, sku, product name',
		Scanarea: 'Scan area',
		Returnstatus: 'Return status',
		ReturnsManagement: 'Return and exchange management',
		return: 'return',
		Resetthepickedquantity: 'Reset the picked quantity',
		Resetorder: 'Reset order',
		Required: 'Required',
		Remindertype: 'Reminder type',
		Reminder: 'Reminder',
		Remarks: 'Remarks',
		Remainingdeliverytimefrommoretoless: 'Remaining delivery time from more to less',
		Remainingdeliverytimefromlesstomore: 'Remaining delivery time from less to more',
		Remainingdeliverytime: 'Remaining delivery time',
		Relative: 'Relative category average price average consumption premium ratio',
		Rechargenow: 'Recharge now',
		Receivefailed: 'Receive failed',
		reasonsforreturn: 'reasons for return',
		Questionandanswermanagement: 'Question and answer management',
		Quantitypicked: 'Quantity picked',
		Quantity: 'Quantity',
		Pushtime: 'Push time',
		Purchasequantityinteger: 'Purchase quantity (integer)',
		Purchasequantity: 'Purchase quantity',
		productstatus: 'product status',
		productname: 'product name',
		Productcollection: 'Product collection',
		Processed: 'Processed',
		Processed: 'Order processed',
		Privatewarehouse: 'Private warehouse',
		Printthecouriersign: 'Print the courier sign',
		printingtime: 'printing time',
		Printbarcode: 'Print barcode',
		Pricesensitivity: 'Price sensitivity',
		Pricesensitive: 'Price sensitive',
		Priceinsensitive: 'Price insensitive',
		Presale: 'Pre-sale',
		Preemptivepoints: 'Preemptive points',
		Position: 'Position',
		PointsAvailable: 'Points Available',
		Platformtype: 'Platform type',
		Personalcenter: 'Personal center',
		Pendingthesellertoverifythreturn: 'Pending the seller to verify the return',
		Pendingreview: 'Pending review',
		Paymenttime: 'Payment time',
		paymentsuccessful: 'payment successful',
		Packingdate: 'Packing date',
		OverseasWarehouseComplaintCenter: 'Complaint',
		Outboundfee: 'Outbound fee',
		ordinary: 'ordinary',
		OrderType: 'Order Type',
		OrderTracking: 'Order Tracking',
		Ordertimerange: 'Order time range',
		Ordertimefrommorningtonight: 'Order time from morning to night',
		Ordertimefromlatetoearly: 'Order time from late to early',
		ordernumber: 'order number',
		Orderlookup: 'Order lookup',
		Orderdata: 'Order data',
		Orderactuallypaid: 'Order actually paid',
		order: 'Pending Claim-Order',
		operating: 'operating',
		Oneclickgenerationprice: 'One-click generation price',
		Oneclickcollection: 'One-click collection',
		Offshelfdistribution: 'Off-shelf distribution',
		Numberofwarehousesku: 'Number of warehouse sku',
		Numberofoutboundorders: 'Number of outbound orders',
		Numberofordersrejected: 'Number of orders rejected',
		Numberofordersconsumptionnumber: 'Number of orders (consumption number)',
		Numberofcancellationsafterdelivery: 'Number of cancellations after delivery',
		Notprinted: 'Not printed',
		Notoutofstock: 'Not out of stock',
		Notgenerated: 'Not generated',
		Nomessage: 'No message',
		Nodata: 'No data',
		No: 'no',
		Newlyaddedproducts: 'Newly added products',
		Negotiate: 'Negotiate',
		Nationalcurrency: 'National currency',
		Multiplechoice: 'Multiple choice',
		MonitoringPrice: 'Online products',
		Monitoredproducts: 'Monitored products',
		Modifyorderinformation: 'Modify order information',
		Middlevalue: 'Middle value',
		Memberrechargeinstructions: 'Member recharge instructions',
		Mediumloyaltyandhighprice: 'Medium loyalty and high price',
		mark: 'Order mark',
		Malaysia: 'Malaysia',
		Machinelearningautomaticclassification: 'Machine learning automatic classification',
		loyalty: 'loyalty',
		lowvalue: 'low value',
		Lowconsumption: 'Low consumption',
		long: 'long',
		Logisticstype: 'Logistics type',
		Logisticsinformation: 'Logistics information',
		Logistics: 'Logistics',
		Linkcollection: 'Link collection',
		Limitationofclaims: 'Limitation of claims',
		Iwanttodistribute: 'I want to distribute',
		Islosinghighprices: 'Is losing high prices',
		Islosing: 'Is losing',
		Includequery: 'Include query',
		InClaimOrder: 'In Claim-Order',
		Inboundstatus: 'Inbound status',
		Inboundproductdetails: 'Inbound product details',
		Inboundordernumber: 'Inbound order number',
		Inboundordercreationtime: 'Inbound order creation time',
		Importproducts: 'Import products',
		Ihaveacted: 'I have acted',
		Icansupply: 'I can supply',
		Highvaluelost: 'High value lost',
		highvalue: 'high value',
		Highloyaltyandhighprice: 'High loyalty and high price',
		high: 'high',
		Hideorder: 'Hide order',
		GroupName: 'Group Name',
		Groupdescription: 'Group description',
		Giveaway: 'Giveaway',
		Giftlibrary: 'Gift library',
		Generatewarehousinglist: 'Generate warehousing list',
		Generalcargo: 'General cargo',
		Find: 'Find',
		Filtertoshoworhideorders: 'Filter to show or hide orders',
		Exportorder: 'Export order',
		Exportall: 'Export all',
		Export: 'Export Excel',
		Expiredate: 'Expire date',
		Expand: 'Expand/collapse',
		Estimatedtotalvolume: 'Estimated total volume',
		EstimatedCompensationPoints: 'Estimated Compensation Points',
		Edittemplate: 'Edit template',
		Editname: 'Edit name',
		edit: 'edit',
		edit: 'edit',
		Distributionwarehousemerchandise: 'Distribution warehouse merchandise',
		Distributionwarehouse: 'Distribution warehouse',
		Distributionselectionlibrary: 'Distribution selection library',
		Distributionplatform: 'Distribution platform',
		description: 'description',
		Deliverytime: 'Delivery time',
		Deliveryplace: 'Delivery place',
		DeliveryMethod: 'Delivery Method',
		Deleteselectedproductsinbulk: 'Delete selected products in bulk',
		CustomerProfile: 'Category',
		Custobuyergrouping: 'Custo buyer grouping',
		Currentlyselected: 'Currently selected',
		Currentlyonly: 'Currently only supports the collection of products on the shopee platform, please enter the link of the product detail page!',
		CreatList: '8 records',
		Creationtime: 'Creation time',
		Courierhasbeendelivered: 'Courier has been delivered',
		Courierhasbeencollected: 'Courier has been collected',
		Couriercollection: 'Courier collection',
		countryregion: 'country / region',
		container: 'container',
		contactseller: 'contact seller',
		Confirmthechanges: 'Confirm the changes',
		Confirmreceipt: 'Confirm receipt',
		Completetime: 'Complete time',
		completed: 'completed',
		complete: 'complete',
		Complaints: 'Complaints',
		Complaintorderstobeprocessedbythewarehouse: 'Complaint orders to be processed by the warehouse',
		Compensation: 'Compensation arrived in the account',
		Commoditystatus: 'Commodity status',
		Commoditycollection: 'Commodity collection',
		Combinatoriallibrary: 'Combinatorial library',
		Collapseall: 'Collapse all',
		Cloudblacklist: 'Cloud blacklist',
		Claimsuccessfultime: 'Claim successful time',
		ClaimAssistant: 'Claim Assistant',
		claim: 'Claim Assistant',
		Churn: 'Churn',
		Chooseawarehouse: 'Choose a warehouse',
		Chooseastore: 'Choose a store',
		checkorder: 'check order',
		Checkcompleted: 'Check completed',
		Changethetime: 'Change the time',
		CaringSMS: 'shut down',
		Cancelorder: 'Cancel order',
		Canceldetails: 'Cancel details',
		Buyerpurchasequantity: 'Buyer purchase quantity',
		Buyermessage: 'Buyer message',
		Buyerhasconfirmed: 'Buyer has confirmed',
		box: 'box',
		blacklist: 'blacklist',
		Bindingtime: 'Binding time',
		Batchsettingofflags: 'Batch setting of flags',
		Batchoperation: 'Batch operation',
		Batchexportorders: 'Batch export orders',
		Batchexportoforders: 'Batch export of orders',
		Barcode: 'Bar code',
		Averageconsumptiontimeinterval: 'Average consumption time interval',
		AuthorizeShop: 'View points deduction details',
		Audited: 'Audited',
		Applicationforcancellation: 'Application for cancellation',
		Amount: 'amount',
		Allsubskusinstorage: 'All sub-skus in storage',
		Allsites: 'All sites',
		Allsellers: 'All sellers',
		Allorders: 'All orders',
		AllLists: 'First trip cost',
		Allcountries: 'All countries',
		all: 'All',
		SellersAccount: 'sellerId',
		agree: 'agree',
		Afterrecharging: 'After recharging, you can immediately use overseas cloud warehouse, test product warehouse, private warehouse and other functions',
		Addnotes: 'Add notes',
		Additnow: 'Add it now',
		Addcustomgroup: 'Add custom group',
		Actualquantity: 'Actual quantity',
		Actualpickingquantity: 'Actual picking quantity',
		Actualarrivalquantityinwarehouse: 'Actual arrival quantity in warehouse',
		Activityprice: 'Activity price',
		Activityid: 'Activity id',
		Quantity: 'Quantity',
		invitecashback: 'Invite back',
		pointdetails: 'View points deduction details',
		Sellersname: 'Sellers name',
		SellersAccount: 'Seller account',
		boundtime: 'Binding time',
		Sellersname: 'Sellers name',
		orderSearch: 'Order number search',
		orthersSearch: 'Search product name，commodity sku',
		syncSingleOrder: 'Synchronize a single order number',
		urgent: 'Whether to remind',
		checkTime: 'Check time',
		orderPrinted: 'Single-sided printing',
		hasPrint: 'Printed,Reload the current page',
		returnReason: 'Fill in the reason for returning for review',
		jkf: 'Return immediately',
		scanArea: 'Order number or waybill number Scan area',
		scanProduct: 'Product barcode Scan area',
		returnReview: 'Return for review',
		resetorder: 'Reset order',
		resetPickingNum: 'Reset the picked quantity',
		checkDone: 'Check completed',
		purcahseNum: 'Purchase quantity',
		singleOrSetmeal: 'Single product or set meal',
		cusCode: 'CUSCODE/Bar code',
		sku: 'SKU',
		pickingNum: 'Quantity picked',
		retrunDesc: 'The reason for returning to review is required！',
		nodata: 'No order data！',
		descPicktip: 'Please confirm whether the quantity packing check has been completed？',
		outProduct: 'Outbound prompt',
		yes: 'Yes',
		cancel: 'Cancel',
		noorderdata: 'No order data！',
		comfirmCheck: 'Please confirm whether the quantity packing check has been completed？',
		fkuvkf: 'Outbound prompt',
		kvjjkf: 'completed',
		kvjfk: 'Check',
		vkjfhbvm: 'Please scan the order number first！',
		fikvnf: 'The quantity picked is the same as the quantity purchased by the buyer！',
		vkhlf: 'Check completed',
		systemNoorder: 'The system currently has no information about this order，please scan the correct order number！'
	},

	home: {
		title: 'shop/warehouse-Overview',
		allproduct: 'all products',
		inproduct: 'in warehouse',
		allshop: 'All shop-orders',
		sale: 'Sales',
		quantity: 'Sales volume',
		grossprofit: 'Gross Profit',
		grossmargin: 'Gross margin',
		allstorehuozhi: 'All warehouses-value',
		houzhi: 'Value',
		shipingcost: 'Transportation costs',
		allshopsales: 'Shop-Sales Status',
		allstoresales: 'Warehouse-Sales Status',
		shopname: 'Shop name',
		shopsales: 'Sales',
		shopquantity: 'Sales volume',
		cost: 'Cost',
		avg: 'Sales/day（AVG）',
		operate: 'Operate',
		linepic: 'Disconnect icon',
		tipdialog: 'Store sales stitching diagram',
		close: 'close',
		storename: 'Warehouse name',
		secondPwsTip: 'For financial privacy,please enter a second password',
		secondPws_Two: 'Initial Password',
		secondChange: 'Click to change ',
		secondPwsInput: 'Enter your second password',
		confirm: 'comfirm',
		tip1: '(Already deducted: actual delivery fee, expected delivery fee, platform transaction fee)',
		tip2: 'Deductible: purchase cost, first haul freight',
		tip3: 'Only warehouse spot purchase fee is included',
		tip4: 'Estimated cost = purchase cost + head haul freight + platform transaction fee',

	},
	header: {
		title: 'DiangXiaosheng Cross-border Management System',
		huanyinru: 'Welcome',

	},
	login: {
		system: 'Login Center',
		tip: 'A Southeast Asian freight forwarder that can increase your net profit',
		account: 'enter e-mail',
		passsword: 'enter password',
		remember_password: 'Remember password',
		login: 'Login',
		desc: 'Shopee-Focus on serving local sellers on Shopee/Lazada',
		desc1: 'Focus on Southeast Asia virtual service/cloud warehouse',
		desc2: 'Self-developed ERP docking Shopee/Lazada to manage precise inventory',
		desc3: 'Provide local customer service dispute resolution, negative review follow-up',
		desc4: 'Big data intelligent procurement forecast',
		desc5: 'Return a lot of goods, increase your net profit',
		th: 'Thailand',
		my: 'Malaysia',
		ph: 'Philippines',
		tw: 'Taiwan',
		sg: 'Singapore',
		vn: 'Vietnam',
		id: 'Indonesia',
		forget: 'forget password',
		registor: 'Click to register'
	},
	registor: {
		center: 'Register Center (Seller)',
		mail: 'enter e-mail',
		nickname: 'nickname',
		passsword: 'The password must be a combination of numbers, letters, and special characters',
		confirm_pws: 'confirm password',
		phone: 'For important notice or emergency contact',
		verification: 'E-mail verification code',
		getCode: 'Get verification code',
		register: 'register',
		log: 'click to log in',
		invitationCode: 'no invitation code, leave it blank'
	},
	stockProduct: {
		singlePro: 'Single',
		combo: 'Combo',
		gift: 'Gift',
	},
	aside: {
		Relevantquotation: 'Related Quotes',
		home: 'Home',
		transformStore: 'Stock Transfer',
		dianpusouquan: 'Authorize Shop',
		invitecashback: 'Invitation Prize',
		mysharePage: 'My Sharge-Page',
		myshareLink: 'My Sharge-Link',
		wodedingdang: 'Orders',
		allOrder: 'ALL Order',
		shenghedang: 'To Check',
		chulidang: 'To Process',
		sellerManagement: 'Seller management',
		zhuanchuandan: 'Inventry Transfer',
		yifahuodingdang: 'Shipped ',
		wentidang: 'Problem',
		rollover: 'Rollover',
		distribution: 'Distribution',
		localGoods: 'Local Source',
		mygoods: 'My Supply',
		hasAgent: 'My Agent',
		zhenzifuwu: 'Value-Add Services',
		prductDev: 'Product Dev',
		collectGoods: 'Collection',
		ProductPending: 'Product Verify',
		productMGM: 'Management',
		xiangshangchanpin: 'Ware-House',
		shengchengchangkuchanpin: 'Generate to Warehouse ',
		changkunchanpin: 'Warehouse Goods ',
		quanbuzhachanshanpin: 'allStore',
		rukuguangli: 'Warehousing list',
		kuchuguanli: ' Stock manage',
		godownentry: ' Stock receipt',
		processed: 'Processed',
		recharge: 'To Recharge',
		purchaseMGM: 'Purchase-MGM',
		yunweiguanli: 'Product activate',
		discountProducts: 'Discount products',
		claimAssistant: 'Claim Assistant',
		Management: 'Management',
		Performance_ranking: 'Performance ranking',
		Monitoring_Price: 'Monitoring Price',
		Customer_Service: 'Customer Service',
		Customer_Profile: 'Customer Profile',
		SmartChat: 'Smart Chat',
		CaringSMS: 'Caring SMS',
		Returned: 'Returned',
		CreatList: 'Creat List',
		AllLists: 'All Lists',
		fenjianhedui: 'Sub-Inspection',
		daibaochuku: 'Ex-warehouse',
		tuhuanguanli: 'Returns Management',
		ScanPrint: 'Scan Print',
	},

	storePending: {
		Form: 'From',
		UserName: 'User Name',
		shoptype: 'Shop',
		Warehouse_type: 'Warehouse type',
		Loading_status: 'Loading status',
		Printstatus: 'Print status',
		LogisticsType: 'Logistics type',
		orderMakr: 'Order mark',
		lastDeliveryTime: 'Last delivery time',
		orderStatus: 'Order status',
		exwarehouse: 'Ex-warehouse',
		orderInclude: 'Order includes',
		all: 'ALL',
		singlesku: 'Single SKU',
		multiplesku: 'Multiple SKUs ',
		shipped: 'shipped',
		tobeshipped: 'to be shipped',
		yes: 'Yes',
		notYet: 'Not yet',
		printed: 'printed',
		notprinted: 'not printed',
		notgenerated: "Not generated",
		Generated: 'Generated',
		loadign: 'loading',
		massArrangeShipment: 'Mass Arrange Shipment',
		drop_off: 'Mass Arrange Dropoff',
		pick_up: 'Mass Arrange Pickup',
		massprint: 'Mass Print Pick&Pack list',
		PrintPacklist: 'Print Packlist',
		PrintPicklist: 'Print Picklist',
		MassPrintShipingLabel: 'Mass Print Shiping Label',
		PrintShipingLabel: 'Print Shiping Label',
		ShipingLabel_Packlist: 'Print Shiping Label & Pack list',
		ReturnBacktoUser: 'Return Back to User',
		SynchronizeOrder: 'Synchronize Order',
		desc: '"First Pick And Then Pack",Can improve efficiency',
		fisrtStep: 'Step 1 Mass Arrange Shipment',
		secondStep: 'Step 2 Mass Print Picklist',
		threeStep: 'Step 3 Mass Print Shiping Label,Pack list',
		fourStep: 'Step 4 Sub-Inspection & Ex-warehouse',
		firstDesc: 'If you need the courier to collect, please choose Pick Up,If no, please choose Drop OFF.',
		secondDesc: 'Mass Print Picklist, First pick out the total quantity from shelf',
		threeDesc: 'Mass Print Shiping Label & Pack list to improve printing speed',
		fourDesc: 'Use  Sub-Inspection & Ex-warehouse, which can improve efficiency',
		Inventory: 'Inventory',
		Enough: 'Enough',
		noEnough: 'No Enough',
		pushTime: 'Push time',
		tenBefore: 'Today before 10:00 AM ',
		tenAfter: 'Today after 10:00 AM',
		specialOrder: 'Special order',
		norMall: 'Normal Order',
		enptry: 'Empty Gift'
	},
	shopaccess: {
		diangpusouquan: 'Shop authorization',
		bindshop: 'Bind shopee shop',
		bindshop_LAZADA: 'Bind LAZADA shop',
		bindstore: 'Bind store',
		shopId: 'shopId',
		shopName: 'shopName',
		shopSite: 'shopSite',
		shopStatus: 'status',
		accessTime: 'Authorization time',
		Expiredate: 'Expire date',
		operate: 'operate',
		storeID: 'storeID',
		userId: 'userId',
		userName: 'userName',
		storeName: 'storeName',
		createTime: 'createTime',
		storeAdresse: 'location',
		Untie: 'Untie Shop',
		UniteStore: 'Untie Store',
		UniteStoreSuccess: 'Unbind warehouse successfully！Please refresh the page',
		UniteShopSuccess: 'Unbind shop successfully！Please refresh the page',
		selectStore: 'Please select the warehouse to be bound',
		cancel: 'cancel',
		comfirm: 'ok',
		bangdinSuccess: 'Bind the warehouse successfully！Please refresh the page',
		enterStoreinfo: 'Enter the new warehouse information',
		enterUserName: 'serName',
		enterStoreName: 'StoreName',
		selected: 'Select a country',
		xinjian: 'New sub-warehouse',
		lazada_shortCode: 'SellerId',
		lazada_account: 'Account',
		lazada_name: 'Name',
		lazada_location: 'Location',
	},
	pendingorder: {
		title: 'Pending order',
		search: 'search',
		allcurrentpage: 'all current page',
		Mass_review_orders: 'Mass Distribute Order',
		synchronize: 'Update Lastest Orders ',
		last_3_days: 'last 3 days',
		last_7_days: 'last 7 days',
		last_1_month: 'last 1 month',
		last_3_month: 'last 3 month',
		orderSn: 'Order NO.',
		status: 'status',
		paytime: 'paytime',
		delivery_time: 'Late shippment time',
		sku: 'SKU',
		quantity: 'quantity',
		shopName: 'shopName',
		shopid: 'shopid',
		recipient: 'recipient',
		phone: 'phone',
		methods: 'methods',
		actually_paid: 'actually paid',
		waybill_number: 'waybill No',
		review: 'Distribute',
		search_tip: 'Query order number, consignee name, consignee phone',
		nodata: 'No-data',
		orderstotal: ' orders',
		select: "Please select shipping warehouse",
		cancel: "cancel",
		confirm: 'confirm',
		UNAUDIT: 'To check',
		cash_on_delivery: 'cash on delivery',
		pending_upgrade: 'pending upgrade',
		notgenerated: "Not generated",
		Mass_generate_waybill_number: "Mass generate waybill No",
		Mass_print_orders: "Mass print orders",
		Mass_print_picking_list: "Mass print picking list",
		synchronized: "The order has been synchronized to the latest state, please refresh the page after a while!",
		Successful_review: "Successful review！",
		day: 'day-',
		hours: 'hours-',
		min: 'min',
		time_order: 'Order time sort',
		Positive: 'Positive order of payment time',
		Reverse: 'Reverse payment time',
		Positive01: "Delivery time remaining in positive order",
		Reverse01: 'Reverse order of delivery remaining time',
		auto_distribute: 'Auto distribute',
		Inventory: 'Inventory',
		In_warehouse: 'Inwarehouse',
		committed: 'Committed',
		on_line: 'on line',
		Turn_on: 'Turn on/off the automatic order review function',
		Store_Name: 'shopName',
		warehouse: 'warehouse',
		un_include: 'Whether to exclude out of stock orders',
		yes: 'yes',
		no: 'no',
		auto_distribute: 'Auto distribute',
		open: 'Open',
		Turned_on: 'Turned on',
		shut_down: 'Shut down',
		confirm: 'Confirm',
		oop: 'In the order you selected, after filtering according to the actual inventory quantity of the warehouse and the urgency as of the delivery date:',
		llo: 'Approvable spot orders',
		ggo: 'ordersn',
		prick: 'Amount',
		hho: 'Deadline for shipping',
		pkl: 'Out of stock orders that are not recommended',
		uuo: 'Only through spot orders',
		iio: 'Continue to pass all',
		addpackingfee: 'Add packing fee',
		cancelTime: 'Cancel time'
	},
	unprocessedorder: {
		title: 'To be processed',
		search: 'search',
		allcurrentpage: 'all current page',
		Mass_review_orders: 'Mass review orders',
		synchronize: 'Update Lastest Orders ',
		last_3_days: 'last 3 days',
		last_7_days: 'last 7 days',
		last_1_month: 'last 1 month',
		orderSn: 'Order NO.',
		status: 'status',
		paytime: 'paytime',
		delivery_time: 'Late shippment time',
		sku: 'SKU',
		quantity: 'quantity',
		logistic: 'All logistics',
		shopName: 'shopName',
		shopid: 'shopid',
		recipient: 'recipient',
		phone: 'phone',
		all_store: 'All warehouse',
		Defaultprint: 'Default print',
		fastprint: 'Fast print',
		viewhistory: 'History print record',
		methods: 'methods',
		actually_paid: 'actually paid',
		waybill_number: 'waybill No',
		review: 'Review',
		search_tip: 'Query order number, consignee name, consignee phone',
		nodata: 'No-data',
		orderstotal: ' orders',
		select: "Please select shipping warehouse",
		cancel: "cancel",
		confirm: 'confirm',
		UNAUDIT: 'pending',
		cash_on_delivery: 'cash on delivery',
		pending_upgrade: 'pending upgrade',
		notgenerated: "Not generated",
		Mass_generate_waybill_number: "Mass generate waybill No",
		Mass_print_orders: "Mass print orders",
		Mass_print_picking_list: "Mass print picking list",
		pick_off: "Pick off ",
		drop_off: "Drop off ",
		allshops: 'All shops',
		allorders: 'ALL orders',
		tobegenerated: 'To generate',
		tobeprinted: 'To print',
		printed: "Printed",
		printed_time: 'printed time',
		print_order: 'Print order',
		print_picking_list: 'Print picking list',
		delivery_store: 'shipping store',
		todelivered: 'To be delivered',
		pingliancancelreview: 'Mass cancel review ',
		cancelreivew: 'The order has been successfully reset to pending review！',
		initTrickingNo: {
			createNO: 'Generating waybill number',
			main: 'Img',
			ordersn: 'ordersn',
			trickingNo: 'Waybill number',
			ttp01: 'completed',
			ttp02: 'ordersn',
			ttp03: 'Printed'

		},
		pingliandayin: 'Please select the order！',
		pingliandayin01: 'Please select the order under the same store to print！',
		haimeishenchendingdang: 'Please generate the waybill number before printing!！',
		searchContent: 'Enter search content',
		Export: 'Export xlsx',
		fenle: 'Product Sorting Picking'
	},
	shippedorder: {
		title: 'Shipped orders',
		search: 'search',
		allcurrentpage: 'all current page',
		Mass_review_orders: 'Mass review orders',
		synchronize: 'Update Lastest Orders',
		last_3_days: 'last 3 days',
		last_7_days: 'last 7 days',
		last_1_month: 'last 1 month',
		orderSn: 'Order NO.',
		status: 'status',
		paytime: 'paytime',
		delivery_time: 'delivery time',
		sku: 'SKU',
		all_store: 'All warehouse',
		quantity: 'quantity',
		shopName: 'shopName',
		shopid: 'shopid',
		recipient: 'recipient',
		phone: 'phone',
		methods: 'methods',
		actually_paid: 'actually paid',
		waybill_number: 'waybill No',
		review: 'Review',
		search_tip: 'Query order number, consignee name, consignee phone',
		nodata: 'No-data',
		orderstotal: ' orders',
		select: "Please select shipping warehouse",
		cancel: "cancel",
		confirm: 'confirm',
		UNAUDIT: 'pending',
		cash_on_delivery: 'cash on delivery',
		pending_upgrade: 'pending upgrade',
		notgenerated: "Not generated",
		Mass_generate_waybill_number: "Mass generate waybill No",
		Mass_print_orders: "Mass print orders",
		Mass_print_picking_list: "Mass print picking list",
		pick_off: "Pick off ",
		drop_off: "Drop off ",
		allshops: 'All shops',
		allorders: 'All orders',
		shipped: 'Shipped',
		pending_receipt: 'Pending receipt',
		confirm_receipt: "Confirm receipt",
		printed: "Printed",
		printed_time: 'printed time',
		print_order: 'Print order',
		print_picking_list: 'Print picking list',
		delivery_store: 'shipping store',
		todelivered: 'To be delivered',
		view_logistics: "View Logistics",


	},
	problemorder: {
		title: 'Problem order',
		tap_tuhuoguanli: 'Return management',
		tap_tuhuobaoguo: 'Return package',
		tap_maijiaqueren: 'Seller confirmed',
		tap_audited: 'Processed',
		tap_canceled: 'Cancelled',
		tap_return: 'Return order',
		tap_in_cancel: 'Apply for cancel',
		tap_in_cancel01: 'Applying',
		tap_alerdy_return: 'Returns accepted',
		tap_cancel_return: 'Cancel return',
		tap_in_return: 'Returning',
		tap_dispute: 'Seller dispute',
		tap_ruling: 'Ruling',
		tap_returned_money: 'Refunded',
		tap_close: 'Closed',
		tap_return_bysellser: 'To be Verify',
		tap_seller_comfirm: 'Seller confirmed',
		tap_processed: 'Processed',
		tap_delivery_failed: 'Delivery failed',
		tap_courier_loss: 'Courier loss',
		tap_delivery_timeout: 'Delivery timeout',
		tap_pay_timeout: 'Pay timeout',
		tap_seller_cancel: 'Buyer canceled',
		tap_others: 'Others',
		tap_ordered: 'Ordered（Not cancelable）',
		tap_nerver_order: 'Not played（Cancelable）',
		nodata: 'No data',
		return_trickNO: 'Return trickNO',
		original_order: 'Origin ordersn',
		return_order: 'Return ordersn',
		order_status: 'Status',
		cancel_time: 'cancel time',
		print_time: 'printing time',
		quantity: 'quantity',
		return_quantity: 'Return quantity',
		cancel_reason: 'Cancel reason',
		shop: 'Shop',
		receipent: 'Recipient',
		phone: 'Phone',
		return_reason: 'Return reason',
		seller_name: 'Buyer nickname',
		seller_Email: 'Buyer Eamil',
		deliver_store: 'Shipping From',
		delivery_method: 'Delivery Method',
		actuall_pay: 'Actually paid',
		trickNO: 'Waybill NO',
		return_count: 'Return amount',
		origin_prick: 'price before discount',
		buyer_delivery_deadline: 'Buyer delivery deadline',
		seller_processing_return_due: 'Seller processing returns due',
		view_logistics: "View Logistics",
		return_package: 'Return bag',
		confirmed_by_seller: 'confirmed by seller ',
		be_processed_by_store: 'processed by store',
		search_tip: 'Query order number',
		search: 'Search',
		no: 'No',
		price: 'price'

	},
	mygoods: {
		allShop: 'All shop',
		ppo: 'records',
		search: 'search',
		search_tip: 'Enter product name to search',
		synchronize: 'Synchronize shopee',
		Generate_warehouse_items: 'Generate to warehouse',
		itemID: 'itemID',
		shop: 'shop',
		price: 'price',
		stock: 'stock',
		cusCode: 'cusCode',
		sales: 'Total sales',
		status: 'Status',
		Whether_to_booking: 'Whether to booking',
		yes: 'Yes',
		no: 'No',
		more: 'More',
		viewOrder: 'view Orders',
		viewSales: 'view Sales',
		update: 'update',
		vieworder: 'View orders',
		viewsales: 'View sales',
		sku: 'sku',
		generated: 'have been generated',
		isTarget: 'has been selected',
		qingdang: {
			title: "Product list",
			Img: 'Img',
			name: 'Name',
			cost: 'Cost',
			operate: 'Operate',
			dele: 'Del',
			store: 'Receiving warehouse',
			qingkong: 'Empty',
			submit: 'Submit',
			choose: 'Choose warehouse...'
		},
		details: {
			title: "Warehouse list details",
			Img: 'Img',
			name: 'Name',
			SKU: 'SKU',
			cusCode: 'cusCode',
			ok: 'OK',
			success: 'Successfully entered the warehouse',
			fail: 'Entry failed (already in warehouse)',
		}
	},
	binditems: {
		allShop: 'All shop',
		ppo: 'records',
		search: 'search',
		search_tip: 'Enter product name to search',
		Generate_warehouse_items: 'Bound goods',
		itemID: 'Product ID',
		shop: 'shop',
		price: 'price',
		stock: 'stock',
		cusCode: 'cusCode',
		sales: 'sales',
		satus: 'satus',
		update: 'update',
		sku: 'sku',
		generated: 'Bound',
		bind: 'Bind',
		jieban: 'Untie',
		isTarget: 'Selected',
		bindDetexl: {
			title: "Commodity binding information",
			tip: 'Please enter cusCode',
			search: 'search',
			Img: 'Img',
			shopId: 'shopId',
			name: 'Name',
			SKU: 'SKU',
			dele: 'Del',
			operate: 'operate',
			qingkong: 'Empty',
			submit: 'Submit',
			cusCode: 'cusCode',
			store: 'warehouse'
		},
		details: {
			title: "Binding situation",
			Img: 'Img',
			name: 'Name',
			SKU: 'SKU',
			cusCode: 'cusCode',
			ok: 'OK',
			success: 'Bind successfully',
			fail: 'product has been bound',
		}
	},
	userStoreItems: {
		ok: 'OK',
		Prompt: 'Prompt',
		ppo: 'records',
		search: 'search',
		search_tip: 'Searchable warehouse code, sku, product name',
		synchronize: 'Synchronize lastest order QTY',
		Generate_warehouse_items: 'Generate warehousing list',
		stock_suggestion: 'Procurement forecast advice',
		allcurrentpage: 'all current page',
		mass_open_updata_stock: 'Mass open update in-stock',
		mass_close_updata_stock: 'Mass close update in-stock',
		shop: 'shopName',
		userName: 'userName',
		warehouse: 'warehouse',
		cost: 'cost',
		cusCode: 'cusCode',
		online_stock: 'Online Stock QTY',
		shipping_stock: 'ALL Waiting for shipment QTY',
		total_stock: 'Actual Stock On wearhouse',
		auto_update: 'Actual Stock Update Online ',
		all: 'all warehouse',
		on: 'ON',
		kki: 'Online stock of products binded will be updated to the actual stock on wearhouse all times .',
		off: 'OFF',
		caigoudangtip: 'Created successfully, the purchase order number is：',
		nodata: 'No products',
		confirmBtn: 'confirm',
		create_ruku: 'Create storage',
		selected: 'Selected',

		edit: 'Edit',
		binditems: 'Bind online',
		delet: 'Delete',
		caigou: {
			title: "Purchase Order",
			Img: 'Img',
			name: 'Name',
			caigouqunatity: 'Quantity',
			anthreName: 'Alias',
			operate: 'operate',
			dele: 'Del',
			tip: 'Please enter the remarks to the warehouse',
			qingkong: 'Empty',
			submit: 'Submit',
		},
		bindItem: {
			title: 'Bind product information',
			xinzhen: 'Bound goods',
			anthreName: 'Alias',
			shopName: 'shopName',
			operate: 'operate',
			jieban: 'Untie',
			tip: 'Warehouse products need to be bound to at least 1 online product, if you don’t need this product, you can directly delete the product in warehouse',
			jiebansuccess: 'Unbind successfully'
		},
		update: {
			tip: 'update reminder',
			open: 'Open',
			close: 'Close',
			close01: 'Close',
			open01: 'Open',
			text01: 'When the automatic update of the inventory in the warehouse is enabled, the shopee inventory of all products bound to the warehouse product will be automatically synchronized to the actual remaining inventory of the warehouse product. Please confirm whether you want to open it?',
			text02: 'Please select the products that need to close the automatic inventory update！',
			text03: 'When the automatic update of the inventory in the warehouse is turned off, the inventory of the products in the warehouse will not affect the shopee inventory of all the bound products. Please confirm whether to enable it?',
			text04: 'Please select the products that need to enable automatic inventory update!',
			text05: 'When the automatic update of inventory in the warehouse is enabled, the shopee inventory of all products bound to the warehouse product will be automatically synchronized to the actual remaining inventory of the warehouse product：',
			text06: '，Please confirm whether to turn it on?？',
			text07: 'When the automatic update of the inventory in the warehouse is turned off, the inventory of the products in the warehouse will not affect the shopee inventory of all the bound products. Please confirm whether to enable it?'
		},
		Quantitytobeshipped: 'Quantity to be shipped',
		long: 'long',
		width: 'width',
		height: 'height',
		weight: 'weight',
		more: 'more',
		vieworder: 'View order',
		viewsales: 'Check sales',
		viewstockstore: 'View inventory',
		del: 'delete',
		quehuo: 'stock reminder'
	},
	sellerpurchase: {
		All_warehouses: 'All warehouses',
		All_inbound_orders: 'All orders',
		Warehousing: 'Find the warehousing order',
		Find: 'Search',
		Create_warehouse_receipt: 'Create warehouse receipt',
		order_number: 'order-No',
		status: 'status',
		Creation_time: 'Estimated arrival',
		Warehouse: 'Warehouse',
		country: 'Total purchases',
		message: 'message',
		operating: 'operate',
		View_items: 'View',
		ship: 'shipingcost',
		infact_time: 'Actual arrival time',
		delete: 'Delete',
		wait_store_check: 'To be checked ',
		wait_check_in: 'To be confirmed ',
		aleady_check_in: 'Confirmed',
		comfirm: 'comfirm',
		cusCode: 'cusCode',
		name: 'Name',
		Purchase_quantity: 'Quantity',
		Purchase_information: 'Purchase information',
		rukudanghao: 'order-No',
		create_time: 'creation time',
		rukustore: 'Warehouse',
		sellerMessage: 'Seller Message',
		rukushuliangcomfirm: 'Quantity confirmation',
		confirm_time: 'confirmation time',
		rukustore: 'Warehouse',
		storeMessage: 'Warehouse Message',
		rukuNo: 'Quantity',
		actualNo: 'Actual',
		ok: 'Confirmed, the product has increased inventory',
		I_know: 'OK',
		warn: 'Prompt',
		sub: 'Submit to seller',
		tosellermsg: "a message to the seller",
		anthoeName: 'Alias',
		check: 'check'

	},
	lazada: {
		time: 'order time',
		total: 'total amount',
		paytotal: 'Payment amount',
		shippingfee: 'Courier fees',
		fahuoleixi: 'Delivery type',
		zuihoufahuo: 'late delivery time',
		shop: 'shop',
		shopid: 'shopID',
		paymenthod: 'pay method',
		receipt: 'Receiver',
		phone: 'phone',
		trickno: 'Waybill No',
		printTime: 'print time',
		choose: 'Choose logistics',
		generate: 'generate',
		pendinggenerate: 'Not generated'
	},
	orderPrint: {
		WarehouseType: 'Warehouse：',
		LoadingStatus: 'Status：',
		PrintStatus: 'Print Status：',
		LogisticsType: 'Logistics Type：',
		FinalDelivery: 'Final Delivery：',
		OrderStatus: 'Order Status：',
		OrderContains: 'Order Contains：',
		Searchquery: 'Search query：',
		Includequery: 'Include query：',
		exclude: 'Exclude',
		Precise: 'Precise',
		generatingWaybillNo: 'Mass generate waybill No',
		Default_printing: 'Default print',
		Ordertimeorder01: 'Sort by Order time (from early to late)',
		Ordertimeorder02: 'Sort by Order time (from late to early)',
		Sortbyquantity01: 'Sort by QTY(from most to least)',
		Sortbyquantity02: 'Sort by QTY(from least to most)',
		Sort_by_number_ofsku01: 'Sort by Sku QTY (from most to least)',
		Sort_by_number_ofsku02: 'Sort by Sku QTY(from least to most)',
		Sort_by_pushtime_early: 'Sort by Push time(From late  to early)',
		Sort_by_pushtime_late: 'Sort by Push time(From early to late)',

		MassSetPickupTime: 'Mass set pickup/drop off：',
		Unselect_current_page: 'Unselect current page',
		Select_current_page: 'Select current page',
		Order_is_scheduled: 'Current order is scheduled',
		all: 'All',
		Loaded: 'Loaded',
		not_loaded: 'Not loaded',
		Generated: 'Generated',
		Not_generated: 'To generate',
		Printed: 'Printed',
		To_print: 'To print',
		To_delivered: 'To delivered',
		Pickup_failed: 'Pickup failed',
		Multiple_SKU: 'Multiple SKU',
		Single_SKU: 'Single SKU',
		select_Order: 'Please select an order！',
		waybill_No: 'The system is generating the waybill number, please refresh the current page after a while！',
		Copy: 'Copy successfully',
		Order_sorting: 'Order sorting',
		Pickup_time: 'Pickup time',
		Order_scheduled: 'Current order is scheduled',
		Print_status: 'Print status',
		Packaged: 'Packaged',
		Unpackaged: 'Unpackaged',
		Order_printing: 'Order printing',
		Combine_print_orders: 'Combine print orders',
		Combined_print_picklist: 'Combined print pick list',
		Regenerate_order: 'Regenerate the face sheet',
		tip: 'The order is lost or the system reports an error, please regenerate the order and print it again!',
		Print_name: 'Print name',
		shop: 'store',
		latest_time: 'Print time-(latest time)',
		operare: 'operate',
		print_order: 'print order',
		Printed_order: 'Printed (order)',
		Print_picklist: 'Mass print pick list',
		Printed_picklist: 'Printed (pick list)',
		close: 'Close',
		Order_acquisition_status: 'Order acquisition status：',
		completed: 'Completed',
		order: 'order',
		total: 'total',
		tip02: ' Orders cannot be scheduled to this time',
		search_tip: 'enter the order number',
		search_tip02: "enter the product name, product Id, SKU",
		open01: 'Open multiple selection mode',
		open02: 'select all',
		already: 'Waybill NO has generated',
		default_second: 'Default Set the next day',
		store: 'Shop：',
		stock: 'Warehouse：'
	},


	remind: {
		header: 'Reminder function',
		remind_message: 'Turning on the smart reminder function will deduct the fee based on the amount of automatically sent text messages，SMS prices are charged according to different countries.',
		charge: '(International SMS Quotation：Malaysia 0.25 points/item，Thailand 0.15 points/item)',
		seller_back: 'Reminder settings',
		shopee: 'shopees shop',
		orderCare: 'Order care',
		record: "Usage record",
		paymentRemind: "Reminder",
		open: "Turn on",
		close: "Turn off",
		displayEchart: "Show results",
		totalSend: "Number of items sent",
		successRecive: "Number of successfully received",
		edit: "Edit template",
		remindType: "Reminder type",
		orderId: "order number",
		orderIdPlaceholder: "Please enter the order number",
		buyerName: "Buyer's name",
		buyerPlaceholder: "Find buyer's name",
		tableTypt: "Belonging to",
		tableChargeNum: "Billing number",
		integralCost: "Consumption points",
		status: "Delivery result",
		arriveTime: "delivery time",
		shipReminder: "Shipment reminder",
		signRemind: "Sign for reminder",
		displayEffect: "Show results",
		succseePayOrdersNum: "Number of successfully paid orders within",
		successSendMessage: "After sending a text message within",
		pleaseSelect: "please choose",
		lately: "recent",
		totalSend: "Sent together",
		strip: "strip",
		successRecive_: "Successfully received",
		successPayOrder: "Successfully paid the order",
		successPay: "payment successful",
		sendAndSuccessSendCount: "Number of SMS messages sent within and successfully sent",
		ifOnlyRemindCod: "Whether to remind COD orders only",
		orderId: "order number",
		buyerName: "Buyer's name",
		Type: "Belonging to",
		CountNum: "Billing number",
		CountIntegral: "Consumption points",
		deliveryResult: "Delivery result",
		arriveTime: "delivery time",
		acceptFail: "Receive failed",
		acceptSuccess: "Successfully received",
		sending: "sending",
		acceptOutTime: "Receive timeout",
		latelySendAndSuccessCount: "The number of recent text messages sent and the number of successful messages",
		sendMessageTotal: "Total number of text messages sent",
		sendSuccessCount: "Number of successful sending",
		successPayCount: "Number of successful payments",
		toData: "From now on",
		setCountOption_tip1: "before",
		setCountOption_tip2: "Sent within",
		setCountOption_tip3: "SMS, successfully sent",
		In: 'exist',
		seccessPay: 'Successfully paid within',
		order: "one",
		//remind_Template
		back: "return",
		currentTemplate: "Current SMS template",
		Bracket_tip: "(Order variables in brackets，the system will get it automatically)",
		currentSelectTemplate: "Currently selected template",
		testTemplate: "Test SMS template",
		sentTestMessage: "Send test SMS",
		systemTemplate: "System template",
		customTemplate: "Custom template",
		defaultLanguage_tip: "The initial default language is English",
		customTemplateLanguage_tip: "Custom templates do not support multi-language adaptation",
		saveSetting: "Save Settings",
		insertLabel: "Insert label",
		what_label: "What is a label",
		label_tip: "After inserting the label，xiangrong Technology will automatically fill in the corresponding order data or name in the label when the SMS is sent，Eliminates the need to manually edit each content。",
		haveInput: "Already entered",
		character: "character",
		countCharacterTip: "Too long buyer ID may result in multiple billing",
		limitLengthTip: "Limit SMS length to 536 characters",
		messageChargeTip: "International SMS Quotation：Malaysia 0.25 points/item，Thailand 0.15 points/item",
		messageCount: "Number of SMS",
		paymentRemind_tip1: "The buyer automatically sends a text message after 30 minutes without payment（Remind if the order amount is greater than $0 ）。",
		paymentRemind_tip2: "The same buyer can send up to 1 reminder on the same day。",
		paymentRemind_tip3: "The buyer has paid the order in our shop on the same day≥1，the reminder will be cancelled automatically。",
		shipRemind_tip1: "After the seller ships，automatically send SMS to notify buyers(Remind if the order amount is greater than $0 ）。",
		shipRemind_tip2: "If the courier has been signed for or has arrived in the buyer's city, it will not be sent",
		signRemind_tip1: "Within 72 hours of the buyer signing for the baby，automatically send SMS notifications to care（Do not send if the buyer has confirmed receipt）,remind if the order amount is greater than $0 。",
		sendCondition: "Sending conditions",
		chargeStandard: "Charges",
		addTemplate: "Add template",
		messageType: "SMS type",
		chargeCountStandard: "Billing number standard",
		messageType_tip1: "Does not contain special characters",
		messageType_tip2: "Characters/bar",
		templateChoose: "Template selection",
		testPhoneNum_tip: "Please enter the test phone number",
		English: "English",
		Chinese: "Chinese",
		My: "Malaysian",
		Th: "Thai",
		recipientName: "The recipient's name",
		OrderId: "Order number",
		shopName: "Store Name",
		purchaseDate: "Purchase date",
		selectTemplate: "Please select a template",
		failSaveTemplate: "Failed to save template",
		confirmButtonText: "determine",
		inputeContent: "Please enter content",
		addCustomFail: "Failed to add custom template",
		outLimit: "The character length of the custom SMS exceeds the limit",
		confirmDeleteCustom: "This action will delete the custom template, whether to continue?",
		tip: "point",
		cancel: "Cancel",
		successDelete: "successfully deleted",
		haveCancelDelete: "Undeleted",
		haveSendTestMessage: "Test SMS sent",
		failSendTestMessage: "Failed to send test SMS",
		phoneFormatErr: "The phone number format is wrong or the test template is not selected"
	},

	complaint: {
		complaintReasonTip1: "Please fill in the reason for appeal",
		complaintReasonTip2: "Please fill in the reason for the seller’s appeal(Required)",
		cancel: "Cancel",
		determine: "determine",
		close: "",
		complaintDetailTip: "Appeal details",
		sellerLeaveMessage: "Seller Message",
		sellerLeaveMessageTip: "Please fill in the seller's message(Required)",
		WarehouseLeaveMessage: "Warehouse message",
		WarehouseLeaveMessageTip: "Please fill in the message of the warehouse(Required)",
		PlatformLeaveMessage: "Platform message",
		PlatformLeaveMessageTip: "Please fill in the message of the platform(Required)",
		overseasWarehouseComplaints: "Overseas Warehouse Complaint Center",
		orderQuery: "Order lookup",
		orderQueryTip: "Enter order number to find",
		query: "Find",
		wareHouseHaveEx: "All outbound orders from the warehouse",
		sellerComplaint: "The seller complains about the order",
		haveFinish: "completed",
		orderId: "order number",
		orderStatus: "Order Status",
		orderPaid: "Order actually paid",
		warehouseHaveCompensation: "Warehouse paid",
		specificationName: "Specification name",
		number: "quantity",
		orderTime: "order time",
		payTime: "Payment time",
		printTime: "printing time",
		warehouseExTime: "Delivery time",
		deliveryTime: "Delivery time",
		storeName: "Store Name",
		deliveryMethod: "Delivery Method",
		WaybillNum: "Waybill number",
		PlatformType: "Platform type",
		sellerLeaveMessage: "Seller Message",
		complaintCompensate: "Complaints",
		waitWarehouseConfirm: "To be confirmed by the warehouse",
		waitPlatformType: "To be processed by the platform",
		haveCompensation: "Paid",
		integral: "integral",
		viewDetail: "see details",
		confirmTip: "The order has filed a complaint to the warehouse，Waiting for warehouse processing！",

	},

	remind: {
		header: 'Reminder function',
		remind_message: 'Turning on the smart reminder function will deduct the fee based on the amount of automatically sent text messages，SMS prices are charged according to different countries.',
		charge: '(International SMS Quotation：Malaysia 0.25 points/item，Thailand 0.15 points/item)',
		seller_back: 'Reminder settings',
		shopee: 'shopees shop',
		orderCare: 'Order care',
		record: "Usage record",
		paymentRemind: "Reminder",
		open: "Turn on",
		close: "Turn off",
		displayEchart: "Show results",
		totalSend: "Number of items sent",
		successRecive: "Number of successfully received",
		edit: "Edit template",
		remindType: "Reminder type",
		orderId: "order number",
		orderIdPlaceholder: "Please enter the order number",
		buyerName: "Buyer's name",
		buyerPlaceholder: "Find buyer's name",
		tableTypt: "Belonging to",
		tableChargeNum: "Billing number",
		integralCost: "Consumption points",
		status: "Delivery result",
		arriveTime: "delivery time",
		shipReminder: "Shipment reminder",
		signRemind: "Sign for reminder",
		displayEffect: "Show results",
		succseePayOrdersNum: "Number of successfully paid orders within",
		successSendMessage: "After sending a text message within",
		pleaseSelect: "please choose",
		lately: "recent",
		totalSend: "Sent together",
		strip: "strip",
		successRecive_: "Successfully received",
		successPayOrder: "Successfully paid the order",
		successPay: "payment successful",
		sendAndSuccessSendCount: "Number of SMS messages sent within and successfully sent",
		ifOnlyRemindCod: "Whether to remind COD orders only",
		orderId: "order number",
		buyerName: "Buyer's name",
		Type: "Belonging to",
		CountNum: "Billing number",
		CountIntegral: "Consumption points",
		deliveryResult: "Delivery result",
		arriveTime: "delivery time",
		acceptFail: "Receive failed",
		acceptSuccess: "Successfully received",
		sending: "sending",
		acceptOutTime: "Receive timeout",
		latelySendAndSuccessCount: "The number of recent text messages sent and the number of successful messages",
		sendMessageTotal: "Total number of text messages sent",
		sendSuccessCount: "Number of successful sending",
		successPayCount: "Number of successful payments",
		toData: "From now on",
		setCountOption_tip1: "before",
		setCountOption_tip2: "Sent within",
		setCountOption_tip3: "SMS, successfully sent",
		In: 'exist',
		seccessPay: 'Successfully paid within',
		order: "one",
		back: "return",
		currentTemplate: "Current SMS template",
		Bracket_tip: "(Order variables in brackets，the system will get it automatically)",
		currentSelectTemplate: "Currently selected template",
		testTemplate: "Test SMS template",
		sentTestMessage: "Send test SMS",
		systemTemplate: "System template",
		customTemplate: "Custom template",
		defaultLanguage_tip: "The initial default language is English",
		customTemplateLanguage_tip: "Custom templates do not support multi-language adaptation",
		saveSetting: "Save Settings",
		insertLabel: "Insert label",
		what_label: "What is a label",
		label_tip: "After inserting the label，xiangrong Technology will automatically fill in the corresponding order data or name in the label when the SMS is sent，Eliminates the need to manually edit each content。",
		haveInput: "Already entered",
		character: "character",
		countCharacterTip: "Too long buyer ID may result in multiple billing",
		limitLengthTip: "Limit SMS length to 536 characters",
		messageChargeTip: "International SMS Quotation：Malaysia 0.25 points/item，Thailand 0.15 points/item",
		messageCount: "Number of SMS",
		paymentRemind_tip1: "The buyer automatically sends a text message after 30 minutes without payment（Remind if the order amount is greater than $0 ）。",
		paymentRemind_tip2: "The same buyer can send up to 1 reminder on the same day。",
		paymentRemind_tip3: "The buyer has paid the order in our shop on the same day≥1，the reminder will be cancelled automatically。",
		shipRemind_tip1: "After the seller ships，automatically send SMS to notify buyers(Remind if the order amount is greater than $0 ）。",
		shipRemind_tip2: "If the courier has been signed for or has arrived in the buyer's city, it will not be sent",
		signRemind_tip1: "Within 72 hours of the buyer signing for the baby，automatically send SMS notifications to care（Do not send if the buyer has confirmed receipt）,remind if the order amount is greater than $0 。",
		sendCondition: "Sending conditions",
		chargeStandard: "Charges",
		addTemplate: "Add template",
		messageType: "SMS type",
		chargeCountStandard: "Billing number standard",
		messageType_tip1: "Does not contain special characters",
		messageType_tip2: "Characters/bar",
		templateChoose: "Template selection",
		testPhoneNum_tip: "Please enter the test phone number",
		English: "English",
		Chinese: "Chinese",
		My: "Malaysian",
		Th: "Thai",
		recipientName: "The recipient's name",
		OrderId: "Order number",
		shopName: "Store Name",
		purchaseDate: "Purchase date",
		selectTemplate: "Please select a template",
		failSaveTemplate: "Failed to save template",
		confirmButtonText: "determine",
		inputeContent: "Please enter content",
		addCustomFail: "Failed to add custom template",
		outLimit: "The character length of the custom SMS exceeds the limit",
		confirmDeleteCustom: "This action will delete the custom template, whether to continue?",
		tip: "point",
		cancel: "Cancel",
		successDelete: "successfully deleted",
		haveCancelDelete: "Undeleted",
		haveSendTestMessage: "Test SMS sent",
		failSendTestMessage: "Failed to send test SMS",
		phoneFormatErr: "The phone number format is wrong or the test template is not selected"
	},


	distribution: {
		//erp系统中的分销平台三个页面
		// Community
		shipmentPlace: "Delivery place",
		generateH5: "Generate h5 share page",
		searchStore: "Search warehouse code，sku，product name",
		mSKU: "Mother sku",
		price: "price",
		oneOffer: "One drop price",
		stockNum: "Spot inventory",
		haveDistribution: "I have distributed",
		havenDistribution: "I want to distribute",
		//Tab
		distributionProduct: "Distribution warehouse products",
		distributionLibrary_tab: "Distribution selection library",
		distributionHaveSupply_tab: "I can supply",
		distributionHaveAgent: "I have acted",
		//hasAgent
		stockType: "Warehouse type",
		selectAll: "Select all current page",
		operationBatch: "Batch operation",
		operationBatchDelete: "Delete selected products in bulk",
		sSKUNum: "Number of sub-sku",
		totalStock: "Total inventory",
		releaseProduct: "product release",
		updateItemTip1: "The products in the current distribution warehouse have not yet been bound to the template information，please bind a product before publishing！",
		updateItemTip3: "Go to template management binding",
		cancel: "Cancel",
		tip: "point",
		determine: "determine",
		confirmDelete: "Please confirm that you want to delete the selected product？",
		deleteSuccess: "successfully deleted",
		//myselfproduct
		distributionH5Link: "Distributed product h5 invitation page link",
		copy: "copy",
		deleteFileTip: "Delete failure prompt！",
		failReason: "Reason for failure",
		nowSelect: "Currently selected",
		importProducts: "Import products",
		havenProduct: "Currently no products",
		offshelfdistribution: "Off-shelf distribution",
		Onshelfdistribution: "Shelf distribution",
		confirmOffshelf: "Are you sure to remove the product?？",
		confirmOnshelf: "Are you sure to list the product to the distribution selection library?？",
		successOnshelf: "Successfully put on the shelves distributed！",
		successOffShelf: "Successfully sold off the shelf！",
		successCopy: "Copy successfully"
	},

	h5: {
		verification: 'verification code',
		phone: 'phone',
		login: 'Login',
		send: 'send',
		phoneDesc: 'enter your phone number',
		passWordeDesc: 'enter your verification code',
		DSX_index_note: 'Not logged in yet!',
		DSX_index_log: 'Login in',
		DSX: 'ShopsBu',
		DSX_title: 'Drop shipping from local warehourse',
		DSX_qty: 'Quantity',
		DSX_dropship: 'Drop Shipping',
		DSX_specification: 'Specification',
		DSX_price: 'Wholesale Price',
		DSX_qty1: 'QTY On Stock',
		DSX_des: 'Product Description',
		DSX_details: 'Product Details',
		DSX_index_slogn: 'Drop shipping Hot Products',
		DSX_index_recommendation: 'Recommend',
		DSX_index_th: 'Thailand',
		DSX_index_my: 'Malaysia',
		DSX_index_ph: 'Philippines',
		DSX_index_tw: 'Taiwan',
		DSX_index_id: 'Indonesia',
		DSX_index_vn: 'Vietnam',
		DSX_index_bz: 'Brazil',
		DSX_index_cn: 'China',
		DSX_index_price: 'Wholesale Price',
		DSX_index_profit: 'Profit',
		DSX_index_qty: 'Quantity',
		DSX_index_country: 'From Malaysia',
		DSX_index_sample: 'Get Sample',
		DSX_index_dropship: 'Drop Shipping',
		DSX_index_welcome: 'welcome',
		DSX_index_signout: 'signOut',
		DSX_index_back: 'Back',
		DSX_index_Quote: 'Get Quote',
		DSX_index_detail: 'Product Detail',
		DSX_index_distribute: 'Drop Shipping',
		DSX_index_tips: 'The product has been successfully distributed to your store shopsbu account. If you want to release the product to TIKTOK/Shopee/Lazada platform, please go to the erp.shopsbu.com PC side: I have been the agent, continue to operate!',

	},

	other: {
		a1: 'Image failed to load...',
		a2: 'Image loading...',
		a3: 'Contact customer service',
		a4: 'Overseas Warehouse Customer Service',
		a5: 'Close',
		a6: 'Click to download the plug-in CRX installation package',
		a7: 'Plugin introduction',
		a8: 'Bei Analysis is an operation tool specially provided for Shopee sellers, which can help Shopee sellers efficiently select products and analyze product data. Applicable to Shopee Thailand, Malaysia, Indonesia, Vietnam and other eight sites, you can experience it with confidence. It can display the following relevant data on any Shopee product detail page',
		a9: '①Product launch date; sales/sales/visitors/conversion index; suspicion of fraud.',
		a10: '②Real-time monitoring of products on Shopee, search for the same source of goods, competing products of the same model, etc.',
		a11: 'Instructions for use：',
		a12: 'Click to view: industry recommendation/search recommendation/store recommendation three usage scenarios',
		a13: 'Installation Guide',
		a14: 'Method 1: After decompressing the downloaded file, put it on the recommended computer desktop for easy operation. The operation steps are as follows:',
		a15: 'Open Google Chrome --> Find the upper right corner...> Then click Open to find "More Tools" --> Then find "Extensions" --> Turn on the developer mode --> Copy the .CRX of the desktop Drag and drop the file directly to the interface in developer mode, and the installation can be completed! ',
		a16: 'Method 2: After going online scientifically,',
		a17: 'Click on the link',
		a18: 'Go to Google Mall to install directly:',
		a19: 'Scan code to download Android distribution platform APP',
		a20: 'Seller App (Android)',
		a21: 'Warehouse App (Android)',
		a22: 'warm reminder',
		a23: 'Seller-side APP: can realize review order/return management and Shopee multi-store chat, including automatic translation, automatic reply, multi-store switching, etc.',
		a24: 'Warehouse-side APP: with PDA or Bluetooth scanner, it can realize order sorting and inspection, scanning out of the warehouse, return and exchange scanning, etc.',
		a25: 'Print history',
		a26: 'Order number search',
		a27: 'Search',
		a28: 'Merge print',
		a29: 'Select',
		a30: 'Name',
		a31: 'Print time - (latest time)',
		a32: 'Print times',
		a33: 'Operation',
		a34: 'View',
		a35: 'Add a waybill number',
		a36: 'Please enter the waybill number to be added:',
		a37: 'Please enter the waybill number',
		a38: 'Confirm',
		a39: 'Acceptance of packaged goods',
		a40: 'Please confirm the waybill number of the goods received:',
		a41: 'Please select the waybill number',
		a42: 'Recharge details',
		a43: 'Search by transaction time',
		a44: 'Search by payment time',
		a45: 'Start date',
		a46: 'End date',
		a47: 'To',
		a48: 'Payment method:',
		a49: 'Payment status:',
		a50: 'Please choose',
		a51: 'Sort:',
		a52: 'Order',
		a53: 'Payment order number',
		a54: 'Points',
		a55: 'Status',
		a56: 'Payment method',
		a57: 'Creation time',
		a58: 'Point deduction details',
		a59: 'Transaction type',
		a60: 'Order number',
		a61: 'Trading time',
		a62: 'Remaining points',
		a63: 'Product classification picking',
		a64: 'Order sort',
		a65: 'Search product name, SKU',
		a66: 'Picture',
		a67: 'Warehouse code',
		a68: 'Commodity ID',
		a69: 'Store ID',
		a70: 'Store filter:',
		a71: 'Return reason screening:',
		a72: 'Export Excel',
		a73: 'Export all',
		a74: 'All claims',
		a75: 'After exporting Excel and submitting to the platform customer service, you can click the start claim button to list this order as pending claim status to avoid confusion with the new lost package order',
		a76: 'Reason for return',
		a77: 'Amount',
		a78: 'Update time',
		a79: 'Claim success time',
		a80: 'Remaining claim validity time',
		a81: 'Start Claim',
		a82: 'View Logistics',
		a83: 'To be contacted platform customer service',
		a84: 'Claim successful',
		a85: 'Logistics information',
		a86: 'Waybill number:',
		a87: 'Order number:',
		a88: 'Current status:',
		a89: 'Time',
		a90: 'Logistics details',
		a91: 'Fill in the receiving information',
		a92: 'Cargo type:',
		a93: 'Modify',
		a94: 'Length:',
		a95: 'Fill in the length of the item',
		a96: 'Width:',
		a97: 'Fill in the width of the item',
		a98: 'Height:',
		a99: 'Fill in the height of the item',
		a100: 'Weight:',
		a101: 'Fill in the weight of the item',
		a102: 'Click to upload picture',
		a103: 'Only jpg/png files can be uploaded, and no more than 500kb',
		a104: 'Warm reminder',
		a105: 'It is recommended to export the current orders to be claimed to an excel sheet for data storage before making all claims. After confirmation, the data will enter the list of orders under claim! ',
		a106: 'Cancel',
		a107: 'Confirm to start claim',
		a108: 'Reload order',
		a109: 'Select store:',
		a110: 'Fill in the order:',
		a111: 'Fill in the order number',
		a112: 'Load now',
		a113: 'All',
		a114: 'Package lost',
		a115: 'Delivery failed',
		a116: 'WeChat payment',
		a117: 'Alipay',
		a118: 'Unpaid',
		a119: 'Completed',
		a120: 'Closed',
		a121: 'Used',
		a122: 'According to points - from more to less',
		a123: 'According to points - from less to more',
		a124: 'Order generation time - from early to late',
		a125: 'Order generation time - from late to early',
		a126: 'According to the purchase quantity - from more to less',
		a127: 'According to the purchase quantity - from less to more',
		a128: 'According to SKU-from less to more',
		a129: 'Purchase by SKU-from more to less',
		a130: 'Recent week',
		a131: 'Recent month',
		a132: 'The last three months',
		a133: 'Claim to be confirmed',
		a134: 'To be claimed',
		a135: 'The claim has been successful',
		a136: 'Distribution platform customer service',
		a137: 'Recharge',
		a138: 'Consumption',
		a139: 'Logistics problem',
		a140: 'None',
		a141: 'Executing this operation will give up the claim for this order, confirm to give up the claim? ',
		a142: 'Prompt',
		a143: 'Please fill in the receipt information as required',
		a144: 'Executing this operation will give up the claim for this order, confirm to give up the claim? ',
		a145: 'OK',
		a146: 'Cancel',
		a147: 'Unpaid',
		a148: 'Paid',
		a149: 'WeChat',
		a150: 'Please check the product',
		a151: 'Currently there is no claimable order! ',
		a152: 'Please select an order',
		a153: 'Bei analysis data board plug-in',
		a154: 'Select payment method',
		a155: 'Payment QR code loading failed',
		a156: 'Payment amount:',
		a157: 'Yuan',
		a158: 'Please use Alipay - scan code to pay',
		a159: 'Please use WeChat - scan code to pay',
		a160: 'Give up payment',
		a161: 'Payment completed',
		a162: 'Sales status',
		a163: 'Inventory turnover:',
		a164: 'Replenishment cycle:',
		a165: 'Enter replenishment period (pure number)',
		a166: 'Confirm modification',
		a167: 'Deduction of in-transit inventory',
		a168: 'Recommended purchase number',
		a169: 'Existing Quantity',
		a170: 'Quantity in transit',
		a171: 'Average sales/day',
		a172: 'Replenishment cycle',
		a173: 'Estimated sales in 7 days',
		a174: 'Estimated sales in 14 days',
		a175: 'Estimated sales in 30 days',
		a176: 'Remaining days available for sale',
		a177: 'Day',
		a178: 'Create purchase order',
		a179: 'Product name',
		a180: 'Inventory turnover',
		a181: 'Recent outbound time',
		a182: 'Store sales status',
		a183: 'Export',
		a184: 'Order attribution',
		a185: 'Agent order',
		a186: 'Self-built order',
		a187: 'Seller order',
		a188: 'Commodity binding',
		a189: 'Add commodity binding',
		a190: 'Pre-sale products',
		a191: 'Yes',
		a192: 'No',
		a193: 'Untie',
		a194: 'All orders belong',
		a195: 'All types',
		a196: 'System initialization',
		a197: 'Order outbound deduction or re-shelf',
		a198: 'Increase the storage order',
		a199: 'Verification of transfer receipt',
		a200: 'Inventory transfer',
		a201: 'Warehouse modification',
		a202: 'Out of stock reminder',
		a203: 'Slow sales reminder',
		a204: 'Sales Quantity',
		a205: 'Sales',
		a206: 'Time',
		a207: 'Sales',
		a208: 'Out of stock reminder--',
		a209: 'Confirm unbinding?',
		a210: 'Unbind successfully! ',
		a211: 'Please select a product',
		a212: 'One month ago',
		a213: 'Price control management',
		a214: 'Set control price',
		a215: 'Set quantity',
		a216: 'Save',
		a217: 'Property map',
		a218: 'Sku name',
		a219: 'Supply price',
		a220: 'Wholesale price',
		a221: 'Lower limit of distribution price control',
		a222: 'Set the lower limit of the sales price of the products on the shelves of the agent',
		a223: 'Agent information',
		a224: 'Agency:',
		a225: 'Account:',
		a226: 'Warehouse code:',
		a227: 'Number of stores on shelves:',
		a228: 'Online discount price',
		a229: 'Remove agent products',
		a230: 'Please enter the number of agents (when -1 means unlimited)',
		a231: 'Success! ',
		a232: 'Successfully submitted! ',
		a233: 'Confirm that you want to forcibly remove the distributor:',
		a234: 'The product? ',
		a235: 'Yes',
		a236: 'Removed successfully! ',
		a237: 'Agency',
		a238: 'Edit',
		a239: 'Save update',
		a240: "The lower limit of the online selling price of the agent's shelf distribution",
		a241: 'Modify order information',
		a242: 'Is it a single product:',
		a243: 'Warehouse selection:',
		a244: 'Enter the search character',
		a245: 'Find',
		a246: 'Selected:',
		a247: 'There are no warehouse products',
		a248: 'Warehouse:',
		a249: 'Mother sku:',
		a250: 'Store in warehouse:',
		a251: 'Single product',
		a252: 'Package',
		a253: 'Ordinary product',
		a254: 'Distributed products',
		a255: 'Search by product name',
		a256: 'Search by warehouse code',
		a257: 'Search by product sku',
		a258: 'The system has detected a warehouse that you have not activated, please go to the store to authorize and enable the warehouse you need! ',
		a259: 'The current account has no account associated with the warehouse! ',
		a260: 'No description yet',
		a261: 'Set the pricing formula of the retail price',
		a262: 'Exchange rate: the exchange rate of RMB to local currency, such as 1rmb=5.19 baht, that is: 0.192 exchange rate',
		a263: 'Discount: if it is a 40% off product, that is: 40 off',
		a264: 'Exit fee: different countries have different prices',
		a265: 'New calculation formula',
		a266: 'Formula',
		a267: 'Outbound fee rmb',
		a268: 'Exchange rate',
		a269: 'Region',
		a270: 'Profit rate%',
		a271: 'Discount',
		a272: 'Set default',
		a273: 'Delete',
		a274: 'Confirm',
		a275: 'Replace the main picture from the shopee link',
		a276: "Please enter the url of shopee's product details page link",
		a277: 'Please wait while loading image resources. . . ',
		a278: 'Loading complete! ',
		a279: 'OK',
		a280: 'Upload property image',
		a281: 'Only upload jpg files, and no more than 10M',
		a282: 'Commodity filling suggestion',
		a283: '1. The number of characters in the product title is greater than 20 but less than 120',
		a284: '2.Sku length does not exceed 20 characters',
		a285: 'Release product',
		a286: 'Modify category',
		a287: '1 Basic information',
		a288: 'Publish store',
		a289: 'Product main image',
		a290: 'Randomly sort pictures',
		a291: 'Add image watermark',
		a292: 'Replace pictures from shopee link',
		a293: 'Maximum 8 jpg/png files can be uploaded, and no more than 10M',
		a294: 'Upload picture',
		a295: 'Product title',
		a296: 'The number of title characters should be controlled between 20 and 120',
		a297: 'Commodity attribute',
		a298: 'Please enter',
		a299: '2 Specification stock',
		a300: 'Retail price calculation: (supply price',
		a301: 'Gross profit margin',
		a302: 'Discount',
		a303: 'Automatic calculation of retail price formula',
		a304: 'Batch Assistant',
		a305: 'Delete the same characters of sku in batches',
		a306: 'Price inventory',
		a307: 'Batch settings',
		a308: 'The character length is within 5~20',
		a309: 'Retail price (local currency)',
		a310: 'Stock',
		a311: 'Bound cusCode',
		a312: 'Delete',
		a313: 'Package specification',
		a314: 'Weight (kg):',
		a315: 'Volume (cm):',
		a316: 'Logistics type:',
		a317: 'Delivery warehouse:',
		a318: 'Commodity description',
		a319: 'Please enter content',
		a320: 'Immediately release the product',
		a321: 'Publish shopee products',
		a322: 'Publish TikTok Shop products',
		a323: 'Please add product attribute pictures before publishing',
		a324: 'This product agent is abnormal, please re-agent, and then release it on the shelves',
		a325: "Please go to the background of TIKTOK to set up a delivery warehouse. If you don't know the address of the delivery warehouse, please contact Xiaosheng customer service",
		a326: 'The product has been successfully listed on TikTok Shop',
		a327: 'Please fill in the retail price!',
		a328: 'The product is abnormal, please re-agent or contact the platform customer service to deal with it! ',
		a329: 'Product sku cannot be empty',
		a330: 'Weight and volume cannot be empty! ',
		a331: 'The main picture of the product cannot exceed 8 pictures',
		a332: 'Please upload the .xlsx file below 2M',
		a333: 'The size of the uploaded avatar picture cannot exceed 10MB!',
		a334: 'Sales attribute',
		a335: 'Specification',
		a336: 'Publish Lazada products',
		a337: 'Please fill in the retail price',
		a338: 'The maximum number of main images cannot exceed 8! ',
		a339: 'Homepage',
		a340: 'I Have been represented',
		a341: 'Personal Center',
		a342: 'Print',
		a343: 'Export PDF',
		a344: 'Total number of boxes:',
		a345: 'Box',
		a346: 'Paper specification:',
		a347: 'Paper width:',
		a348: 'Paper height:',
		a349: 'MM',
		a350: 'Thermal paper',
		a351: 'Custom',
		a352: 'Product barcode',
		a353: 'My file',
		a354: 'Nothing',
		a355: 'Warehouse parent sku:',
		a356: 'Warehouse sub-sku:',
		a357: 'Position:',
		a358: 'All',
		a359: 'Select store',
		a360: 'Commodity status',
		a361: 'Expand the remaining stores',
		a362: 'Current and:',
		a363: 'In session',
		a364: 'Session list',
		a365: 'Read',
		a366: 'This message is a voice message, please log in to the APP to view',
		a367: 'Unread',
		a368: 'Click to upload',
		a369: 'Send',
		a370: 'The sent content cannot be empty! ',
		a371: 'Websock connection succeeded',
		a372: 'Websock connection failed',
		a373: 'Please select a product specification',
		a374: 'Dian Xiaosheng Distribution Mall',
		a375: 'Shopping cart',
		a376: 'All products (0)',
		a377: 'Selected product',
		a378: 'Select all',
		a379: 'Commodity information',
		a380: 'Unit price',
		a381: 'Quantity',
		a382: 'Authorization successful! ',
		a383: 'Error prompt',
		a384: 'Sorry, the Xiaosheng page you visited does not exist! ',
		a385: "Click here to return to Xiaosheng's homepage!",
		a386: 'Store selection:',
		a387: 'Loading order',
		a388: 'Enable multi-selection mode',
		a389: 'Reload the current page',
		a390: 'Batch setting mark',
		a391: 'None',
		a392: 'Getting data...',
		a393: 'Data loading...',
		a394: 'Registration Center',
		a395: 'Mobile phone number:',
		a396: 'User password:',
		a397: 'Confirm password:',
		a398: 'Verification code:',
		a399: 'Mobile phone number',
		a400: 'User password',
		a401: 'Verification code',
		a402: 'Get Verification Code',
		a403: 'Register now',
		a404: 'Already have an account, please go to the PC to log in! ',
		a405: 'Buy the gift package now',
		a406: 'Shop Xiaosheng',
		a407: 'Provide cross-border localization of overseas warehouse and distribution solutions',
		a408: 'Focus on small and medium parts of the United States/Southeast Asia localization services',
		a409: '① To provide local exclusive new strange supply in the United States, can be customized flexible production, a batch.',
		a410: '② Provide overseas warehouse services in the United States, specializing in small and medium-sized pieces (clothing, home, mobile phone shells, etc.).',
		a411: '③ It can support sellers to build their own family warehouse/overseas warehouse, and provide ERP/WMS pure system services.',
		a412: 'Precise inventory synchronization',
		a413: '99.99% Inventory accuracy rate, bind online inventory in multiple stores, and prevent oversold points from being deducted',
		a414: 'Claim Assistant',
		a415: 'Sellers promptly discover orders that are rejected by COD or lost in express delivery, so that sellers can claim compensation from the platform in a timely manner, recover losses, and increase your net profit! ',
		a416: 'Distribution platform',
		a417: 'Southeast Asian local spot, one piece of distribution on the shelves, accurate inventory, association binding, to prevent overselling',
		a418: 'Chat with Shopee',
		a419: 'Thai, Vietnamese, Indonesian, Malay, English automatic translation, automatic reply, multi-store switching, quick reply',
		a420: 'Welcome to log in to Xiaosheng',
		a421: 'Account login',
		a422: 'Register account',
		a423: 'Enter user account',
		a424: 'Enter user password',
		a425: 'account:',
		a426: 'password:',
		a427: 'Number area:',
		a428: 'Register account:',
		a429: 'Enter mobile phone number or email',
		a430: 'User nickname',
		a431: 'Confirm password',
		a432: 'Please enter the verification code',
		a433: 'Required field, if not available, please contact customer service',
		a434: 'Invitation code',
		a435: 'Register now',
		a436: 'Click to send verification code',
		a437: 'Please enter the account number or password! ',
		a438: 'Please enter the mobile phone number',
		a439: 'The account balance is insufficient',
		a440: 'The verification code was sent successfully, please pay attention to check it! ',
		a441: 'Please enter your email address to get a verification code! ',
		a442: 'Please fill in the user account! ',
		a443: "Please fill in the user's password! ",
		a444: 'Please fill in the verification code! ',
		a445: 'The passwords entered twice are inconsistent, please reconfirm the passwords! ',
		a446: 'Successful registration',
		a447: "Please fill in the user's nickname! ",
		a448: 'Please fill in the correct account password! ',
		a449: 'Successful login, jumping to the homepage',
		a450: '③ERP supports automatic synchronization of inventory of the same item on different platforms of Shopee/Lazade to prevent overselling! ',
		a451: 'Login center',
		a452: 'Please enter your mobile phone number to get a verification code! ',
		a453: 'Mobile phone verification code login',
		a454: 'The phone number cannot be empty! ',
		a455: 'The verification code was sent abnormally, please try again later! ',
		a456: 'Please enter the account number or password! ',
		a457: 'Successful registration, jumping to the home page! ',
		a458: 'Mobile phone number is required! ',
		a459: 'Registration type',
		a460: 'Mobile phone registration',
		a461: 'Email registration',
		a462: 'Number area',
		a463: 'Mailbox number',
		a464: 'Login password',
		a465: "Seller's Nickname",
		a466: 'Please enter your mailbox number',
		a467: 'Please enter a password (a combination of more than 6 digits and letters)',
		a468: 'Please enter the verification code of your mobile phone',
		a469: 'Please enter the email verification code',
		a470: "Please enter the seller's nickname",
		a471: 'Invitation code (optional)',
		a472: 'The two passwords entered are inconsistent, please reconfirm the password',
		a473: "Please enter the seller's nickname",
		a474: 'Registration is successful, user information is being associated and analyzed',
		a475: 'The association is successful! ',
		a476: 'Association failed, please contact Xiaosheng customer service! ',
		a477: 'Southeast Asian localization expert',
		a478: 'Email phone',
		a479: 'Please fill in the correct mobile phone number! ',
		a480: 'Successful login, going to the home page! ',
		a481: 'Country',
		a482: 'Level one category',
		a483: 'Secondary category',
		a484: 'Third-level category',
		a485: 'Total number of pages',
		a486: "Can't print out after loading?",
		a487: 'Current printing page',
		a488: 'Page',
		a489: 'The number of pages per print',
		a490: 'Close batch printing',
		a491: 'Enable batch printing function',
		a492: 'Face sheet loading progress',
		a493: 'A4 paper',
		a494: 'A5 paper',
		a495: 'Thermal paper (custom)',
		a496: 'The loading of the face sheet is abnormal',
		a497: 'Gift',
		a498: 'Buyer message',
		a499: 'Message from the seller',
		a500: 'Getting the face order data, please wait a moment. . . ',
		a501: `<div class="Section0" style="layout-grid:15.6000pt;"><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:center;line-height:12.0000pt;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:21.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="黑体">ShopsBu Privacy Policy</font></span></b><b><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:11.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><o:p></o:p></span></b></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Release date: October 15, 2025 &nbsp;&nbsp;；Effective Date: October 15, 2025</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Thank you for visiting the e-commerce business management platform of Guangzhou Xiangrong Information Technology Co., Ltd. (hereinafter referred to as "us" or "ShopsBU"). This policy applies to Guangzhou Xiangrong Information Technology Co., Ltd., which provides products and services for ShopsBU. We attach great importance to the privacy and personal information security protection of our users (hereinafter referred to as "you"). We will strictly comply with legal and regulatory requirements, take corresponding security measures, and do our best to protect your personal information and privacy security. In view of this, we have formulated this "ShopsBU Privacy Policy" (hereinafter referred to as "this policy") and draw your attention to:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">This policy applies to all functions and services provided by our store's e-commerce business management platform. Please carefully read and thoroughly understand this policy before using the various functions or services we provide. Only after confirming full understanding and agreement can you start using them.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">To protect your relevant rights, this policy will explain to you how Dianxiaosheng's products and services will collect, use, and store your personal information, and what rights you have. Please read, understand, and agree to this policy before using Dianxiaosheng's products and services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Before using our products and services, please carefully read and thoroughly understand this privacy policy. Only after confirming that you fully understand and agree can you start using it. We will check and update our policies from time to time. Please visit this page regularly to ensure that you are aware of the latest version of our privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">By using or continuing to use products and services related to Dianxiaosheng, you agree to our collection, use, storage, and sharing of your information in accordance with this privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">This privacy policy will help you understand the following:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1、 How do we collect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2、 How we use your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3、 How do we share and disclose your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4、 How do we store your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5、 How do we protect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6、 Your rights</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7、 How do we handle the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">8、 How can your personal information be transferred globally</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">9、 How do we use cookies and similar technologies</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">10、 Changes to this policy</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">11、 Contact Us</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1、 How do we collect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">In order to provide services to you and enterprise users, optimize our services, and ensure account security, Dianxiaosheng will collect information that you voluntarily provide, authorize, or generate due to the use of the service when registering or using it in the following ways:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you register an account on the platform or log in to an existing account: We will collect your email address, phone number, login password, name, and country;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you use the waybill query function on the platform, we will collect your waybill number and logistics tracking information;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you use this platform for product order distribution and shipping, we will collect your store name, product information, and shipping address. After obtaining your permission, we will collect the names, phone numbers, addresses, and order information of buyers on your platform from third-party e-commerce platforms such as TEMU and Tiktok Shop (including package information, order items, prices, ordering time, shipping time, etc.);</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Please understand that the functions and services we provide to you are constantly updated and developed. If a certain function or service is not mentioned in the above description and has collected your information, we will separately explain the content, scope, and purpose of the information collection to you through page prompts, interaction processes, website announcements, etc., in order to obtain your consent.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2、 How we use your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">The data we collect during the provision of services to you may be used in the following ways:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Provide services to you. We will collect and store certain types of information about your use of this website. Our purpose of collecting this information is to improve the operation of the website, enable us to provide services, and accurately evaluate the website's performance;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Use your personal information to communicate with you. You may receive notifications from us via email or mobile push notifications you submit, such as when the status of your package changes or when we launch new services, promotions, etc. You can unsubscribe at any time;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Assist us in designing new services and improving our existing services;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Allow you to participate in surveys related to our products and services, conduct market activities related to our services, and push you the latest market activity information and discount plans;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Assist national judicial, administrative, security and other authorities in conducting investigations, and comply with applicable laws, regulations and other obligations promised to the authorities.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3、 How do we share and disclose your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will not sell, rent, trade or otherwise disclose your personal information to anyone under any circumstances, except in the following special circumstances:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Service providers and suppliers: In order to manage, supply, and improve the services of our store staff, as well as for marketing purposes, we may disclose personal information, including transaction information, to service providers and suppliers. Such as logistics companies, suppliers, and payment service providers, data storage and management suppliers, marketing and promotion suppliers, and suppliers that send email and SMS notifications. Used to help us improve our services and products.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Protecting legitimate rights and other legal purposes: We may be required to disclose information, such as being summoned, appearing in court, or being asked by law enforcement officers to conduct investigations, or any other legal requirement for us to disclose such information. We will also disclose personal information when necessary to protect our legal rights or to enforce our terms of use and other agreements. ShopsBUs may provide your personal information based on search warrants, subpoenas, or other lawful and effective inquiries or orders, or other requirements of applicable laws.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Merger and/or sale of assets: We usually do not sell, trade, or rent your personal information to any third-party company in the normal course of business. However, we may acquire, merge, or be acquired by another company, or we may dispose of some or all of our assets, in which case your personal information may be disclosed to another company, subject to compliance with privacy policies.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4、 How do we store your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Your personal information will be transferred and stored in Amazon Cloud, while other personal information will be transferred and stored on Tencent Cloud servers in the United States. Unless required or permitted by law for a longer retention period, we will retain the information collected from or about you for the shortest period of time necessary to achieve the purposes described in this privacy policy. When the information is no longer needed for these purposes, we will delete it or save it in a form that does not identify you. When determining this retention period, we will consider various criteria, including the type of service you request or provide, the nature of our relationship with you, the impact on the services we provide to you if we delete certain information about you, and the retention period required by law. Please note that once you successfully apply to cancel your ShopsBU account, we will complete the review of your account cancellation as soon as possible. After the application is approved, we will completely delete your personal data. If we cease to operate our products or services, we will notify you in the form of individual deliveries or announcements, and delete your personal data after ceasing to operate our products and services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5、 How do we protect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We have implemented industry standard security measures to protect the personal data you provide from unauthorized access, public disclosure, use, modification, damage, or data loss. We will take the following reasonable and feasible measures to protect your personal data:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use encryption technology to ensure the confidentiality of data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use trusted protection mechanisms to prevent malicious attacks on data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We have deployed access control mechanisms to ensure that only authorized personnel can access personal data, and we have organized security and privacy training courses to raise employees' awareness of the importance of protecting personal data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will use secure encryption technology to protect your personal data during transmission. Take all appropriate organizational, managerial, and technical measures to protect the security of the personal data you provide within our internal organization.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our physical, technical, or management safeguards are violated, resulting in unauthorized access, public disclosure, alteration, or destruction of data that damages your legal rights, we will be held responsible. After the unfortunate occurrence of a personal data security incident, we will promptly inform you of the requirements of laws and regulations: the basic situation and possible impact of the security incident, the disposal measures we have taken or will take, as well as suggestions for you to independently prevent and reduce risks, remedial measures taken for you, etc. We will promptly notify you of the situation related to the event through email, letter, phone, push notifications, and other means.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Although our business aims to protect your personal information, please understand that there is currently no 100% security anywhere, whether online or offline. The ShopsBU account requires a username and password to log in. Please protect your username and password and never disclose them to third parties.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6、 Your rights</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">According to the relevant laws, regulations, and standards in your local area, as well as the prevailing practices in other countries and regions, we guarantee that you exercise the following rights over your personal data. You have the right to demand that we:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1. Accessing your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You have the right to access your personal information, except for exceptions provided by laws and regulations. If you want to exercise your data access rights, you can access them yourself through the following methods:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Account information: If you wish to access or edit personal profile information in your account.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can log in to your store's Xiaosheng platform account through: personal homepage → click on the avatar in the upper right corner → click on "personal information" → browse your nickname, phone number, country, and email;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2. Correct your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you discover errors in the personal information we process about you, you have the right to request us to make corrections. You can submit a correction request through the methods listed in "1. Accessing Your Personal Information".</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are unable to correct these personal information through the above link, you can contact us using the contact information listed in Chapter 11 of this Privacy Policy. We will reply to your correction request within 5-7 working days.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3. Delete your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">In the following situations, you can request the deletion of personal information by sending us an email:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our handling of personal information violates laws and regulations;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we collect and use your personal information without your consent;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our handling of personal information violates our agreement with you;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you no longer use our products or services, or if you cancel your account;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we no longer provide you with products or services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we decide to respond to your deletion request, we will also notify the entities that have obtained your personal information from us to delete it in a timely manner, unless otherwise provided by laws and regulations, or if these entities have obtained your independent authorization.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4. Cancel your account</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can cancel the previously registered account at any time. You can send us an account cancellation application email using the contact information listed in Chapter 11 of this privacy policy. We will reply and take relevant actions within 5-7 working days after verifying your identity. After canceling your account, we will cease providing you with products or services and immediately delete your personal information.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5. Obtain a copy of your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You have the right to obtain a copy of your personal information. If you need to obtain a copy of the personal information we have collected from you, you can contact us using the contact information listed in Chapter 11 of this privacy policy. We will reply and take relevant actions within 5-7 working days after verifying your identity. We will submit a copy of your personal information to you via email. Subject to compliance with relevant legal regulations and technical feasibility, we will provide you with a copy of your personal information upon your request.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6. Consumer Rights of California Residents</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">According to the California Consumer Privacy Act, California residents have the right to know, access, and delete their personal data. California residents also have the right to choose not to allow businesses to sell their personal data, as well as the right not to be discriminated against for exercising California's privacy rights. We will not sell your personal data to anyone for any purpose, nor will we discriminate in responding to privacy requests.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are a resident of California, please be sure to review this privacy policy for important information regarding your rights under California privacy laws and how to submit requests to us based on these rights.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7. Responding to your above request</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will respond to the above request within 5-7 working days. Please refer to Chapter 11 of this Privacy Policy for contact information.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will not be able to respond to your request in the following situations:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests related to the fulfillment of legal and regulatory obligations by personal information controllers;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to national security and defense security;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to public safety, public health, and major public interests;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to criminal investigation, prosecution, trial, and execution of judgments;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">The personal information controller has sufficient evidence to indicate that the personal information subject has subjective malice or requests for abuse of rights;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests made to safeguard the significant legitimate rights and interests of personal information subjects or other individuals, such as life and property, but with difficulty in obtaining their consent;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Responding to a request from a personal information subject would result in serious harm to the legitimate rights and interests of the personal information subject or other individuals or organizations;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests involving trade secrets.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7、 How do we handle the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We expect parents or guardians to guide minors in using our services</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are a minor under the age of 14, you should read and agree to this policy under the supervision and guidance of your parents or other guardians before using our products.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2. We attach great importance to protecting the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We protect the personal information of minors in accordance with relevant laws and regulations. In the case of collecting personal information of minors with the consent of parents, we will only use, share or publicly disclose this information when permitted by law, with the explicit consent of parents or guardians, or when necessary to protect minors.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3. Self inspection and receiving feedback</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we find that we have collected personal information of minors without obtaining verifiable parental consent in advance, we will try to delete the relevant data as soon as possible. At the same time, we have established strict rules for the collection and use of underage information to protect the personal information security of children and adolescents. If you are the guardian of a minor and have any questions about the personal information of the minor under your guardianship, please contact us through the contact information disclosed in this policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">8、 How can your personal information be transferred globally</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We are committed to adhering to the highest privacy protection standards in the processing and transfer of personal information worldwide. When you use our services, your personal information may be transferred to servers located on Tencent Cloud. This type of international transfer will follow strict data protection and privacy security measures to ensure the same level of privacy protection as we provide locally to you.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">For personal information transferred to Tencent Cloud servers located in Guangzhou, China, we comply with relevant privacy and data protection laws in China and the United States, including but not limited to ensuring that there are corresponding security measures in place, such as encryption and access control, to safeguard data security and privacy. In addition, we will monitor relevant legal changes to ensure that our practices can adapt to these changes in a timely manner and safeguard users' privacy rights.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will transfer personal information of EU users in accordance with the requirements of the EU General Data Protection Regulation (GDPR). This means that when personal information leaves the European Union and economic regions, we will transfer it by adopting standard contractual terms recognized by the European Commission or when there is sufficient data protection in the receiving country. We promise to regularly evaluate the data protection level of the receiving country and ensure the effective implementation of protection measures.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you have any questions or need assistance regarding the cross-border transfer of your personal information, please contact us.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">9、 How do we use cookies and similar technologies</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use cookies and other similar technologies to enhance your experience using this service. When you use this service, we may use relevant technologies to send one or more cookies or anonymous identifiers to your device to collect and store information about your access and use of this service. We promise not to use cookies for any purposes other than those described in this privacy policy. We use cookies and similar technologies mainly to achieve the following functions or services:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Accelerate navigation</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Track website usage</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Identify user identity, access permissions, and preferences</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Conduct research and diagnosis to improve our content, products, and services</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can refuse or manage cookies or data analytics tools through your browser settings. However, please note that if cookies or data analytics tools are disabled, you may not be able to enjoy the best service experience, and some services may not function properly.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">10、 Changes to this policy</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">To ensure that you are always aware of how we collect, use, and disclose your information, we will post any changes or updates to this privacy policy on this website and encourage you to review this privacy policy from time to time. If we change this privacy policy, we will notify you by modifying the date at the top of this privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">11、 Contact Us</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Please protect your personal information properly and only provide it to others when necessary. If you discover that your personal information has been leaked, especially the username and password of this application, please contact the customer service of this application immediately so that this application can take corresponding measures.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you have any questions about this policy or other related matters, please contact us through https://erp.shopsbu.com// Contact us. You can also send your questions to https://erp.shopsbu.com/ Or send it to the following address:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Address: 1st Floor, Federal Building, No. 30 Caotang Road, Panyu District, Guangzhou City (Address)</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Postal code: 510520.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">隐私政策</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">发布日期：</font>202</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">5</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">年</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">10</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">月</font>15日</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">生效日期：</font>202</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">5</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">年</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">10</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">月</font>15日</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">感谢您访问</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">广州向榕信息科技有限公司</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">电商业务管理平台（以下称</font><font face="system">“我们”或“</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">”）。本政策适用于提供</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">产品和服务的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">广州向榕信息科技有限公司</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">。</font> <font face="system">我们非常重视用户（下称</font><font face="system">“您”）的隐私和个人信息安全保护，我们将严格按照法律法规要求，采取相应安全保护措施，尽力保护您的个人信息及隐私安全。鉴于此，我们制定本《</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">隐私政策》（下称</font><font face="system">“本政策”）并提请您注意：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">本政策适用于我们提供的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">电商业务管理平台所提供的所有的功能和服务。请您在使用我们提供的各项功能或服务前，务必仔细阅读并透彻理解本政策，在确认充分理解并同意后再开始使用。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为保障您的相关权利，本政策将向您说明</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务会如何收集、使用和存储您的个人信息及您享有何种权利，请您在使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务之前，阅读、了解并同意本政策。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">产品服务前，请您务必仔细阅读并透彻理解本隐私政策，在确认充分理解并同意后再开始使用。我们会不时地检查并更新我们的政策，请您定期光顾本页面，以确保对最新版本隐私政策的了解。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您使用或继续使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务，都表示您同意我们按照本隐私政策收集、使用、储存和分享您的信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">本隐私政策将帮助您了解以下内容：</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">一、</font> <font face="system">我们如何收集您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">二、</font> <font face="system">我们如何使用您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">三、</font> <font face="system">我们如何共享、披露您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">四、</font> <font face="system">我们如何存储您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">五、</font> <font face="system">我们如何保护您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">六、</font> <font face="system">您的权利</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">七、</font> <font face="system">我们如何处理未成年人的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">八、</font> <font face="system">您的个人信息如何在全球范围转移</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">九、我们如何使用</font>Cookie和同类技术</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">十、</font> <font face="system">本政策的变更</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">十一、联系我们</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">一、我们如何收集您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为了向您和企业用户提供服务、优化我们的服务以及保障帐号安全，</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">会按照如下方式收集您在注册、使用服务时主动提供、授权或因为使用服务而产生的信息：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您在平台注册账号或登录现有帐户：我们将收集您的电子邮箱地址、手机号码、登陆密码、姓名、国家；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您在平台使用运单查询功能时，我们将收集您的运单号与物流跟踪信息；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您使用本平台进行产品订单配货发货时我们将收集您的店铺名称、商品信息、发货地址。我们通过您的准许后会从</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">TEMU</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">，</font>Tiktok Shop等第三方电商凭他平台收集您所在平台买家的姓名、电话、地址与订单信息（包括：包裹信息、订单商品、价格、商品下单时间、发货时间等）；</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:18.0000pt;
		mso-para-margin-left:0.0000gd;mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
		mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p>&nbsp;</o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们通过页面提示，交互流程，网站公告等方式另行向你说明信息收集的内容、范围和目的，以征得您的同意。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">二、我们如何使用您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们在向您提供服务过程中收集的数据可能会以以下方式使用：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">向您提供服务。我们会收取并存储有关您使用本网站的某些类型的信息。我们收集这些信息的目的是为了让网站更好的运作、使我们能够提供服务、正确的评估网站的运行情况；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">使用您的个人信息与您沟通。您可能会收到我们通过您提交的电子邮件或者手机推送的通知，例如：当您的包裹状态发生改变或者我们有新服务上线、促销等。您可以随时取消订阅；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">帮助我们设计新服务，改善我们现有服务；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">让您参与有关我们产品和服务的调查，开展与服务相关的市场活动，向您推送最新的市场活动信息及优惠方案；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">协助国家司法、行政、安全机关等权利机构开展调查，并遵守适用法律法规及其他向有权机构承诺之义务。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">三、我们如何共享、披露您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们不会以任何情形出售、出租、交易或以其他方式向任何人披露您的个人信息，以下特殊情况下除外：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">服务提供商和供应商：为了管理、供应和改进</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">的服务以及出于市场营销目的，我们可能会向服务提供商和供应商披露包括交易信息在内的个人信息。如物流公司、供应商和支付服务提供商，数据存储和管理供应商、营销和促销供应商、发送电子邮件和</font>SMS通知的供应商。用于帮助我们改进服务、产品。</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">保护合法权利和其他法定目的：我们可能被要求披露信息，如被传唤、法院出庭或被执法机关人员要求进行调查，或者其它任何一切由法律要求我们披露这些信息。</font> <font face="system">我们还会在必要时披露个人信息，以保护我们的合法权利或执行我们的使用条款和其他协议。</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">可能会根据搜查令，传票或其他合法有效的查询或命令或适用法律的其他要求提供您的个人信息。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">合并和</font>/或出售资产：我们通常不会在正常经营过程中向任何第三方公司出售、交易、出租您的个人信息。但是，我们可能会收购、合并或被另一家公司收购，或者我们可能会处置部分或全部资产，在这种情况下，您的个人信息可能会被披露给另一家公司，但须遵守隐私政策 有效。</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">四、我们如何存储您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您的个人信息将被传输并存储</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">亚马逊云</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">中，其他个人信息将被传输并存储美国腾讯云服务器中。除非法律要求或允许更长的保留期，否则我们将在实现本隐私政策所述目的所需的最短时间内保留从您处收集的或关于您的信息。当信息不再需要用于这些目的时，我们会将其删除或以不识别您身份的形式保存。在确定此保留期时，我们会考虑各种标准，包括您请求或提供的服务类型、我们与您关系的性质、如果我们删除您的某些信息，对我们向您提供的服务的影响，以及法律要求的保留期。请注意，当您申请注销您的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">账户成功后，我们将尽快完成对您账户注销的审查。申请获得批准后，我们将完全删除的您的个人数据。如果我们停止经营产品或服务，我们将以逐一交付或公告的形式通知您，并在停止经营产品和服务后删除您的个人数据。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">五、我们如何保护您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们采取的安全措施我们使用了行业标准的安全措施来保护您提供的个人数据免受未经授权的访问、公开披露、使用、修改、损坏或数据丢失。我们将采取以下合理可行的措施来保护您的个人数据：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用加密技术来确保数据的机密性；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用可信的保护机制来防止对数据的恶意攻击；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们部署了访问控制机制，以确保只有授权人员才能访问个人数据，我们举办了安全和隐私培训课程，以提高员工对保护个人数据重要性的认识；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们将使用安全加密技术在传输过程中保护您的个人数据。采取一切适当的组织、管理和技术措施，保护您在我们内部组织中提供的个人数据的安全。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们的物理、技术或管理保障措施被违反，导致未经授权访问、公开披露、更改或破坏数据，从而损害您的合法权利，我们将承担责任。在个人数据安全事件不幸发生后，我们将及时告知您法律法规的要求：安全事件的基本情况和可能产生的影响，我们已经或将要采取的处置措施，以及您可以独立预防和降低风险的建议，为您采取的补救措施等。我们将通过电子邮件、信函、电话、推送通知等方式及时通知您与事件相关的情况。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">虽然我们的业务旨在保护您的个人信息，但请理解，目前在任何地方都不存在</font>100％的安全性，无论线上或线下。 </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">帐户需要用户名和密码才能登录。请保护好您的用户名和密码，绝不向第三方透露。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">六、您的权利</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">根据您当地的相关法律、法规和标准以及其他国家和地区的通行做法，我们保证您对您的个人数据行使以下权利。您有权要求我们</font>:</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">1.访问您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">账户信息</font>:如果您希望访问或编辑您的账户中的个人资料信息。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您可以登陆您的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">平台账号通过：个人主页</font><font face="system">→点击右上角头像→点击「个人资料」→浏览您的昵称、手机号码、国家、邮箱；</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">2.更正您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过</font><font face="system">“1.访问您的个人信息”中罗列的方式提出更正申请。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您无法通过上述链接更正这些个人信息，您可按照本《隐私政策》第十一章中列明的联系方式与我们联系。我们将在</font>5-7个工作日内回复您的更正请求。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">3.删除您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在以下情形中，您可以通过发送邮件向我们提出删除个人信息的请求：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们处理个人信息的行为违反法律法规；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们收集、使用您的个人信息，却未征得您的同意；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们处理个人信息的行为违反了与您的约定；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您不再使用我们的产品或服务，或您注销了账号；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们不再为您提供产品或服务。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">4.注销您的账户</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您随时可注销此前注册的账户。您可按照本隐私政策第十一章中列明的联系方式向我们发送账号注销申请邮件，我们将在验证您身份后的</font>5-7个工作日内回复并进行相关操作。在注销账户之后，我们将停止为您提供产品或服务，并立即删除您的个人信息。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">5. 获取您的个人信息副本</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您有权利获得您的个人信息副本。如您需要获取我们收集的您的个人信息副本您可按照本隐私政策第十一章中列明的联系方式与我们联系，我们将在验证您身份后的</font>5-7个工作日内回复并进行相关操作。我们会将个人信息副本通过邮件的形式提交给您。在符合相关法律规定且技术可行的前提下，我们将会根据您的要求向您提供您的个人信息副本。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">6. 加州居民消费者权益</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">根据《加州消费者隐私法》，加州居民有权了解、访问和删除他们的个人数据。加州居民也有权选择不让企业出售他们的个人数据，也有权不因行使加州隐私权而受到歧视。我们不会出于任何目的将您的个人数据出售给任何人，也不会在回应隐私权请求时进行歧视。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您是加州居民，请务必查看本隐私政策，了解有关您在加州隐私法下的权利以及如何根据这些权利向我们提交请求的重要信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">7. 响应您的上述请求</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">对于以上请求，我们将在</font>5-7个工作日内做出答复，联系方式请见本隐私政策第十一章节。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在以下情形中，我们将无法响应您的请求：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与个人信息控制者履行法律法规规定的义务相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与国家安全、国防安全直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与公共安全、公共卫生、重大公共利益直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与犯罪侦查、起诉、审判和执行判决等直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">涉及商业秘密的请求。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">七、我们如何处理未成年人的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">1. 我们期望父母或监护人指导未成年人使用我们的服务</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">若您是未满</font>14周岁的未成年人，在使用我们的产品前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">2.我们重视保护未成年人个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们根据相关法律法规的规定保护未成年人的个人信息，对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享或公开披露此信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">3. 自查与接收反馈</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。同时我们建立了严格的未成年人信息收集使用规则，以保护儿童和青少年个人信息安全。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策公示的联系方式与我们联系。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">八、您的个人信息如何在全球范围转移</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们在全球范围内对个人信息的处理与转移承诺遵守最高的隐私保护标准。当您使用我们的服务时，您的个人信息可能会被转移到位于腾讯云服务器上。此类国际转移将遵循严格的数据保护和隐私安全措施，确保与我们在您本地提供的隐私保护同等水平。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">对于转移到位于中国广州的腾讯云服务器上的个人信息，我们遵循中国与美国的相关隐私和数据保护法律，包括但不限于，确保有相应的安全措施存在，如加密和访问控制，以保障数据的安全与隐私。此外，我们还将监控相关的法律变动，确保我们的做法能够及时适应这些变化，维护用户的隐私权益。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">针对欧盟用户的个人信息，我们将依照欧盟通用数据保护条例（</font>GDPR）的要求进行数据转移。这意味着当个人信息离开欧盟及经济区域时，我们将通过采用欧盟委员会认可的标准合同条款或在接收国有足够的数据保护水平时进行转移。我们承诺会定期评估接收国的数据保护水平，并确保保护措施的有效执行。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您对于您的个人信息跨境转移有疑问或需要帮助，请与我们联系。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">九、我们如何使用</font>Cookie和同类技术</span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用</font>Cookie和其他类似技术，以提升您使用本服务的体验。当您使用本服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本服务时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">加速导航</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">追踪网站使用情况</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">辨别用户身份、访问权限及偏好</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">进行研究和诊断以改善我们的内容、产品和服务</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您可以通过的浏览器设置拒绝或管理</font>cookies或数据统计工具。但请注意，如果停用cookies或数据统计工具，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">十、本政策的变更</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为了确保您随时了解我们如何收集、使用和披露您的哪些信息，我们将在本网站上发布本隐私政策的任何更改或更新，并鼓励您不时查看本隐私政策。</font> <font face="system">如果我们更改本隐私政策，我们会通过修改本隐私政策顶部的日期来通知您。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">十一、联系我们</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">如您对本政策或其他相关事宜有疑问，请通过</font><font face="微软雅黑">&nbsp;</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">https://erp.shopsbu.com//</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">&nbsp;与我们联系。您也可将您的问题发送至</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">https://erp.shopsbu.com/</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">或寄到如下地址：</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">地址：</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">广州市</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">番禺区草堂路</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">30号</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">联邦大厦一楼</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">&nbsp;（收）</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">邮编：</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">510520</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p></div>`,
		a502: 'Identify payment code payment',
		a503: 'Recharge amount',
		a504: 'Actual payment',
		a505: 'Cashback',
		a506: 'Consumption time',
		a507: 'Continue to login',
		a508: 'WeChat scan code payment',
		a509: 'After the user recharges successfully, please contact the platform customer service to provide information on opening a local store and related matters!',
		a510: 'Customer Service WeChat',
		a511: 'Receipt order',
		a512: 'Print now',
		a513: 'Upload the head-to-head logistics form',
		a514: 'Only jpg/png files can be uploaded, and no more than 8M',
		a515: 'Storage order number',
		a516: 'Box number',
		a517: 'Detailed address',
		a518: 'Consignee',
		a519: 'Telephone',
		a520: 'Login mailbox',
		a521: 'Mobile phone number',
		a522: 'The password must be composed of more than 6 characters',
		a523: 'Please enter your email address! ',
		a524: 'Please enter the correct email address! ',
		a525: 'Please fill in the account information! ',
		a526: 'The passwords entered twice are inconsistent! ',
		a527: 'Please enter the mobile phone number! ',
		a528: 'Please enter the email verification code! ',
		a529: 'Please enter the email address or seller name! ',
		a530: 'Select region',
		a531: '(Required)',
		a532: 'Warehouse account',
		a533: 'Warehouse name',
		a534: 'Warehouse password',
		a535: 'Email verification code',
		a536: 'Fill in the warehouse account number',
		a537: 'Fill in the warehouse name',
		a538: 'The warehouse password must be at least 6 characters, a combination of letters, numbers, and characters',
		a539: 'Copy and share your exclusive registration link. Once the invited seller recharges, 1% of the amount will be returned to your account immediately. The invited seller can also immediately receive 10 yuan bonus points. All points can be used for distribution Purchasing, logistics consumption and overseas warehouses, etc. Hurry up and share with your seller friends to create a cross-border overseas market together',
		a540: 'Invite user registration link',
		a541: 'Copy link',
		a542: 'Invite user link',
		a543: 'The account is abnormal, please contact customer service! ',
		a544: 'Copy successfully',
		a545: 'Cross-border management system',
		a546: 'Associated binding',
		a547: 'Focus on serving local sellers in Southeast Asia',
		a548: 'Affiliated store niche account',
		a549: 'Please enter your Xiaosheng account',
		a550: 'Associate immediately',
		a551: 'Authorization management',
		a552: 'Official partner',
		a553: 'Congratulations, the store authorization is successful, please choose the operation you will perform!',
		a554: 'Go to the homepage',
		a555: 'Review order',
		a556: 'Import products',
		a557: 'Stock product',
		a558: 'Successful registration, going to the login page! ',
		a559: 'Watermark management',
		a560: 'Restore the original image',
		a561: 'Apply all pictures',
		a562: 'Only use the current picture',
		a563: 'Confirm return',
		a564: 'Are you sure you want to continue deleting the watermark? ',
		a565: 'Deleted successfully! ',
		a566: 'Warehouse',
		a567: 'Gift Quantity',
		a568: 'Unbound product',
		a569: 'Minute',
		a570: 'The order has filed a complaint with the warehouse and is waiting for the warehouse to process it! ',
		a571: 'Please confirm the following information',
		a572: 'Enter remarks to the seller (optional)',
		a573: "Please fill in the warehouse's message (required)",
		a574: 'Enter the order number to search',
		a575: 'Complaint orders to be processed by the warehouse',
		a576: "Agree to this seller's complaint will deduct the number of points",
		a577: 'Please fill in the points that the warehouse is willing to pay',
		a578: 'Complaint details',
		a579: 'Warehouse message',
		a580: 'Platform message',
		a581: 'Overseas Warehouse Complaint Center',
		a582: 'Order search',
		a583: 'Order Status',
		a584: 'Order paid',
		a585: 'Estimated compensation points',
		a586: 'Specification name',
		a587: 'Quantity',
		a588: 'Order time',
		a589: 'Payment time',
		a590: 'Print time',
		a591: 'Exit time',
		a592: 'Store name',
		a593: 'Delivery method',
		a594: 'Waybill number',
		a595: 'Platform type',
		a596: 'Paid',
		a597: 'Agree',
		a598: 'Negotiation',
		a599: 'Waiting for platform processing',
		a600: 'View details',
		a601: 'Please fill in the reason for rejection!',
		a602: 'Successfully submitted!',
		a603: 'New product',
		a604: 'Reset order',
		a605: 'Return',
		a606: 'Store in warehouse',
		a607: 'Change',
		a608: 'Are you sure you want to delete? ',
		a609: 'The order item has been modified successfully! ',
		a610: 'It has been reset to the original order! ',
		a611: 'User-created order',
		a612: 'Create order',
		a613: 'Fill in consignee information',
		a614: 'Add warehouse product',
		a615: 'Estimated total volume',
		a616: 'Estimated total weight',
		a617: 'When warehouse type',
		a618: 'Estimated courier fee',
		a619: 'Select logistics:',
		a620: 'First weight',
		a621: 'First weight cost',
		a622: 'Renewal fee',
		a623: 'Billing method',
		a624: 'Order Remarks',
		a625: 'Leave a message to the warehouse:',
		a626: 'Zip code',
		a627: 'Please select a country',
		a628: 'Province',
		a629: 'City',
		a630: 'Address',
		a631: 'Volume (length*width*height/cm)',
		a632: 'Weight/KG',
		a633: 'Purchase Quantity',
		a634: 'Please select logistics',
		a635: 'By weight',
		a636: 'By volume',
		a637: 'Take the larger of weight/volume weight',
		a638: 'Please enter the consignee',
		a639: 'Please enter the province',
		a640: 'Please enter the phone number',
		a641: 'Please fill in the city',
		a642: 'Please enter the region',
		a643: 'Please enter the detailed address of the consignee',
		a644: 'Please select a country',
		a645: 'The items in the self-built order must default to items in the same warehouse! ',
		a646: 'Duplicate warehouse products already exist! ',
		a647: 'Please add the product of the order! ',
		a648: 'The self-built order was created successfully! Returning the order to be reviewed! ',
		a649: 'The content with red starry sky is required! ',
		a650: 'Please select the product type',
		a651: 'Please select a delivery warehouse',
		a652: 'Add product',
		a653: 'Select Warehouse',
		a654: 'You can enter the product name and sku to search',
		a655: 'Currently audited warehouse',
		a656: 'Only spot inventory will be automatically approved, and it will not be automatically passed if there is no imported product in the warehouse or if it is stored in the warehouse as 0',
		a657: 'Main image',
		a658: 'Currently there are no sku options',
		a659: 'Warehouse mother sku',
		a660: 'Number of sub-sku',
		a661: 'Select SKU',
		a662: 'Please note: If the product is bound as a virtual SKU warehouse, this product will no longer be sorted. This function is suitable for settings such as virtual gifts. ',
		a663: 'Bind virtual sku',
		a664: 'Bind inventory products',
		a665: 'The modification is successful! ',
		a666: 'Please check the product',
		a667: 'Please select the SKU of the product',
		a668: 'The order must contain at least one item! ! ! ',
		a669: 'Confirm to delete?',
		a670: 'The warehouse type is the product warehouse, please select the product type! ! ! ! ',
		a671: 'The testing warehouse currently does not support the automatic audit function, please re-select the warehouse type! ',
		a672: 'Please select the audited warehouse',
		a673: 'Remark order information:',
		a674: 'Batch remark order information',
		a675: "Order remarks are added by the seller, only the warehouse and the seller on the platform can see it, if not filled, it means no seller's message by default!",
		a676: 'Binding failure prompt',
		a677: 'Reason',
		a678: 'Create self-built orders in batches',
		a679: 'Download import template',
		a680: 'Drag the excel file here, or click to upload',
		a681: 'Data is loading, please wait. . . ',
		a682: 'Data loading is complete, please refresh the page! ',
		a683: 'Among the orders you selected, after filtering according to the actual inventory quantity in the warehouse and the urgency up to the delivery date',
		a684: 'Audit success',
		a685: 'Audit details',
		a686: 'Withholding points',
		a687: 'Audit failed',
		a688: 'Failure reason',
		a689: 'Point fee',
		a690: 'Deadline delivery time',
		a691: 'System Prompt',
		a692: 'Received (￥) - total supply price',
		a693: 'Supply price * purchase quantity',
		a694: 'A spot order that can be approved',
		a695: 'Proposal for out-of-stock orders that do not pass',
		a696: 'Batch review orders',
		a697: 'Enable automatic review',
		a698: 'Synchronize order status',
		a699: 'Batch export',
		a700: 'Batch remark order',
		a701: 'Self-built manual order',
		a702: 'Create a single manual order',
		a703: 'Create manual orders in batches',
		a704: 'Seller APP',
		a705: "Seller's mobile APP can realize review order/return management and Shopee multi-store chat, including automatic translation, automatic reply, multi-store switching, etc.",
		a706: 'Reverse selection',
		a707: 'Record',
		a708: 'Estimated gross profit',
		a709: 'Total supply price',
		a710: 'Distribution order',
		a711: 'Supplier',
		a712: 'Reason for withdrawal',
		a713: 'Modify order',
		a714: 'Remark order',
		a715: 'Delete self-built list',
		a716: 'Please select an order! ',
		a717: 'Successfully submit the remark information! ',
		a718: 'The submission is abnormal, try again after a while! ',
		a719: 'Successful submission! ',
		a720: 'Currently there is no spot order that can be approved! ',
		a721: 'Successfully close the automatic review! ',
		a722: 'Successfully enable automatic review! ',
		a723: 'After checking the order, review it again! ',
		a724: 'This review',
		a725: 'In the number of orders, there are',
		a726: 'The order is not bound or the audit warehouse is inconsistent and cannot be audited. Do you want to continue to audit the rest',
		a727: 'Order? ',
		a728: 'Continue to review the remaining orders',
		a729: 'OK',
		a730: 'To be reviewed',
		a731: 'COD (cash on delivery)',
		a732: 'Successfully bound as a virtual sku',
		a733: 'The binding is successful! ',
		a734: 'Currently bound inventory products:',
		a735: 'Mother SKU',
		a736: 'Sub sku',
		a737: 'Currently there is no news about bound stock products! ',
		a738: 'Please bind the warehouse product before performing this operation! ',
		a739: 'Confirm to restore the order? ',
		a740: 'Are you sure to set an empty package? ',
		a741: 'The setting is successful! ',
		a742: 'Display orders will restore the occupation of the online inventory of warehouse products, are you sure to cancel hiding? ',
		a743: 'Hiding the order will cancel the occupation of the online inventory of the warehouse product. Are you sure to hide this order? (display recoverable)',
		a744: 'The order has been displayed',
		a745: 'The order is hidden',
		a746: 'Please select the order to export! ',
		a747: 'This time will export',
		a748: 'Details of orders, do you want to continue exporting? ',
		a749: 'Immediately export excel',
		a750: 'All stores',
		a751: 'This time will be synchronized: "',
		a752: '"Recently',
		a753: 'It is expected to take 30-59 seconds to synchronize the order data for the order of the day. After the data is synchronized, please refresh the current page. Do you want to continue the synchronization? ',
		a754: 'order synchronization',
		a755: 'Synchronize now',
		a756: 'The order data is being synchronized, please wait a moment! ',
		a757: 'The order data has been synchronized, please refresh! ',
		a758: 'Only upload files of excel type!',
		a759: 'Currently only one file can be selected, please delete it and continue uploading',
		a760: 'The store has been unbound',
		a761: 'Pending order',
		a762: 'The order failed to pass the review within 2 hours of payment',
		a763: 'Open',
		a764: 'Order number query',
		a765: 'Order sorting',
		a766: 'Order time from late to early',
		a767: 'Order time from morning till night',
		a768: 'Remaining delivery time from more to less',
		a769: 'Remaining delivery time from less to more',
		a770: 'Are you sure you want to close? ',
		a771: 'Are you sure you want to open it? ',
		a772: 'The order has not passed the review within 2 hours of opening! ',
		a773: 'The order has not been approved within 2 hours of closing! ',
		a774: 'Shop Options',
		a775: 'Cargo type',
		a776: 'Country area',
		a777: 'Order type',
		a778: 'Warehouse withdrawal review',
		a779: 'Binding status',
		a780: 'Show hidden',
		a781: 'Ordinary order',
		a782: 'Contains distribution products',
		a783: 'Self-built bill',
		a784: 'General goods',
		a785: 'Sensitive goods',
		a786: 'Platform self-built list',
		a787: 'Unbound order',
		a788: 'Orders from different warehouses',
		a789: 'Hidden',
		a790: 'Display',
		a791: 'Create manual order',
		a792: 'Please choose a store! ',
		a793: 'The order information has been reset! please refresh! ',
		a794: 'Please select the order that needs to be reviewed! ',
		a795: 'Please select an audit warehouse',
		a796: 'The audit warehouse type is the product warehouse, please select the cargo type! ',
		a797: 'Currently there is no spot order that can be reviewed',
		a798: 'Synchronizing order data, please wait a moment! ',
		a799: 'belonging to the seller',
		a800: 'The order was deleted successfully! ',
		a801: "The information of receiving the package has been submitted to the seller, please wait patiently for the seller's confirmation! ",
		a802: "Please wait patiently for the seller's confirmation! ! ",
		a803: 'Select seller:',
		a804: 'The order already exists! ',
		a805: 'Discard package',
		a806: 'Re-launch',
		a807: 'Other',
		a808: 'Fill in the received return information',
		a809: 'Select receiving warehouse',
		a810: 'Leave a message to the seller',
		a811: 'Return package',
		a812: 'Operation type',
		a813: 'Quantity on shelves',
		a814: 'Return details',
		a815: 'Please select a shipping warehouse',
		a816: 'The seller confirms the return operation type:',
		a817: 'Product name',
		a818: 'Please enter the quantity on the shelf',
		a819: 'Leave a message to the warehouse (optional)',
		a820: 'Leave a message to the seller (optional)',
		a821: 'The warehouse that received the return',
		a822: 'Drag the picture here, or',
		a823: 'No picture yet',
		a824: 'Status at that time',
		a825: 'Return amount',
		a826: 'Return',
		a827: 'Buyer nickname',
		a828: 'Buyer eamil',
		a829: 'Buyer delivery deadline',
		a830: 'The seller is due to process the return',
		a831: 'Price',
		a832: 'Return Form',
		a833: 'Cancel order',
		a834: 'Total amount',
		a835: 'Reason for cancellation',
		a836: 'Shipment type',
		a837: 'Delivery Warehouse',
		a838: 'Shop',
		a839: 'All orders',
		a840: 'Cancelled',
		a841: 'Return order',
		a842: 'Application Cancellation',
		a843: 'All stores',
		a844: 'Please select the receiving warehouse',
		a845: 'Please enter the quantity on the shelf',
		a846: 'The seller is confirming, please wait patiently! ',
		a847: 'The warehouse is being confirmed, please wait patiently! ',
		a848: 'Not reviewed',
		a849: 'Buyer',
		a850: 'System',
		a851: 'The seller failed to answer my question in time',
		a852: 'Buyer fails to pay, the system automatically cancels',
		a853: "The buyer doesn't want it anymore",
		a854: 'Package has been lost',
		a855: 'The seller has not shipped',
		a856: "The logistics cannot be delivered to the buyer's area",
		a857: 'Package is damaged',
		a858: 'Commodity function damaged',
		a859: 'The seller sent the wrong goods! ',
		a860: 'The buyer did not receive the goods',
		a861: 'Time period',
		a862: 'Total quantity of distribution orders',
		a863: 'point income',
		a864: 'Export excel form',
		a865: 'Scan out of the warehouse (only for overseas warehouses)',
		a866: 'Select date',
		a867: 'Order number',
		a868: 'Find the order number',
		a869: 'Package date',
		a870: 'Outbound order quantity',
		a871: 'Number of cancellations after delivery',
		a872: 'Express collection number',
		a873: 'Deduction points',
		a874: 'Income points',
		a875: 'View order',
		a876: 'Export order',
		a877: 'Print the courier sign',
		a878: 'Logistics type:',
		a879: 'Seller type',
		a880: 'Sensitive goods mode',
		a881: 'General cargo mode',
		a882: 'The sensitive goods delivery mode has been enabled',
		a883: 'The general goods delivery mode has been turned on',
		a884: 'I know',
		a885: 'Scan out of the library',
		a886: 'No seller message',
		a887: 'No barcode',
		a888: 'No information',
		a889: 'The picking quantity is abnormal! ',
		a890: 'Please scan the order number first! ',
		a891: "My dear, you haven't bound shopee yet! ",
		a892: 'Go to the bound shopee store! ',
		a893: 'Has received',
		a894: 'Not collected',
		a895: 'Order number',
		a896: 'Shipping method',
		a897: "Seller's note",
		a898: 'Push time',
		a899: 'Contact information',
		a900: 'Exit points',
		a901: 'Generate waybill number',
		a902: 'Initialize PDF',
		a903: 'Reprint the face sheet',
		a904: 'The waybill has been generated, please refresh the page manually!',
		a905: 'Please generate the waybill number and print it!',
		a906: "Seller's actual outbound quantity",
		a907: 'No logistics name',
		a908: 'Orders processed',
		a909: 'Enter order number query',
		a910: 'Outgoing fee',
		a911: 'Distribution order profit',
		a912: 'Distribution list',
		a913: 'Store filter:',
		a914: 'Warehouse type',
		a915: 'Return order',
		a916: 'Query',
		a917: 'Rebinding',
		a918: 'Unbound warehouse products',
		a919: 'To bind',
		a920: 'No delivery warehouse detected',
		a921: 'The seller requires the processing method',
		a922: 'The actual processing method of the warehouse',
		a923: 'Return status:',
		a924: 'The seller verified the return',
		a925: 'The seller has confirmed',
		a926: 'Processed',
		a927: 'Please choose the processing method',
		a928: 'Seller confirms success, pending warehouse processing',
		a929: 'The order is pending review, please operate after order review! ',
		a930: 'Test',
		a931: 'Printing method',
		a932: 'Face sheet & picking list',
		a933: 'Only face order',
		a934: 'Picking list only',
		a935: 'Zoom single surface',
		a936: 'Description text',
		a937: 'Please fill in the delivery information first',
		a938: 'Export xlsx file',
		a939: 'Store list',
		a940: 'Historical print record',
		a941: 'Print time period',
		a942: 'Print type',
		a943: 'Print order quantity',
		a944: 'Reprint',
		a945: 'Test',
		a946: 'Side single print',
		a947: 'print name',
		a948: 'Print time (first time)',
		a949: 'Not printed',
		a950: 'printed',
		a951: 'Print order',
		a952: 'Print the default pick list',
		a953: 'It has been printed, reload the current page',
		a954: 'Return failed for review',
		a955: 'Okay, I see',
		a956: 'Order processing progress',
		a957: 'The courier has been received! ',
		a958: 'The warehouse has finished scanning and leaving the warehouse, waiting for the courier to pick it up and go online! ',
		a959: 'The warehouse has completed the inspection, waiting for the warehouse to scan out the warehouse! ',
		a960: 'The warehouse has printed the face sheet for sorting, and the warehouse is waiting for inspection! ',
		a961: 'The warehouse has completed distribution, waiting for the warehouse to print the face sheet and sort it! ',
		a962: 'Approved, waiting for warehouse sorting and distribution! ',
		a963: 'The waybill number is being generated, please do not leave the current page! ',
		a964: 'Total',
		a965: 'Orders/completed',
		a966: 'Order query',
		a967: 'Contains query',
		a968: 'Search product name, product sku',
		a969: 'Push time sorting (from early to late)',
		a970: 'Push time sorting (from late to early)',
		a971: 'Fill in the basic information of the courier consignor',
		a972: "Sender's name",
		a973: "Sender's phone number",
		a974: "Consignor's detailed address",
		a975: 'Batch mark/remark',
		a976: 'Synchronize a single order number',
		a977: 'Batch export order information',
		a978: 'Order modified by the user',
		a979: 'Add mark',
		a980: 'Cash on delivery',
		a981: 'Check time',
		a982: 'Unchecked',
		a983: 'Not out of the warehouse',
		a984: 'Logistics',
		a985: 'Not generated',
		a986: 'Order progress',
		a987: 'Urgent reminder',
		a988: 'Expedited processing',
		a989: 'Loading pending orders, please wait!!!',
		a990: 'Successfully submit the remark information! ',
		a991: 'The submission is abnormal, please retry after a while! ',
		a992: 'The system detects that you have not filled in the basic delivery information, please fill in it first, so that you can quickly print in batches! ',
		a993: 'Successfully saved! ',
		a994: 'You have expedited this order, each order can only be expedited once a day! ',
		a995: 'The review time of the current order has not exceeded 24 hours, and the order cannot be urgently urged. If the order has not been printed after 24 hours of review, you can urge the order, thank you. ',
		a996: 'Got it',
		a997: 'The same order can only be reminded once a day. Are you sure you want to urgently remind this order number? ',
		a998: 'Reminder to remind',
		a999: 'The warehouse staff has been notified to give priority to expediting the order! ',
		a1000: 'Confirm to withdraw',
		a1001: 'An order? ',
		a1002: 'Successfully returned for review! ',
		a1003: 'Synchronizing, the process takes about 50-60 seconds! ! ! ',
		a1004: 'Self-built manual',
		a1005: 'The seller has made a note',
		a1006: 'No mark',
		a1007: 'The waybill has been generated, and the current page is being refreshed! ',
		a1008: 'Please select the order to be printed! ',
		a1009: 'Dear user, if you have finished printing the order, please refresh the current page to get the latest order status',
		a1010: 'Refresh',
		a1011: 'Refresh the page',
		a1012: 'Continue to print all',
		a1013: 'Remove duplicates and continue printing',
		a1014: 'Address management',
		a1015: 'Consignee',
		a1016: 'Details of failure to generate waybill',
		a1017: 'Reason for generation failure',
		a1018: 'Select delivery logistics',
		a1019: 'Select Logistics',
		a1020: 'Volume/cm',
		a1021: 'Actual freight',
		a1022: 'Waybill number',
		a1023: 'Length/cm',
		a1024: 'Width/cm',
		a1025: 'Height/cm',
		a1026: 'Pure number',
		a1027: 'Currency',
		a1028: 'Waybill number',
		a1029: 'Set default shipping address',
		a1030: 'Set default delivery address',
		a1031: 'Self-built logistics bill',
		a1032: 'Batch generate face list & picking list',
		a1033: 'Batch printing face list & picking list',
		a1034: "Fill in and modify the consignor's detailed information",
		a1035: 'View historical print records',
		a1036: 'One-click print default face sheet',
		a1037: 'Online inventory',
		a1038: 'Quantity to be dispatched',
		a1039: 'Fill in the delivery logistics of the self-built form',
		a1040: 'Fill in the charges for the test warehouse',
		a1041: 'Please enter the height',
		a1042: 'Please enter the length, width and height of the item',
		a1043: 'Please enter the width',
		a1044: 'Please select logistics',
		a1045: 'Please enter the weight',
		a1046: 'The logistics delivery information has been successfully submitted! ',
		a1047: 'The red asterisk is required, please fill in! ',
		a1048: 'No seller notes',
		a1049: 'Please fill in the reason for returning for review',
		a1050: 'Normal order',
		a1051: 'Currently contains ungenerated waybill numbers, or orders that are being generated, confirm all generated waybill numbers before printing!',
		a1052: 'Using this mode to print the form will cause the browser to pop up multiple form windows, please try to choose the same seller and the same logistics order to print',
		a1053: 'I see, continue to print',
		a1054: 'Background bill of lading data error, please regenerate the waybill number, and then confirm to print the bill of lading! ',
		a1055: 'Orders with ungenerated waybill numbers, please confirm the generated waybill numbers before printing! ',
		a1056: 'Please confirm that all orders have generated waybill numbers before printing! ',
		a1057: 'Please set the default delivery address before printing',
		a1058: 'Please set the default delivery address before printing',
		a1059: 'Currently selected',
		a1060: 'In order, yes',
		a1061: 'A waybill number has not been generated for an order or is being generated, please confirm that all the selected orders have generated a waybill number before printing',
		a1062: 'In the order, there will be',
		a1063: 'This order will be printed repeatedly, confirm whether to continue printing? ',
		a1064: 'To be confirmed by the seller',
		a1065: 'Warehouse management',
		a1066: 'Warehouse item',
		a1067: 'Warehouse package',
		a1068: 'Warehouse gift',
		a1069: 'The warehouse is in transit',
		a1070: 'Purchasing Management',
		a1071: 'Recharge now',
		a1072: 'Settled in local stores',
		a1073: 'Overseas Warehouse Quotation',
		a1074: 'Pure ERP quotation',
		a1075: 'QR code conversion',
		a1076: 'Inquiry list',
		a1077: 'Save Binding',
		a1078: 'Add the item on the left to the binding on the right',
		a1079: 'Select product',
		a1080: 'Will bind goods',
		a1081: 'Add',
		a1082: 'Normal',
		a1083: 'Removed',
		a1084: 'First question setting',
		a1085: 'Knowledge base settings',
		a1086: 'Keyword setting',
		a1087: 'Current and',
		a1088: 'Visitor',
		a1089: 'Remaining delivery time overtime',
		a1090: 'Order reminder',
		a1091: 'Thailand',
		a1092: 'Malay',
		a1093: 'Reminder for balance payment',
		a1094: 'Fill in information',
		a1095: 'Modify remarks',
		a1096: 'Modify network purchase order number',
		a1097: 'Multiple purchase orders are separated by commas (,)',
		a1098: 'Custom attribute',
		a1099: 'Modify the transit warehouse',
		a1100: 'Modify supplier',
		a1101: 'Modify purchase remarks',
		a1102: 'Modify waybill number',
		a1103: 'Status change history',
		a1104: 'Add comment',
		a1105: 'Details',
		a1106: 'Update purchase order status',
		a1107: 'Modify quantity',
		a1108: 'Advance payment ratio/%',
		a1109: 'Access payment cycle/day',
		a1110: 'Attribute name',
		a1111: 'Attribute value',
		a1112: 'Transit warehouse',
		a1113: 'Supplier',
		a1114: 'Review time',
		a1115: 'Reviewer ID',
		a1116: 'Audit Status',
		a1117: 'Review Remarks',
		a1118: 'Picture preview',
		a1119: 'Product image',
		a1120: 'Product information',
		a1121: 'Purchase Warehouse Inventory',
		a1122: 'After automatic update is enabled for all bound online links, this quantity will be synchronized, online inventory=inventory in warehouse-locked inventory-pending inventory',
		a1123: 'The inventory of the single item in the warehouse is the actual remaining quantity that is currently in the warehouse and has not been released',
		a1124: 'Purchase product category ID',
		a1125: 'Purchase Quantity',
		a1126: 'Purchase unit price',
		a1127: 'Purchasing Remarks',
		a1128: 'Please enter a note (optional)',
		a1129: 'Add a new transit warehouse',
		a1130: 'Please enter the warehouse name',
		a1131: 'Transit warehouse',
		a1132: 'Warehouse ID',
		a1133: 'Supplier address',
		a1134: 'Settlement method',
		a1135: 'Payment cycle/day',
		a1136: 'Add supplier',
		a1137: 'Payment method:',
		a1138: 'Transportation method',
		a1139: 'Update supplier information',
		a1140: 'Payment cycle',
		a1141: 'Supplier name',
		a1142: 'Please enter the product name keyword, purchase order number or domestic waybill number',
		a1143: 'Purchase Warehouse',
		a1144: 'Public Purchaser',
		a1145: 'Purchase order number',
		a1146: 'Paid the first payment',
		a1147: 'The balance payment has been paid',
		a1148: 'Distribution platform products',
		a1149: 'Purchasing products',
		a1150: 'Purchase demand initiator',
		a1151: 'Buyer',
		a1152: 'Purchasing Team Leader',
		a1153: 'Whether to transfer',
		a1154: 'The latest status update time',
		a1155: 'Purchase Status',
		a1156: 'Remarks',
		a1157: 'Straight hair',
		a1158: 'Need transfer',
		a1159: 'Wait',
		a1160: 'Level one review',
		a1161: 'Second level review',
		a1162: 'Need to pay the balance',
		a1163: 'This purchase order should pay the total points',
		a1164: 'Prepayment ratio',
		a1165: 'First installment payable',
		a1166: 'The warehouse is located',
		a1167: 'Product size',
		a1168: 'Product weight',
		a1169: 'Position',
		a1170: 'Commodity purchase price',
		a1171: 'Store in warehouse',
		a1172: 'Modify purchase quantity',
		a1173: 'Supplier basic information',
		a1174: 'Purchase order basic information',
		a1175: 'Net purchase order',
		a1176: 'Domestic waybill number',
		a1177: 'Purchase order remarks',
		a1178: 'Estimated arrival time',
		a1179: 'Custom attribute value',
		a1180: 'There is no custom attribute value',
		a1181: 'Comment on purchase order',
		a1182: 'There is no purchase order comment',
		a1183: 'Add a new comment',
		a1184: 'Reviewer',
		a1185: 'Comment content',
		a1186: 'Not passed',
		a1187: 'Pass',
		a1188: 'Update',
		a1189: 'Create warehouse',
		a1190: 'Purchase Order',
		a1191: 'Purchase order search',
		a1192: 'Manually create a purchase order',
		a1193: 'Create supplier',
		a1194: 'Supplier list',
		a1195: 'My transit warehouse',
		a1196: 'No product information',
		a1197: 'See more',
		a1198: 'Hidden products',
		a1199: 'Remaining',
		a1200: 'Total',
		a1201: 'Products',
		a1202: 'View status change history',
		a1203: 'Audit',
		a1204: 'Settlement Balance',
		a1205: 'By purchase order number',
		a1206: 'Product sku',
		a1207: 'All status',
		a1208: 'Audit rejected',
		a1209: 'Waiting for level one review',
		a1210: 'Waiting for the second level review',
		a1211: 'Purchasing',
		a1212: 'On the way to the transit warehouse',
		a1213: 'Arrived in the transit warehouse',
		a1214: 'On the way to the terminal warehouse',
		a1215: 'Arrived at the terminal warehouse',
		a1216: 'Has been stored',
		a1217: 'Land transportation',
		a1218: 'Sea Freight',
		a1219: 'Air Freight',
		a1220: 'Cash',
		a1221: 'Online',
		a1222: 'Bank card',
		a1223: 'Settlement balance successful',
		a1224: 'Demand initiation:',
		a1225: 'Purchasing personnel:',
		a1226: 'Purchase Status:',
		a1227: 'Added successfully',
		a1228: 'Refresh successfully',
		a1229: 'Please fill in the purchase price of the product',
		a1230: 'Rejected',
		a1231: 'Update successful',
		a1232: 'Deleted successfully',
		a1233: 'Please select the status to be updated',
		a1234: 'Update status successful',
		a1235: 'The order has not passed the review and cannot modify the status',
		a1236: 'The purchase order item has been put into storage, and the status cannot be modified',
		a1237: 'Supplier created successfully! ',
		a1238: 'Dear user, if you have already submitted a purchase order, please refresh the current page to obtain all the latest purchase orders',
		a1239: 'Basic information',
		a1240: 'Commodity link:',
		a1241: 'Description',
		a1242: 'Product image',
		a1243: 'Attribute name',
		a1244: 'Attribute type',
		a1245: 'Commodity Specifications',
		a1246: 'Please enter the parent SKU',
		a1247: 'Fill in attributes',
		a1248: 'Unified settings',
		a1249: 'Fill in inventory',
		a1250: 'Fill in sku',
		a1251: 'Specification sku',
		a1252: 'Retail price',
		a1253: 'Commodity weight',
		a1254: 'Commodity size',
		a1255: 'Long',
		a1256: 'Width',
		a1257: 'High',
		a1258: 'Expected profit',
		a1259: 'Is it quality inspection',
		a1260: 'Product keywords',
		a1261: 'Sales Status',
		a1262: 'Purchase cost',
		a1263: 'Product Supplier',
		a1264: 'Product Warehouse',
		a1265: 'Picture information',
		a1266: 'Cover image',
		a1267: 'Product attributes',
		a1268: 'Add new attribute',
		a1269: 'Common attributes',
		a1270: 'Specification attribute',
		a1271: 'Specification stock',
		a1272: 'Multiple specifications',
		a1273: 'Type',
		a1274: 'Specification type',
		a1275: 'Retail original price',
		a1276: 'Logistics information',
		a1277: 'Other information',
		a1278: 'Update product information',
		a1279: 'Return',
		a1280: 'Quality inspection required',
		a1281: 'Exempt from inspection',
		a1282: 'Please enter the product name',
		a1283: 'No more than 255 characters',
		a1284: 'Please fill in the description of the product',
		a1285: 'Please select a category',
		a1286: 'Please select a specification',
		a1287: 'Please fill in the weight',
		a1288: 'Please fill in the product specification',
		a1289: 'Please fill in the product attributes',
		a1290: 'Please enter the parent sku of the product',
		a1291: 'On the shelves',
		a1292: 'Off the shelf',
		a1293: 'Blue',
		a1294: 'Source data',
		a1295: 'Shop Xiaosheng Retail Mall',
		a1296: 'Add to product library',
		a1297: 'Please select the store to publish according to the site! ',
		a1298: 'Please select a store! ',
		a1299: 'The attribute is required, please fill in the attribute! ',
		a1300: 'Please fill in the price and stock, and neither of them can be 0',
		a1301: 'Product weight is required, and cannot be 0, please fill in! ',
		a1302: 'Logistics is required, please select logistics',
		a1303: "The product has been put on the shelves to Xiaosheng's retail mall! ",
		a1304: 'The logistics information has been synchronized to the latest! ',
		a1305: 'Thailand Station',
		a1306: 'Philippine Station',
		a1307: 'Indonesia station',
		a1308: 'Malay Station',
		a1309: 'Taiwan station',
		a1310: 'Vietnam station',
		a1311: 'Are you sure to delete',
		a1312: 'Currently, the specifications of the product can be set up to two levels! ',
		a1313: 'Confirm the products on the shelves? ',
		a1314: 'The product is on the shelves! ',
		a1315: 'Template created successfully! ',
		a1316: 'Please choose a store to release products according to the site! ',
		a1317: 'Please fill in the price and stock',
		a1318: 'The change value cannot be empty',
		a1319: 'Unable to match',
		a1320: 'Currently shared',
		a1321: 'A product cannot be automatically matched and bound to a warehouse product, you can modify the product sku to be consistent with the warehouse sku and then bind it again or manually bind',
		a1322: 'There is no warehouse sku',
		a1323: 'Supply price:',
		a1324: ', Please fill in the original retail price',
		a1325: 'Please select the products that need to be purchased and stored',
		a1326: 'Records',
		a1327: 'Search warehouse code, sku, product name',
		a1328: 'Generate storage order',
		a1329: 'Product storage',
		a1330: 'Purchase order product storage',
		a1331: 'Cancel all storage of current products',
		a1332: 'Select all current products into storage',
		a1333: 'Unselect',
		a1334: 'Select storage',
		a1335: 'Expand to see more',
		a1336: 'Hide up',
		a1337: 'One',
		a1338: 'Purchase order status filter',
		a1339: 'Independent package',
		a1340: 'All items and packages',
		a1341: 'Single product library',
		a1342: 'Package library',
		a1343: 'Fill in the price',
		a1344: 'Please select the bound warehouse product',
		a1345: 'Collection succeeded',
		a1346: 'Product Status',
		a1347: 'There is no template information',
		a1348: 'Whether to pre-sale',
		a1349: 'Total inventory',
		a1350: 'Total sales',
		a1351: 'Commodity Status',
		a1352: 'Retail Mall',
		a1353: 'Released',
		a1354: 'Unpublished',
		a1355: 'Release',
		a1356: 'Copy',
		a1357: 'Attribute',
		a1358: 'Hidden',
		a1359: 'Please select a store',
		a1360: 'Status on shelves',
		a1361: 'Attribute selection',
		a1362: 'Please select a unit',
		a1363: 'Whether second-hand:',
		a1364: 'Country area:',
		a1365: 'Product link:',
		a1366: 'Other specifications',
		a1367: 'Add a new specification',
		a1368: 'Product Details',
		a1369: 'Property ID',
		a1370: 'Product ID',
		a1371: 'Time type',
		a1372: 'Expected selling price',
		a1373: 'Search criteria',
		a1374: 'Product',
		a1375: 'Click to modify the information to fill in',
		a1376: 'Is it a single product',
		a1377: 'Shop Category',
		a1378: 'Fourth category',
		a1379: 'Five-level category',
		a1380: 'Brand new',
		a1381: 'Second-hand',
		a1382: 'Add attribute',
		a1383: 'Select all',
		a1384: 'Synchronous logistics mode',
		a1385: 'Save and publish',
		a1386: 'Save template',
		a1387: 'Only save the template',
		a1388: 'Immediate release',
		a1389: 'Basic product information',
		a1390: 'Product description',
		a1391: 'Product sku name',
		a1392: 'Product purchase cost',
		a1393: 'Product sales status',
		a1394: 'Product address',
		a1395: 'Product Owner',
		a1396: 'Product attribute information',
		a1397: 'Modification time',
		a1398: 'Product logistics information',
		a1399: 'Product length',
		a1400: 'Product width',
		a1401: 'Product height',
		a1402: 'Sub-sku attribute information',
		a1403: 'Expand all',
		a1404: 'Product Filter',
		a1405: 'Modify information',
		a1406: 'Approved',
		a1407: 'Approved',
		a1408: 'All sites',
		a1409: 'Select warehouse:',
		a1410: 'Supplier:',
		a1411: 'The template is saved successfully! ',
		a1412: 'The audit is successful, please go to product management to release the product on the shelf',
		a1413: 'The audit is successful, enter the product management for release',
		a1414: 'Saved modification',
		a1415: 'Are you sure to release it to the Xiaosheng retail mall? ',
		a1416: 'Please select a product! ',
		a1417: 'The product has been discontinued! ',
		a1418: 'Copy successfully! ',
		a1419: 'Are you sure you want to delete this master template? ',
		a1420: 'Draft box',
		a1421: 'Site',
		a1422: 'Re-edit',
		a1423: 'Update picture',
		a1424: 'Select the parent sku that needs to be bound',
		a1425: 'Search cusCode / parent sku / child sku',
		a1426: 'Sub sku information',
		a1427: 'Template watermark (upload PNG watermark image with size 800*800px/500*500px)',
		a1428: 'Select site',
		a1429: 'Commodity parent SKU',
		a1430: 'Loading image watermark, please wait! ',
		a1431: 'Apply all pictures',
		a1432: 'Only apply the first image',
		a1433: 'Add product image',
		a1434: 'Automatic binding',
		a1435: 'Manual binding',
		a1436: 'Bound',
		a1437: 'Set retail price calculation formula',
		a1438: 'Local retail original price',
		a1439: 'Deleted! ',
		a1440: 'The current record has been stored in the draft box',
		a1441: 'The number of characters in the description information of the product can only be 2-3000 characters',
		a1442: 'Product sku cannot contain illegal characters, such as: Chinese/special characters',
		a1443: 'Product sku, title, and description cannot contain illegal characters, such as: Chinese/special characters',
		a1444: 'The first-level specification attribute cannot be deleted',
		a1445: ', please fill in',
		a1446: 'Local original retail price',
		a1447: 'Cannot be empty',
		a1448: 'New',
		a1449: 'Reset',
		a1450: 'Buyer account details (can only create up to 5 buyer accounts)',
		a1451: 'Purchaser Account',
		a1452: "Buyer's nickname",
		a1453: 'New buyer account',
		a1454: 'Team leader',
		a1455: 'Set as group leader',
		a1456: 'Add a new buyer account (register up to 5 purchasing accounts)',
		a1457: "Enter the buyer's nickname",
		a1458: 'Enter login password',
		a1459: 'Confirm login password',
		a1460: "Purchaser's nickname is required",
		a1461: 'Password is required',
		a1462: 'Select purchase product',
		a1463: 'Add selected product',
		a1464: 'Wholesale price in China',
		a1465: 'Purchase details',
		a1466: 'Submit',
		a1467: 'Purchase warehouse:',
		a1468: 'Method:',
		a1469: 'Transit warehouse:',
		a1470: 'Purchase method:',
		a1471: 'Ordinary buyer',
		a1472: 'Buyer:',
		a1473: 'Public Purchaser:',
		a1474: "If you don't choose to default to yourself",
		a1475: 'Please select public procurement',
		a1476: 'Purchasing team leader:',
		a1477: 'Set the leader',
		a1478: 'Automatically fill in after selecting a supplier',
		a1479: 'Add multiple net purchase orders',
		a1480: 'Add the custom attribute you need for the purchase order',
		a1481: 'Clear selected products',
		a1482: 'Add product',
		a1483: 'Net purchase order number:',
		a1484: 'Purchase order remarks:',
		a1485: 'China waybill number:',
		a1486: 'Demand initiator',
		a1487: 'Setting succeeded',
		a1488: 'No procurement team leader selected',
		a1489: 'The two input passwords are inconsistent',
		a1490: 'Your buyer account number:',
		a1491: ', Password:',
		a1492: 'Please add products before submitting',
		a1493: 'The purchase order was successfully created, go to the purchase order page to view',
		a1494: 'Please select the purchasing warehouse first',
		a1495: 'Purchase cost price',
		a1496: 'Submit purchase order',
		a1497: 'Need to consume points',
		a1498: 'Return to distribution platform',
		a1499: 'Go to the purchase order management page',
		a1500: 'Purchase amount',
		a1501: 'Generate warehouse products',
		a1502: 'Commodity created successfully!',
		a1503: 'Total quantity purchased by the seller this time',
		a1504: 'Total quantity with the actual arrival of the warehouse',
		a1505: 'Consistent',
		a1506: 'Difference',
		a1507: 'Warning',
		a1508: 'Details of the confirmed storage order',
		a1509: 'Seller Purchase Quantity',
		a1510: 'Actual arrival quantity',
		a1511: 'To be paid by the seller',
		a1512: 'Paid',
		a1513: 'Cubic meters',
		a1514: 'Pricing Standard',
		a1515: 'Total cargo volume',
		a1516: 'Weight',
		a1517: 'Points payable',
		a1518: 'Confirm payment',
		a1519: 'Print product SKU barcode',
		a1520: 'Print the barcode of the storage order',
		a1521: 'Barcode printing',
		a1522: 'Print Quantity',
		a1523: 'The seller confirms the storage information',
		a1524: 'There is a discrepancy, please contact the warehouse to verify the details! ',
		a1525: 'Purchase price',
		a1526: 'The actual quantity of goods arriving in the warehouse',
		a1527: 'No message yet',
		a1528: 'Return heavy core',
		a1529: 'Confirm storage',
		a1530: 'Warehouse management',
		a1531: 'Acquiring storage order data, please wait a moment! ',
		a1532: 'Estimated arrival',
		a1533: 'Actual arrival',
		a1534: 'First trip fee',
		a1535: 'View & Modify',
		a1536: 'Print barcode',
		a1537: 'Payment successful! ',
		a1538: 'Waiting for confirmation from the shopkeeper',
		a1539: 'Paid for the first trip',
		a1540: 'The shopkeeper is checking the information of the invoice, please wait patiently! ',
		a1541: 'Please check the product! ',
		a1542: 'Current order status does not allow deletion! ',
		a1543: 'This operation will permanently delete the current storage order, do you want to continue?',
		a1544: 'It has been returned to the warehouse for re-checking! ',
		a1545: "There is a difference between the seller's purchase quantity and the warehouse's actual receipt quantity. Do you want to continue to confirm the storage operation? ",
		a1546: 'Yes',
		a1547: 'Payment is required for this confirmation of warehousing',
		a1548: 'Points, and additional deductions are required',
		a1549: 'Warehouse miscellaneous fees of points',
		a1550: 'Additional deduction is required for this warehousing',
		a1551: 'Points',
		a1552: 'OK',
		a1553: "There is a difference between the seller's storage quantity and the warehouse's actual verification quantity! ",
		a1554: 'Storage status',
		a1555: 'Creation time of storage order',
		a1556: 'Scan into storage',
		a1557: 'Storage Warehouse',
		a1558: 'Seller',
		a1559: 'Additional storage fee',
		a1560: 'Fill in pure numbers',
		a1561: 'Confirm receipt',
		a1562: 'Length/cm(required)',
		a1563: 'Width/cm(required)',
		a1564: 'Height/cm(required)',
		a1565: 'Weight/kg (required)',
		a1566: 'Enter a message for the seller',
		a1567: 'Please fill in the length, width, height and weight of the product! ',
		a1568: 'The quantity purchased by the seller is consistent with the actual quantity delivered by the warehouse. Do you confirm the receipt? ',
		a1569: "The seller's purchase quantity is inconsistent with the actual arrival quantity of the warehouse. Do you want to continue to confirm the receipt? ",
		a1570: 'Successfully submitted to the seller for confirmation! ',
		a1571: 'All sellers',
		a1572: 'Confirmed purchase order',
		a1573: 'Query type',
		a1574: 'Query value',
		a1575: 'View monitoring pricing rules',
		a1576: 'Online product',
		a1577: 'National currency',
		a1578: 'Price',
		a1579: "Bind opponent's product",
		a1580: 'Monitored product',
		a1581: 'Event ID',
		a1582: 'Activity price',
		a1583: 'Expiration time',
		a1584: 'Unbind',
		a1585: 'Monitoring price trend',
		a1586: 'Modify monitoring rules',
		a1587: 'Modify discount product information',
		a1588: 'Default',
		a1589: 'Activity name',
		a1590: 'Active area',
		a1591: 'Please select an active area',
		a1592: 'Area 1',
		a1593: 'Area 2',
		a1594: 'Activity time',
		a1595: 'Instant Delivery',
		a1596: 'Activity nature',
		a1597: 'Gourmet/restaurant online activities',
		a1598: 'Ground push activity',
		a1599: 'Offline activities',
		a1600: 'Pure brand exposure',
		a1601: 'Special resource',
		a1602: 'Online brand sponsorship',
		a1603: 'Offline venues are free',
		a1604: 'Activity form',
		a1605: 'Add discount product information',
		a1606: 'Event end time',
		a1607: 'Active product',
		a1608: 'Price before the event',
		a1609: 'Event Price',
		a1610: 'Limited number of purchases',
		a1611: "Binding the user's product and the opponent's product",
		a1612: 'Get page products',
		a1613: 'Monitor reserve price:',
		a1614: 'Price reduction strategy:',
		a1615: 'Down-regulation value:',
		a1616: 'Bind the selected product',
		a1617: 'Rule one',
		a1618: 'Rule 2',
		a1619: 'All prices are based on the monitored lowest price',
		a1620: 'Are you sure you want to unbind this product? ',
		a1621: 'This function has not been launched yet. ',
		a1622: 'Reduce by 0.01%',
		a1623: 'Default down by 0.01%',
		a1624: 'Do not adjust',
		a1625: 'Reduce the fixed value',
		a1626: 'Custom down percentage',
		a1627: 'Please enter a note',
		a1628: 'Product Image',
		a1629: 'Product sub-SKU',
		a1630: 'Pricing rules',
		a1631: 'Price monitoring chart',
		a1632: 'Last monitoring price',
		a1633: 'Search by product name',
		a1634: 'Query based on parent sku',
		a1635: 'All products',
		a1636: 'Already on the shelves',
		a1637: 'Commodity banned',
		a1638: 'Deleted product',
		a1639: 'Please set the start interval to be smaller than the end interval. ',
		a1640: 'Please enter a time interval less than 15 days. ',
		a1641: 'Confirm to close? ',
		a1642: 'Expired',
		a1643: 'In progress',
		a1644: 'Unbind the product successfully! ',
		a1645: 'Modify the rules successfully! ',
		a1646: 'Responsible for the store',
		a1647: 'Choose a bound store, you can choose more than one! ',
		a1648: 'Select the store to bind (multiple choices)',
		a1649: 'Create group',
		a1650: 'Group name',
		a1651: 'Cost cycle',
		a1652: 'Quarter',
		a1653: 'Month',
		a1654: 'Total cost of custom items',
		a1655: 'Add new expense item',
		a1656: 'Get historical fees',
		a1657: 'Charge name',
		a1658: 'Expense name, such as: labor costs',
		a1659: 'Fee Amount',
		a1660: 'Year',
		a1661: 'Year',
		a1662: 'Month',
		a1663: 'Shop custom fee details',
		a1664: 'Group custom fee details',
		a1665: 'The expense item has been added successfully! ',
		a1666: 'Modify the fee successfully! ',
		a1667: 'Please confirm whether you want to delete this expense item?',
		a1668: 'Please fill in the content as required! ',
		a1669: 'Period',
		a1670: 'Select month',
		a1671: 'Select year',
		a1672: 'Select quarter',
		a1673: 'Reload the current page',
		a1674: 'Shop',
		a1675: 'Paid order amount (sales)',
		a1676: 'Sales chain growth rate',
		a1677: 'Advertising fee',
		a1678: 'Goods purchase cost',
		a1679: 'Claim successful amount',
		a1680: 'Return refund amount',
		a1681: 'First journey transportation cost',
		a1682: 'No store bound yet',
		a1683: 'Advertising costs',
		a1684: 'Profit',
		a1685: 'Profit rate',
		a1686: 'Comprehensive score',
		a1687: 'Other custom expense items',
		a1688: 'View custom fees',
		a1689: 'Delete group',
		a1690: 'Q1',
		a1691: 'Second quarter',
		a1692: 'Q3',
		a1693: 'Quarter 4',
		a1694: 'Headway transportation cost: only need to fill in each batch of headway warehousing form accurately, then the freight cost attributable to each batch can be automatically calculated. For example, different batches of air freight and sea freight have different costs. ',
		a1695: 'Currently only supports automatic acquisition of Shopee advertising fees, other platform advertising fees need to add custom fee items',
		a1696: 'Profit = Sales - Goods Purchase Cost - Headway Transportation Cost - Advertising Expenses - Other Custom Expense Items + Successful Claim Amount',
		a1697: 'Goods purchase cost: the actual purchase cost of the goods, which is automatically calculated from the purchase cost of inventory products',
		a1698: 'Are you sure you want to unbind the store?',
		a1699: 'Unbind successfully',
		a1700: 'Successfully bound! ',
		a1701: 'Delete group successfully! ',
		a1702: 'Group created successfully! ',
		a1703: 'Distributors are not allowed to distribute their own products! ',
		a1704: 'I want a sample',
		a1705: 'Scan to contact the distribution customer service to obtain samples',
		a1706: 'WeChat ID',
		a1707: 'Loading...',
		a1708: 'Successful distribution! ',
		a1709: 'Distribution failed',
		a1710: 'Account or password cannot be empty! ',
		a1711: 'Successful login! ',
		a1712: 'Spot distribution products',
		a1713: '1 Piece on behalf of the price',
		a1714: 'Spot quantity',
		a1715: 'Distribute immediately',
		a1716: 'Stock stock',
		a1717: 'Product Details',
		a1718: "Please log in to the store's Xiaosheng account to redistribute products! ",
		a1719: 'Do you want to continue to distribute this product? ',
		a1720: 'Successful distribution! Subsequent products to be put on the shopee platform, please go to the shopee distribution platform "I am an agent" to put on the shelves! ',
		a1721: 'Go to the store to put products on the shelves',
		a1722: 'Continue to distribute products',
		a1723: 'Contact customer service',
		a1724: 'If you need to obtain distribution samples, please scan the QR code to contact the customer service of the distribution platform! ',
		a1725: 'Free use of Shopee data analysis tools',
		a1726: 'Shrimp shell analysis plug-in',
		a1727: 'Click to download',
		a1728: 'Shopee main picture',
		a1729: 'Shopee soaring index',
		a1730: 'Shopee monthly sales',
		a1731: 'Shopee monthly sales',
		a1732: 'Shopee shelf days',
		a1733: 'Shopee lowest price',
		a1734: 'Shopee conversion index',
		a1735: 'View source link',
		a1736: 'Download Dianxiaosheng APP now',
		a1737: 'Hot list of spot goods distribution in Southeast Asia',
		a1738: 'Hot Recommendation List',
		a1739: 'Search product name',
		a1740: 'Spot inventory',
		a1741: 'Market Analysis',
		a1742: 'I want to distribute',
		a1743: 'There is no associated data',
		a1744: 'Spot distribution platform in Southeast Asia',
		a1745: 'Distribution product details',
		a1746: 'Please enter a message',
		a1747: 'Sku specification',
		a1748: 'Spot inventory:',
		a1749: 'This product has been successfully distributed to your Shopee account. If you want to release the product to the shopee platform, please go to the distribution platform on the PC side: I am an agent, continue to operate! ',
		a1750: 'Send verification code',
		a1751: 'Register',
		a1752: 'Registered, click to log in',
		a1753: 'Please enter your phone number',
		a1754: 'Please enter the user password',
		a1755: 'Please enter user nickname',
		a1756: 'Optional',
		a1757: 'Email account',
		a1758: 'Please fill in the registration information, it cannot be empty! ',
		a1759: 'Successful registration, please log in! ',
		a1760: 'The verification code has been sent, pay attention to check it! ',
		a1761: 'Please fill in the mobile phone number! ',
		a1762: 'Distribution homepage',
		a1763: 'I can supply',
		a1764: 'Customer service contact',
		a1765: 'Log in now',
		a1766: 'Exit the current login',
		a1767: 'Southeast Asia/Taiwan spot distribution platform',
		a1768: 'Spot goods in Southeast Asia, one dropshipping',
		a1769: 'Precise inventory, associated binding, prevent oversold',
		a1770: 'Support Shopee/Lazade/Shopify local sellers',
		a1771: 'Invite distribution',
		a1772: 'Recommended distribution products',
		a1773: 'View shopee related information',
		a1774: 'Location',
		a1775: "Currently not logged in, please log in to the store's Xiaosheng account before proceeding with the distribution operation!",
		a1776: 'The current login has been logged out! ',
		a1777: "Please log in to the store's Xiaosheng account before distributing! ",
		a1778: 'Successful distribution, please click I have acted as an agent to release products in the future! ',
		a1779: 'Shop niche users:',
		a1780: "You are sincerely invited to distribute his spot products, one drop shipping, to increase the seller's net profit! ",
		a1781: 'I have been represented',
		a1782: 'The current status is not logged in, please log in! ',
		a1783: 'There are no agent products yet! ',
		a1784: 'The current login account has been logged out! ',
		a1785: 'Account',
		a1786: 'The number of bound stores',
		a1787: 'Associated warehouse quantity',
		a1788: 'The number of remaining points',
		a1789: 'Erp system focusing on cross-border sellers in Southeast Asia',
		a1790: 'Bei analysis free product selection plug-in',
		a1791: 'Mobile terminal',
		a1792: 'System Guidance Document',
		a1793: 'Technical Support',
		a1794: 'New message',
		a1795: 'Logout',
		a1796: 'No news!',
		a1797: 'Latest news',
		a1798: 'Unread messages',
		a1799: 'Reply',
		a1800: 'From',
		a1801: 'Important reminders from the system',
		a1802: 'View all messages',
		a1803: 'No session message',
		a1804: 'Enable secondary password',
		a1805: 'After setting, sensitive financial data such as gross profit and purchase price need to be displayed after entering a second password',
		a1806: 'Number of paid orders',
		a1807: 'Note: After the secondary password is enabled, it will not be able to be closed. It involves sensitive financial data such as gross profit and purchase price. It can only be displayed after entering the secondary password! ',
		a1808: 'Please enter the secondary password',
		a1809: 'Change the secondary password',
		a1810: 'Overview',
		a1811: 'Commodity purchase advance payment expenditure',
		a1812: 'Commodity purchase advance payment income',
		a1813: 'The final payment for commodity purchase',
		a1814: 'The fee paid by the purchaser to the platform in advance payment for commodity purchase',
		a1815: 'The commission obtained from the commodity purchase prepayment system',
		a1816: 'Exchange rate modified successfully',
		a1817: 'Secondary password set successfully! ',
		a1818: 'Sku sales overview',
		a1819: 'Value',
		a1820: 'Quantity in warehouse',
		a1821: 'Average sales/day (nearly 7 days)',
		a1822: 'Recent storage time',
		a1823: 'Nearly 30 days',
		a1824: 'Nearly 7 days',
		a1825: 'Nearly 3 days',
		a1826: 'Total sales in the current time period',
		a1827: 'Warehouse selection',
		a1828: 'Export excel file',
		a1829: 'Replenishment cycle (days)',
		a1830: 'Warehouse product query',
		a1831: 'Find warehouse code/sku name',
		a1832: 'Create storage',
		a1833: 'Check sku sales',
		a1834: 'Out of stock reminder',
		a1835: 'Deduction details',
		a1836: 'Details',
		a1837: 'Point deduction',
		a1838: 'Deduction description',
		a1839: 'Expenditure Details',
		a1840: 'Points records',
		a1841: 'Order number query',
		a1842: 'Fee Type',
		a1843: 'Integral change',
		a1844: 'Payment source',
		a1845: 'View deduction details',
		a1846: 'All warehouses',
		a1847: 'Point update',
		a1848: 'Confirm to continue the operation, the current point fee will be changed to:',
		a1849: ' Integral, do you want to continue the update operation! ',
		a1850: 'Yes, update now',
		a1851: 'Points updated successfully! ',
		a1852: 'Point update failed, the new charging rules are consistent with the current one! ',
		a1853: 'Charge the seller "',
		a1854: '" Warehouse miscellaneous fees',
		a1855: 'Warehouse for miscellaneous fees',
		a1856: "Deduct the seller's points",
		a1857: 'Remarks for deduction of miscellaneous expenses',
		a1858: 'Seller Offer',
		a1859: 'Add new offer',
		a1860: 'Preferential discount (value between 0 and 1): 0: free, 1: no discount, 0.95: 95% off',
		a1861: 'Warehouse',
		a1862: 'Preferential discount',
		a1863: 'Number of associated seller users',
		a1864: 'Ample points',
		a1865: 'Points in arrears',
		a1866: 'Seller Account',
		a1867: 'Status of remaining points',
		a1868: 'Currently less than 30 points, please remind the user to allow the value in time! ',
		a1869: 'Set discount',
		a1870: 'Charge miscellaneous fees',
		a1871: 'Hidden seller',
		a1872: 'Show seller',
		a1873: 'The value range is between 0 and 1',
		a1874: 'Material fee',
		a1875: 'Shelfing fee',
		a1876: 'Storage fee',
		a1877: 'Default SKU overcharge',
		a1878: 'Overcharge for the same sku',
		a1879: 'The setting is successful!',
		a1880: 'The deducted points cannot be 0! ',
		a1881: 'Remarks cannot be empty! ',
		a1882: 'Successfully charged miscellaneous fees! ',
		a1883: 'The value range is between 0.6 and 1',
		a1884: 'The preferential value of the service fee must be between 0.6 and 1, and cannot be less than 0.6',
		a1885: 'Warehouse overview',
		a1886: 'Pending order',
		a1887: 'Processing orders today',
		a1888: "Today's point income",
		a1889: 'The sub-warehouse of the current warehouse account',
		a1890: 'Zicang nickname',
		a1891: 'Sub-warehouse Id',
		a1892: 'Sub-warehouse type',
		a1893: 'Test product warehouse',
		a1894: 'Overseas cloud warehouse',
		a1895: 'Private warehouse',
		a1896: 'Alliance Warehouse',
		a1897: 'Distribution Warehouse',
		a1898: "Purchaser's phone number",
		a1899: 'Inquiry time',
		a1900: 'Commodity List',
		a1901: 'Product name',
		a1902: 'Cost price (only valid integers or decimals can be entered)',
		a1903: 'Select warehouse...',
		a1904: 'Commodity binding status',
		a1905: 'Receiving warehouse',
		a1906: 'Clear',
		a1907: 'Submit',
		a1908: 'Successfully bind the product',
		a1909: 'Has been bound',
		a1910: 'Binding failed',
		a1911: 'Banned',
		a1912: 'Deleted',
		a1913: 'Generate warehouse products',
		a1914: 'Records successfully added',
		a1915: 'All stores',
		a1916: 'Please enter the warehouse code of the product in the warehouse, or add it in the warehouse product! ',
		a1917: 'Please select the store to resync products',
		a1918: 'The product has been synchronized',
		a1919: 'There is currently no product information, please select the product you need to add to the warehouse',
		a1920: 'Please select a receiving warehouse',
		a1921: 'Joined successfully',
		a1922: 'Congratulations, this is a successful message',
		a1923: 'Binding Commodities',
		a1924: "Warehouse products need to be bound to at least one online product. If you don't need this product, you can directly delete the product in the warehouse!",
		a1925: 'Import type',
		a1926: 'Storage type',
		a1927: 'Searchable commodity name, sku',
		a1928: 'Import all with one click',
		a1929: 'Synchronize lazada products',
		a1930: 'Import warehouse products',
		a1931: 'Import in warehouse item library',
		a1932: 'Import combined package library',
		a1933: 'In the warehouse item library',
		a1934: 'Combined package library',
		a1935: 'Shopee data is being updated synchronously, please refresh after a while! ',
		a1936: 'Generated by the currently selected store',
		a1937: 'Generate according to the currently selected category',
		a1938: 'Generate according to the currently selected items',
		a1939: 'Currently there are no products checked! ',
		a1940: 'Are you sure to delete the current product?',
		a1941: 'The lazada data is being updated synchronously, please refresh after a while! ',
		a1942: 'Synchronize SHOPEE products',
		a1943: 'Category',
		a1944: 'Current quantity',
		a1945: 'Currently there is no selected category',
		a1946: 'Batch import in-warehouse products',
		a1947: 'According to the currently selected store, import the item library in the warehouse',
		a1948: 'Import combined package library according to the currently selected store',
		a1949: 'According to the currently selected products, import them into the warehouse order warehouse',
		a1950: 'Import the combined package library according to the currently selected products',
		a1951: 'On the shelves',
		a1952: 'According to the currently selected store, generate the warehouse item library',
		a1953: 'Create a combined package library according to the currently selected store',
		a1954: 'Generate in the warehouse item library according to the currently selected category',
		a1955: 'Generate a combined package library according to the currently selected category',
		a1956: 'Generate in the warehouse order according to the currently selected product',
		a1957: 'Generate a combination package library according to the currently selected products',
		a1958: 'Account Management',
		a1959: 'Mobile phone',
		a1960: 'Please enter the mobile phone verification code',
		a1961: 'New login password',
		a1962: 'Mailbox',
		a1963: 'Please enter the email verification code',
		a1964: 'New password',
		a1965: 'Current phone',
		a1966: 'Change login password',
		a1967: 'Enter a new password',
		a1968: 'Mobile phone verification code',
		a1969: 'Current mailbox',
		a1970: 'Second password',
		a1971: 'Please enter your phone number! ',
		a1972: 'Password changed successfully, logging out, please log in again! ',
		a1973: 'Add address',
		a1974: 'Fill in the consignee',
		a1975: 'Fill in the phone number of the consignee',
		a1976: 'Fill in the detailed address',
		a1977: 'Fill in the zip code',
		a1978: 'Mobile phone/telephone',
		a1979: 'Consignee cannot be empty! ',
		a1980: 'Consignee method cannot be empty! ',
		a1981: 'The address cannot be empty! ',
		a1982: 'Increase success! ',
		a1983: 'Personal information page',
		a1984: 'Information Management Center',
		a1985: 'Account Management',
		a1986: 'Address management',
		a1987: 'Buyer portrait CRM intelligent analysis',
		a1988: 'In the theory of customer management: the cost of developing a new customer is the cost of retaining an old customer',
		a1989: 'Times! ! The maintenance and service of old customers is especially important! ! ! ',
		a1990: "For this reason, Dianxiaosheng's big data team has adjusted the training model and algorithm for one year, and officially launched the customer analysis function for sellers. We combined the characteristics of cross-border e-commerce transactions in Southeast Asia and adopted machine learning algorithm models. According to you",
		a1991: "Purchase frequency/purchase amount/dispute refund probability/latest purchase time of buyer's historical transactions",
		a1992: 'Etc. for analysis. ',
		a1993: 'Smart classification is:',
		a1994: 'High value/high loyalty low value/low loyalty and imminent churn high value',
		a1995: 'Customers, etc., this classification algorithm will help your customer service to further improve customer service and retain customers who may be lost when following up customers. ',
		a1996: 'Try it now',
		a1997: 'Average consumption interval',
		a1998: 'Number of orders (consumption times)',
		a1999: 'The interval between the latest consumption and the present',
		a2000: 'Average consumption premium ratio relative to category average price',
		a2001: 'Total consumption amount',
		a2002: 'Number of rejected orders',
		a2003: 'Buyer Quantitative Analysis',
		a2004: 'Data filter condition',
		a2005: 'Buyer name',
		a2006: 'Loyalty',
		a2007: 'Consumption capacity',
		a2008: 'price sensitivity',
		a2009: 'Purchases',
		a2010: 'Total purchase amount',
		a2011: 'Recent purchase date',
		a2012: 'Buyer name:',
		a2013: 'The interval between the latest consumption and the present',
		a2014: 'Total price',
		a2015: 'Currency',
		a2016: 'Custom buyer group',
		a2017: 'Group name',
		a2018: 'Group description',
		a2019: 'Shared description',
		a2020: 'Move out of description',
		a2021: 'Get historical transaction data',
		a2022: 'Quantized model index training',
		a2023: 'The final classification of buyer portraits',
		a2024: 'Data calculation...',
		a2025: 'Blacklist',
		a2026: 'Cloud blacklist',
		a2027: 'Move into cloud blacklist',
		a2028: 'Remove from cloud blacklist',
		a2029: 'Modify name',
		a2030: 'OK to modify',
		a2031: 'Add a custom group',
		a2032: 'Add now',
		a2033: 'Current stage',
		a2034: 'Current progress',
		a2035: 'Amount of trained data',
		a2036: 'Actual total data volume',
		a2037: 'You have not authorized the store, please authorize first',
		a2038: 'Go to authorization',
		a2039: 'Estimated buyer training volume',
		a2040: 'Authorized store',
		a2041: 'Add authorization',
		a2042: 'Start training',
		a2043: 'Currently your available points',
		a2044: 'Training estimated consumption points',
		a2045: '*Estimated calculation amount may be slightly different from actual calculation amount (within 1% error)',
		a2046: 'Order rejection quantity',
		a2047: 'Purchase time interval',
		a2048: 'Average premium percentage',
		a2049: 'Training has been completed',
		a2050: 'Ready to ship',
		a2051: 'Reship',
		a2052: 'Shipped',
		a2053: 'Waiting for confirmation of receipt',
		a2054: 'Cancelling',
		a2055: 'Returning goods',
		a2056: 'High value',
		a2057: 'Medium value',
		a2058: 'Low value',
		a2059: 'Has been lost',
		a2060: 'Draining',
		a2061: 'Normal',
		a2062: 'Loyalty',
		a2063: 'Low consumption',
		a2064: 'High consumption',
		a2065: 'Price insensitive',
		a2066: 'Price sensitive',
		a2067: 'High consumption power',
		a2068: 'The current points are insufficient, please recharge first',
		a2069: "The current buyer's training volume is 0, and training cannot be performed",
		a2070: 'Currently unauthorized stores, unable to train',
		a2071: 'Shared successfully',
		a2072: 'Add smart customer service translation charging rules',
		a2073: 'Modify the intelligent customer service translation charging rules',
		a2074: 'Charging area',
		a2075: 'Please select a charging area',
		a2076: 'Please select the charging type',
		a2077: 'Charge type',
		a2078: 'Charge interval setting:',
		a2079: 'Charging range',
		a2080: 'Charge fees',
		a2081: 'Times',
		a2082: 'Smart customer service and SMS charging standard',
		a2083: 'Smart customer service translation charging standard',
		a2084: 'Please select a region',
		a2085: 'Filter',
		a2086: 'Within 10 billion',
		a2087: 'Forever free',
		a2088: 'Number of ten thousand characters',
		a2089: 'Number of characters',
		a2090: 'SMS reminder function quotation standard',
		a2091: '* Turning on the smart reminder function will deduct the fee according to the amount of SMS automatically sent, and the SMS price is charged according to different countries. The following is the international SMS quotation:',
		a2092: 'Charge',
		a2093: 'Pieces',
		a2094: 'Lane 1518, Jinshajiang Road, Putuo District, Shanghai',
		a2095: 'Lane 1517, Jinshajiang Road, Putuo District, Shanghai',
		a2096: 'Number of replies to buyers',
		a2097: 'Number of translated characters',
		a2098: 'Are you sure to delete?',
		a2099: 'The rule was added successfully',
		a2100: 'Classification',
		a2101: 'View all orders of buyers',
		a2102: 'Modify purchase cost',
		a2103: 'Transportation costs',
		a2104: 'Local currency',
		a2105: 'Submit modification',
		a2106: 'The freight will directly affect the calculation of the value of the goods, it is recommended to enter',
		a2107: 'Volume/cubic meter',
		a2108: 'Purchase quantity (integer)',
		a2109: 'Already exists! ',
		a2110: 'It is not a product under the same warehouse, please choose a product from the same warehouse! ',
		a2111: 'The expected arrival time must be more than 3 days from the current date, and the current day will not be counted!',
		a2112: 'No product information, cannot create a purchase order',
		a2113: 'Please fill in the expected arrival date',
		a2114: 'The quantity of goods cannot be 0',
		a2115: 'Please select products under the same warehouse for purchase',
		a2116: 'Successfully created storage order:',
		a2117: 'Unable to create a storage order, the current available points are not enough, please recharge! ',
		a2118: 'The modification is successful, and the storage order page is being returned! ',
		a2119: 'I know',
		a2120: 'Arrival time',
		a2121: 'Please enter the local currency',
		a2122: 'Current purchase total',
		a2123: 'Estimated arrival date',
		a2124: 'Create storage',
		a2125: 'Add new product',
		a2126: 'Confirm modification',
		a2127: 'First freight',
		a2128: 'Own channel',
		a2129: 'Platform head journey',
		a2130: 'Charging Standard',
		a2131: 'Estimated total volume',
		a2132: 'Reserved Points',
		a2133: 'Per cubic meter',
		a2134: 'Per kilogram',
		a2135: 'The actual weight or the volumetric weight takes the larger value',
		a2136: 'Incoming product details',
		a2137: 'Cost price',
		a2138: 'Gift',
		a2139: 'Warehouse sku',
		a2140: 'Add a single product or package',
		a2141: 'Product Type',
		a2142: 'Purchase 1 or less single product or package, will add the number set by the distribution center',
		a2143: 'Number of free accessories',
		a2144: 'Selected',
		a2145: 'Warehouse mother Sku',
		a2146: 'Expand',
		a2147: 'Close',
		a2148: 'All sub-SKUs in the warehouse',
		a2149: 'The number of warehouse sub-sku',
		a2150: 'Remaining total inventory in warehouse',
		a2151: 'Please enter a new warehouse sub-SKU',
		a2152: 'Enter a new skuName',
		a2153: 'Volume',
		a2154: 'Please confirm to delete the selected',
		a2155: ' Products? ',
		a2156: 'Failed to delete an order! ',
		a2157: 'Are you sure to delete this product?',
		a2158: 'Failed to delete an order',
		a2159: 'Saved successfully',
		a2160: 'Successfully create a single product in the warehouse! ',
		a2161: 'Manually create gift consumables',
		a2162: 'Scan product bar',
		a2163: 'Generate QR code',
		a2164: 'Go to print',
		a2165: 'QR code',
		a2166: 'Store type',
		a2167: 'Shopee\Lazade\TikTok store\Tiki local store is currently supported, please confirm with customer service and click to pay for the following package content',
		a2168: 'Personal Exclusive Store',
		a2169: '5 People share enterprise store',
		a2170: 'Personal Exclusive Enterprise Store',
		a2171: 'Attached',
		a2172: 'Including 1 local store, 1000 cashback points on the distribution platform. ',
		a2173: 'Related quotations and services are as follows',
		a2174: '1. What is pure ERP?',
		a2175: 'Local sellers who build their own warehouses in Southeast Asian countries do not need to use our overseas cloud warehouses. They can also use only ERP and WMS systems. Create a private warehouse account (that is, a warehouse account) on the store authorization page, and immediately use our entire warehouse. Efficient ERP and warehouse WMS processing flow, only need to pay a system service fee as low as 0.05 yuan/order. ',
		a2176: '2. Why use Dianxiaosheng ERP/WMS system? ',
		a2177: 'Specially designed for local sellers, a permanent free claim assistant can track logistics lost orders with one click, prevent store oversold and deduct points, 99.99% inventory accuracy rate, bind online inventory on multiple platforms and stores, and automatically update online within 1 minute Inventory, to prevent oversold in stores & delivery timeouts! ',
		a2178: '3. ERP spot distribution platform? ',
		a2179: 'Exclusive Southeast Asian spot distribution platform, sellers can use the Dianxiaosheng distribution platform to establish an overseas distribution system at any time, more online agents, support for setting online minimum retail prices, real-time monitoring of agent selling prices and price control. ',
		a2180: '4. Professional service team',
		a2181: "Dianxiaosheng's ERP system is specially tailored for local sellers in Southeast Asia. Currently, local service teams have been established in many Southeast Asian countries such as Malaysia, Thailand, Indonesia, and the Philippines! ",
		a2182: '1. Why do you want to settle in a local store? ',
		a2183: 'Sellers entering Southeast Asia should know that Southeast Asian countries require all e-commerce platforms to protect their local accounts. At the same time, under the epidemic, only local cloud warehouse delivery can make buyers experience better, resulting in higher conversion rates and profits. The rate is also higher, and the Thailand, Malaysia, and Vietnam TIKTOK shop newly opened in March this year live-streamed impulsive consumption returns and exchanges can only be realized in local warehouses, so local stores have become a must for Southeast Asian sellers. ',
		a2184: '2. Service object',
		a2185: 'Because there are not many safe and compliant high-quality accounts, and the number is limited, we currently only provide them to customers in the warehouse or use the Xiaosheng distribution platform of the store, and strictly prohibit counterfeit products and other merchants, only for sellers who have long-term presence in Southeast Asia Serve. ',
		a2186: '3, More information',
		a2187: 'The countries and platforms that can be settled in, we will continue to update the relevant information, please click to view the details:',
		a2188: 'Shared document',
		a2189: 'Overseas Warehouse Price List',
		a2190: '1. What is an overseas cloud warehouse? ',
		a2191: "Cloud warehouse, commonly known as overseas warehouse. That is, according to the store's product operation effect, the goods will be stocked in advance to the mainland, and once the order is issued, the goods will be delivered within 24 hours. You can use Dianxiaosheng ERP for free and prepare goods to Dianxiaosheng's overseas cloud warehouse, which can facilitate you to control the goods in time, automatically monitor the buyer's COD rejection/dispute return order, and effectively increase the overall net profit for the seller! ",
		a2192: '2. Which countries are the main overseas cloud warehouses? ',
		a2193: "Currently Dian Xiaosheng's overseas cloud warehouse services have covered: Vietnam/Thailand/Malaysia/Philippines/Indonesia/Taiwan/and other Southeast Asian countries",
		a2194: '3. Why use overseas cloud storage? ',
		a2195: '①、Reduce the cost of first-leg transportation and compress logistics costs;②、Fast delivery within 24 hours to improve buyer experience;③、Returns and exchanges are processed in a timely manner to increase overall net profit',
		a2196: 'Points change details',
		a2197: 'Integral changes in the current time period',
		a2198: 'Positive number: increase points, negative number: deduct points',
		a2199: 'Point deduction type (default all)',
		a2200: 'Payment type',
		a2201: 'Deduction',
		a2202: 'Expense item',
		a2203: 'Before points change',
		a2204: 'After the change of points',
		a2205: 'Find',
		a2206: 'Reserved point details',
		a2207: 'Payment party (shop)',
		a2208: 'Revenue side (warehouse)',
		a2209: 'Total points',
		a2210: 'Available points',
		a2211: 'View point details',
		a2212: 'Check the reservation points details',
		a2213: 'After recharging, you can immediately use functions such as overseas cloud storage, testing product storage, and private storage',
		a2214: 'Member recharge instructions: 1 yuan 1 point, the more recharge, the more bonus points will be given',
		a2215: 'There is no deduction information for this order number!',
		a2216: 'Reminder to pay',
		a2217: 'Shipment reminder',
		a2218: 'Sign for reminder',
		a2219: 'No limit',
		a2220: 'Sign Reminder',
		a2221: 'Are you sure you want to submit the form? ',
		a2222: 'Getting storage records! ',
		a2223: 'There is no storage record! ',
		a2224: 'Transportation costs',
		a2225: 'To be confirmed by the platform',
		a2226: 'To be paid by the seller...',
		a2227: 'Modify cost price',
		a2228: 'Create a new headline route',
		a2229: 'Please select the cargo type',
		a2230: 'Select country',
		a2231: 'Please select an area',
		a2232: 'Singapore',
		a2233: 'Deduction method',
		a2234: 'Volume or weight maximum',
		a2235: 'Please select a deduction method',
		a2236: 'Pricing fee',
		a2237: 'Transfer warehouse contact',
		a2238: 'Transfer warehouse address',
		a2239: 'Self-owned channel head journey',
		a2240: 'Add a head trip',
		a2241: 'Take the maximum value',
		a2242: 'Consignee phone number',
		a2243: 'General cargo by sea',
		a2244: 'Air cargo',
		a2245: 'Land transport general cargo',
		a2246: 'Sea Sensitive Goods',
		a2247: 'Air Sensitive Goods',
		a2248: 'Sensitive land transport',
		a2249: 'Create successfully!',
		a2250: 'Delete successfully! ',
		a2251: 'Select the following platform for store authorization',
		a2252: 'Click to authorize',
		a2253: 'Please climb over the wall',
		a2254: 'Again',
		a2255: 'Authorization coming soon! If the store has been authorized on another account, it will be automatically unbound from the original account and cannot be restored. Please operate with caution. If you are not sure, please contact the platform customer service',
		a2256: 'Authorize now',
		a2257: 'Claim Assistant',
		a2258: 'Claim limitation',
		a2259: 'Compensation arrives in the account',
		a2260: 'It is a special function of the system specially designed for local sellers in Southeast Asia. It can help sellers to find out the orders rejected by COD or lost in express delivery in time, and it is convenient for sellers to export the form, which can be used to claim compensation from the platform. ',
		a2261: "Generally within 30 days, if you have not made a claim to the platform customer service for more than 30 days, it will be deemed as a waiver of the claim qualification, and the seller will eventually lose a sum of compensation (such as Thailand's maximum 2,000 baht)! If you can make a claim to the platform in time, it will immediately help you recover your losses and increase your net profit immediately! ",
		a2262: 'After submitting the platform customer service claim form, the system will automatically judge whether the order you are claiming has been successfully compensated, saving you time to check, and it is clear at a glance. ',
		a2263: 'Click on the corresponding menu bar below "Claim to be confirmed - Order", "Claim - Order", "Claim Successful - Order"',
		a2264: 'Claim pending confirmation',
		a2265: 'Once the buyer rejects a COD order from a local store, the probability of package loss will increase, and the system will automatically monitor lost packages and deliver failed packages. ',
		a2266: 'The seller needs to manually click the start claim button to enter this state, so as to avoid confusion with the newly arrived claim order to be confirmed! ',
		a2267: 'Once submitted to the platform customer service, the system will automatically check that the order has been successfully claimed and the actual amount received, and will automatically display this status. ',
		a2268: 'You need to take the initiative to contact SHOPEE customer service to make a claim. Generally, tell them to claim for lost packages and submit an Excel list. ',
		a2269: 'Claiming',
		a2270: 'Package received',
		a2271: 'To confirm the claim order',
		a2272: 'To be contacted platform customer service orders',
		a2273: 'The order has been successfully claimed',
		a2274: 'Confirm to claim the order: ',
		a2275: 'Confirm to abandon the order: ',
		a2276: 'The claim?',
		a2277: 'The order has given up the claim!',
		a2278: 'When you click on all claims, the current total will be',
		a2279: 'All orders are claimed, please confirm if you want to continue this operation?',
		a2280: 'All claims are successful!',
		a2281: 'Waiting for the seller to contact the platform customer service',
		a2282: 'Successful claim',
		a2283: 'Enter a note name',
		a2284: 'Please fill in the remarks of the store',
		a2285: 'Export the current status deduction details',
		a2286: 'Revenue side',
		a2287: 'Payer',
		a2288: 'Private warehouse account details (can only create up to 3 private warehouse accounts)',
		a2289: 'Create a new private warehouse account',
		a2290: 'Private warehouse account',
		a2291: 'Create a distribution warehouse sub-warehouse',
		a2292: 'Create a private warehouse',
		a2293: 'Preferential Settings',
		a2294: 'Current seller',
		a2295: 'Please select a warehouse',
		a2296: 'Please select a discount type',
		a2297: 'Promotion Type',
		a2298: 'Service Fee',
		a2299: 'Seller Offer',
		a2300: 'The value range is 0-1, 0.95=95% off, 1=no discount, 0=free',
		a2301: 'Currently there is no bound warehouse',
		a2302: 'There is currently no account bound to the seller',
		a2303: "Deduct seller's miscellaneous fees",
		a2304: 'The value range is 0.7-1, 0.7=30% off, 1=no discount',
		a2305: 'The reason for applying for opening a distribution warehouse is required',
		a2306: 'Please fill in the detailed address',
		a2307: 'Please fill in the consignee',
		a2308: "Please fill in the recipient's contact information",
		a2309: 'Please fill in the distribution warehouse name',
		a2310: "Successfully deducted the seller's points!",
		a2311: "The store's remarks have been updated, and the current page is being refreshed",
		a2312: 'Bind successfully',
		a2313: 'Successfully create a private warehouse! ',
		a2314: 'The application for creating a distribution warehouse has been submitted to the platform, please wait for the platform to process it! ',
		a2315: 'Please fill in the content of the red starry sky! ',
		a2316: 'New sub-warehouse',
		a2317: 'New alliance warehouse',
		a2318: 'Please enter a decimal between 0 and 1! Can only keep up to two decimal places',
		a2319: 'The preferential value of the service fee must be between 0.7 and 1, and cannot be less than 0.7',
		a2320: 'Please select a warehouse type! ! ! ',
		a2321: 'Deduct seller',
		a2322: 'Warehouse miscellaneous fees',
		a2323: 'The account already exists! please enter again! ',
		a2324: 'Select a country',
		a2325: 'Please fill in the name of the private warehouse! ',
		a2326: 'Please fill in the password of the private warehouse account! ',
		a2327: 'You have successfully created a private warehouse account:',
		a2328: ', Login password:',
		a2329: 'Created successfully',
		a2330: 'Successfully bind the store! ',
		a2331: '! Do you want to re-authorize and unbind the original account? ',
		a2332: 'Note: After unbinding, the order data of the original account on this store will be automatically cleared. ',
		a2333: 'Do you want to continue the authorization? ',
		a2334: 'Confirm Authorization',
		a2335: 'China',
		a2336: 'Enabled',
		a2337: 'Disabled',
		a2338: 'Please fill in the warehouse information',
		a2339: 'Successfully create alliance warehouse! ',
		a2340: 'Unbind soon! After unbinding, the association and binding relationship between the store and the warehouse product will be automatically deleted, and the store order cannot be obtained and cannot be restored! Please operate with caution, if you are not sure, please contact the platform customer service',
		a2341: 'Unbind immediately',
		a2342: 'Seller address',
		a2343: "Enter the name of the seller's remarks",
		a2344: 'Add Shopify authorization',
		a2345: 'Store name',
		a2346: 'Shop URL',
		a2347: 'Private warehouse account details (can only create up to 5 private warehouse accounts)',
		a2348: 'New distribution sub-warehouse',
		a2349: 'Distribution Warehouse Name',
		a2350: 'Sub-warehouse name',
		a2351: 'Please enter the detailed address',
		a2352: 'Please enter the description for applying for a distribution warehouse! ',
		a2353: 'Application description',
		a2354: 'To create a private warehouse account, please scan the QR code on WeChat to contact the customer service staff',
		a2355: 'Fill in the name of the sub-warehouse',
		a2356: 'Enter the private warehouse password',
		a2357: 'Warehouse charging rules',
		a2358: 'Enable',
		a2359: 'Disabled',
		a2360: 'No type yet',
		a2361: 'The store name is required',
		a2362: 'Store URL is required',
		a2363: 'Apply to open a private warehouse account',
		a2364: 'Reminder: When a user creates a private warehouse account, the system will randomly generate a private warehouse account, and at the same time, the system will automatically create a private sub-warehouse for the account, please fill in the name of the sub-warehouse! ',
		a2365: 'Each order fee',
		a2366: 'The maximum number of orders per month',
		a2367: 'Return processing fee',
		a2368: 'The default deduction SKU number of single package',
		a2369: 'The number of sku exceeds the default charge',
		a2370: 'The default deduction number of packages with the same sku',
		a2371: 'SKU overcharge',
		a2372: 'Order fee',
		a2373: 'Operation fee',
		a2374: 'New gift for buyers',
		a2375: 'Create private warehouse and distribution warehouse',
		a2376: 'Local sellers who build their own warehouses in Southeast Asian countries can only use the ERP system, create a new private warehouse account on the store authorization page, and immediately use our entire efficient ERP processing process. ',
		a2377: 'Official website authorization',
		a2378: 'Store local IP isolation',
		a2379: 'Authorization Status',
		a2380: 'Currently there is no authorized store',
		a2381: 'Address Details',
		a2382: 'Charging rules',
		a2383: 'When disabled, the current warehouse will be hidden when the user triggers the warehouse selection behavior',
		a2384: 'View charging rules',
		a2385: 'Please fill in the content marked with a red asterisk! ',
		a2386: 'Successfully create a sub-position! ',
		a2387: 'Import excel form',
		a2388: 'Drag the file here, or',
		a2389: 'You can only import excel sheets with the suffix .xlsx/.xls',
		a2390: 'The file is being verified, please wait',
		a2391: 'Confirm Import',
		a2392: 'The product is already in the warehouse',
		a2393: 'Binding online products',
		a2394: 'Synchronous online products',
		a2395: 'Binding products',
		a2396: 'You can search for name, sku, product Id',
		a2397: 'Bind the product',
		a2398: 'Data verification is successful, total',
		a2399: 'Products of sku, please continue to operate! ',
		a2400: 'Removing from the shelf',
		a2401: 'Please import the excel form',
		a2402: 'Synchronizing store:',
		a2403: 'Online products',
		a2404: 'It is expected to take 15-30 seconds to synchronize online products. After the system prompts that the synchronization is successful, please refresh the page by yourself! ',
		a2405: 'The synchronization is complete, please refresh the page! ',
		a2406: 'Error getting data, please try again later! ',
		a2407: 'Please select a product! ',
		a2408: 'Only selectable',
		a2409: 'Files, currently selected',
		a2410: 'The format of the attachment is wrong, please delete it and upload it again! ',
		a2411: 'Please upload the attachment! ',
		a2412: 'Exceeded the limit of the maximum number of uploaded files! ',
		a2413: 'Historical purchase records',
		a2414: 'Additional fees',
		a2415: 'Logistics costs',
		a2416: 'Purchasing time',
		a2417: 'Agent Details',
		a2418: 'Nickname',
		a2419: "Agent's cusCode",
		a2420: 'Manually create SKU',
		a2421: 'Weight (optional)',
		a2422: 'Volume (optional)',
		a2423: 'Please enter the warehouse sub-SKU',
		a2424: 'Please enter the name of the warehouse sub-SKU',
		a2425: 'Please enter the weight of the product (unit/KG',
		a2426: 'Length (cm)',
		a2427: 'Width (cm)',
		a2428: 'Height (cm)',
		a2429: 'Binding online products',
		a2430: 'Add new binding product',
		a2431: 'Discount price',
		a2432: 'Currently select the inventory product to be bound',
		a2433: 'The following are the online products that will be associated and bound',
		a2434: 'Bind now',
		a2435: 'Delete failed prompt',
		a2436: 'Failed to delete the product! ',
		a2437: 'Binding situation',
		a2438: 'A sku successfully binds warehouse products',
		a2439: 'A sku binding failed',
		a2440: 'The product is already bound',
		a2441: 'Close, return to warehouse products',
		a2442: 'One-click import of online products and binding correspondence',
		a2443: 'Important!! Please pay special attention!!!!',
		a2444: 'This function is only applicable to stores with planned SKUs. Every time it is used, it will first be automatically associated with the same online parent SKU of the warehouse product that has been created,',
		a2445: 'Secondly, the parent SKU of the product that has not been created in the warehouse is automatically created and merged and associated with the same parent SKU. Therefore, if the parent SKU of the online product is not filled in, the creation will fail! ',
		a2446: 'This function is not suitable for stores where the original SKU is not planned online, otherwise it may cause confusion in the binding of the successfully created warehouse SKU,',
		a2447: 'If you are not sure about the operation, you can consult the customer service staff of Xiaosheng, thank you! ! (Important!! Please pay special attention!!!!)',
		a2448: 'Please select the store to import',
		a2449: 'Loading data, please wait...',
		a2450: 'Configure the single product of this package',
		a2451: 'Add item in warehouse',
		a2452: 'Number of packages',
		a2453: 'Accessories List',
		a2454: 'Searchable warehouse code, warehouse sub-sku',
		a2455: 'Save the current configuration options',
		a2456: 'Number of packages',
		a2457: 'The picture cannot be empty! ',
		a2458: 'Warehouse sub-SKU cannot be empty! ',
		a2459: 'SkuName cannot be empty! ',
		a2460: 'warehouse product',
		a2461: 'Already exists, please do not repeat the configuration! ',
		a2462: 'Template watermark',
		a2463: 'Replace property image',
		a2464: 'Put the warehouse products on the distribution platform',
		a2465: 'Fill in distribution product information',
		a2466: 'Distribution on shelves',
		a2467: 'Update to distribution platform',
		a2468: 'Commodity category',
		a2469: 'Main product image',
		a2470: 'Add product picture',
		a2471: 'Pictures are sorted randomly',
		a2472: 'Add picture',
		a2473: 'Specification information',
		a2474: 'Distributed at a fixed supply price',
		a2475: 'Distributed on shelves with a fixed gross profit margin',
		a2476: 'Distributed at the cost price of the product',
		a2477: 'Set default calculation formula',
		a2478: 'Default formula',
		a2479: 'Local spot price',
		a2480: 'The price of one dropshipping from the local spot (including cross-border logistics fee)',
		a2481: 'Between 5-99',
		a2482: 'Received (5% commission from the platform)',
		a2483: 'Received after the platform commission',
		a2484: 'Overseas domestic spot inventory',
		a2485: 'Wholesale price purchased from China (excluding shipping costs)',
		a2486: "All the sources of goods in the platform industry belt support the Panax notoginseng billing period model, that is, the seller only needs to pay a 30% deposit, and the supplier will deliver the goods to the platform collection warehouse according to the purchase order, and transport them to the platform's overseas warehouse. Only need to pay the remaining 70% balance",
		a2487: 'Does it support 3/7 account period',
		a2488: 'Online lowest retail discounted price',
		a2489: 'Weight volume',
		a2490: 'After the fixed supply price is enabled, the product cost of the order after the transaction will be settled according to the supply price, and will be settled to the supplier after being commissioned by the platform. Please fill in the supply price of the product',
		a2491: 'After the fixed gross profit rate is enabled, the system will automatically calculate the distribution supply price of each sku based on the lowest discounted RMB price of the bound online product. Please fill in the fixed gross profit rate (that is, the gross profit margin space for each agent. !)! ',
		a2492: 'Enable the product cost price to be put on the shelf, the supplier should calculate the gross profit by himself, and then fill in the supply price',
		a2493: 'After closing the fixed gross profit margin, the system will no longer automatically calculate the distribution supply price of each sku based on the bound online products, please fill in the supply price of the product',
		a2494: 'Up to 9 main pictures can be uploaded',
		a2495: 'Product cost price:',
		a2496: 'The gross profit rate cannot be less than 5%',
		a2497: 'The number of characters in the product title must be between 2-120! ',
		a2498: 'The character length of all sku cannot be greater than 20! ',
		a2500: 'The supply price cannot be 0',
		a2501: 'Updated to the distribution platform',
		a2502: 'Template binding is successful! ',
		a2503: 'The product has been released to the distribution platform',
		a2504: 'Sku',
		a2505: 'Entry failed',
		a2506: 'Mother sku (required)',
		a2507: 'Is it sensitive goods',
		a2508: 'Online products',
		a2509: 'Excel import warehouse products',
		a2510: 'Export products',
		a2511: 'Import warehouse products',
		a2512: 'The warehouse has been imported',
		a2513: 'Cancel import',
		a2514: 'Import warehouse',
		a2515: 'The parent sku is a required item, there are still products whose parent sku has not been filled in, please fill in the corresponding parent sku information',
		a2516: 'Select the single product/package configured for the gift',
		a2517: 'Enter product barcode',
		a2518: 'Please enter the product barcode information',
		a2519: 'Inventory product details',
		a2520: 'Select all current page',
		a2521: 'Batch operation',
		a2522: 'Move into package library in batches',
		a2523: 'Delete selected products in batches',
		a2524: 'Add sub-sku',
		a2525: 'Online import',
		a2526: 'Manually created',
		a2527: 'Uploaded to the distribution platform',
		a2528: 'Update the product information of the distribution platform',
		a2529: 'Upload to TikTok Shop',
		a2530: 'Warehouse mother sku information',
		a2531: 'Characters within 120',
		a2532: 'Unbound',
		a2533: 'Source of goods',
		a2534: 'Modify the source of goods',
		a2535: 'View historical purchase records',
		a2536: 'The total quantity to be shipped that has been approved to this warehouse',
		a2537: 'Product cost price',
		a2538: 'Approved to be shipped',
		a2539: 'All quantities to be shipped',
		a2540: 'Lock inventory',
		a2541: 'Automatic means to automatically obtain from Shopee the inventory that is locked in activities such as Flash, and manual means that the seller needs to lock the inventory according to the actual setting. The default lock is 0, that is, no lock. And the seller cannot modify the locked inventory quantity of the configured package, and the locked value of the configured package needs to be modified in the combined package library. ',
		a2542: 'Includes all approved and unapproved quantities to be shipped',
		a2543: 'Automatic',
		a2544: 'Manual',
		a2545: 'Seller User',
		a2546: 'Automatically update online inventory',
		a2547: 'When automatic update is enabled in the warehouse, the shopee inventory of all products bound to the warehouse product will be automatically synchronized to the actual remaining inventory of the warehouse product',
		a2548: 'Whether to set independent packaging',
		a2549: 'Independent inventory',
		a2550: 'Barcode',
		a2551: 'Enter barcode',
		a2552: 'Distribution supply price',
		a2553: 'Required',
		a2554: 'Move into package',
		a2555: 'Match into single product/package',
		a2556: 'Move into a single product',
		a2557: 'Configuration package',
		a2558: 'View inventory log',
		a2559: 'View agency',
		a2560: 'Configured packages',
		a2561: 'Configured gifts',
		a2562: 'Whether to continue setting this product as a sensitive product',
		a2563: 'Whether to continue to set this product as general goods',
		a2564: 'Fill in the distribution supply price in bulk (￥)',
		a2565: 'Fill in the gross profit rate (decimal between 0 and 1):',
		a2566: 'Successfully added sub-SKU! ',
		a2567: 'You can only enter numbers greater than 0! ',
		a2568: 'The gross profit margin of the products put on the distribution platform cannot be less than 5%',
		a2569: 'The supply price of the distributed product is required, please fill in! ',
		a2570: 'This product cannot be distributed, please contact customer service! ',
		a2571: 'The picture was replaced successfully! ',
		a2572: 'Sku has been removed from the distribution platform:',
		a2573: ', Has been put on the shelf to the distribution platform',
		a2574: 'This package has been opened as an individually packaged package',
		a2575: 'This package has been closed as an individually packaged package',
		a2576: 'The warehouse code of the package to which it belongs:',
		a2577: 'The maximum number of characters cannot exceed 35',
		a2578: 'Please enter a number',
		a2579: 'The maximum number of notes cannot exceed 32',
		a2580: 'Successfully modify attributes',
		a2581: 'Are you sure you want to move into the package library? ',
		a2582: 'Are you sure you want to move to the single product library? ',
		a2583: 'It has been moved into the package library',
		a2584: 'It has been moved into the single product library',
		a2585: 'A product will be added to the combination library, please confirm? ',
		a2586: 'Successfully moved into the package library! ',
		a2587: 'Currently delete the selected',
		a2588: ' SKU products, please confirm whether to continue this operation? ',
		a2589: 'Cost price modified successfully',
		a2590: 'Enter characters within 120! ',
		a2591: 'Update data successfully! ',
		a2592: 'The uploaded avatar picture can only be in JPG format!',
		a2593: 'Please enter the barcode information! ',
		a2594: 'The product barcode has been entered successfully! ',
		a2595: 'Enabling automatic will automatically obtain from Shopee the locked inventory that participates in activities such as Flash',
		a2596: 'Automatically lock inventory has been turned on! ',
		a2597: 'When it is set to manual, the number of inventory needs to be locked according to the actual setting of the seller. The default lock is 0, that is, no lock. ',
		a2598: 'Automatically lock inventory has been turned off! ! ',
		a2599: 'When automatic update is enabled in the warehouse, all product platform inventory bound to the warehouse product will be automatically synchronized to the actual remaining inventory of the warehouse product. Please confirm whether to enable it? ',
		a2600: 'Automatic update of online inventory is enabled! ',
		a2601: 'When the automatic update of inventory in the warehouse is closed, the inventory of the warehouse product will not affect the platform inventory of all bound products. Please confirm whether to continue to close? ',
		a2602: 'The automatic update of online inventory has been turned off! ',
		a2603: 'Delete failed! ',
		a2604: 'Select online data source',
		a2605: 'Commodity Id:',
		a2606: 'Product distribution details',
		a2607: 'Select a data source from the bound online link',
		a2608: 'Fill in the supply price',
		a2609: 'The estimated gross profit margin needs to be greater than 80%, and the supply price is less than 50% of the current price, before it is allowed to be set as a clearance product',
		a2610: 'Combination package',
		a2611: 'Batch move into single product',
		a2612: 'Create warehouse package',
		a2613: 'Export inventory products',
		a2614: 'Total remaining inventory',
		a2615: 'Sku',
		a2616: '20 Warehouse products were successfully imported this time, with a total of 521 sub-skus, 58554 sub-skus were successfully bound, and 5201 sub-skus failed to bind',
		a2617: 'Successfully moved into the single product library! ',
		a2618: 'Please select the target warehouse where the product will be copied',
		a2619: 'Please select the target warehouse',
		a2620: 'Gift consumables',
		a2621: 'Full warehouse copy product',
		a2622: 'Create gift consumables',
		a2623: 'The operation was successful! ',
		a2624: 'Warehouse single product',
		a2625: 'Create a warehouse item',
		a2626: 'Import and bind online with one click',
		a2627: 'Out of stock reminder',
		a2628: 'Successfully imported this time',
		a2629: 'Sku, successfully bound',
		a2630: 'Sub-sku, binding failed',
		a2631: 'Sub SKU, after closing the pop-up window, please refresh to get the latest warehouse product data! ',
		a2632: 'Products will be moved into the combination library, please confirm? ',
		a2633: 'Task message',
		a2634: 'Task progress',
		a2635: 'Select task progress:',
		a2636: 'Create a new task',
		a2637: 'Task name',
		a2638: 'Task description',
		a2639: 'Charge details',
		a2640: 'Seller description',
		a2641: 'The warehouse has not received an order',
		a2642: 'The warehouse has received an order',
		a2643: 'Task completed',
		a2644: 'Task number',
		a2645: 'Current task progress',
		a2646: 'Please enter the message content',
		a2647: 'Leave a message',
		a2648: 'Select task progress',
		a2649: 'Complete all fees',
		a2650: 'Partial completion fee',
		a2651: 'Value-added services are local warehouse special services promoted by the platform, such as finding local anchors for live broadcast, telephone communication with customer service in small languages, and revision of negative reviews, etc.',
		a2652: 'Not all overseas warehouses have opened all value-added services. If there is a need, please consult the warehouse customer service staff for details. Value-added services are currently in the internal testing period,',
		a2653: 'All sellers and friends need to work together to improve, hoping to help sellers and friends',
		a2654: 'Region selection',
		a2655: 'Fee Details',
		a2656: 'Complete all task costs',
		a2657: 'Contribution has not been completed',
		a2658: 'Fee',
		a2659: 'All tasks completed',
		a2660: 'Confirmation completed',
		a2661: 'Return',
		a2662: 'Confirm additional fee',
		a2663: 'Delete task',
		a2664: 'Warehouse orders',
		a2665: 'Warehouse rejection',
		a2666: 'Confirm progress',
		a2667: 'The warehouse has been confirmed',
		a2668: 'All done',
		a2669: 'Partially completed',
		a2670: "Seller's task description",
		a2671: 'System message',
		a2672: 'Unfinished',
		a2673: 'There is no task type',
		a2674: 'Please enter a number! ',
		a2675: 'Create successfully! ',
		a2676: 'The order status has been returned! ',
		a2677: "After this confirmation is completed, it will be deducted from the seller's credit account",
		a2678: 'Points, and',
		a2679: 'Extra points, total',
		a2680: 'Points, do you want to continue the operation? ',
		a2681: 'Settlement completed! ',
		a2682: 'The seller has not yet confirmed the additional charges, do you want to continue? ',
		a2683: "This confirmation, the seller will agree to the warehouse's proposal",
		a2684: 'Do you want to continue to execute the extra cost of points? ',
		a2685: 'Confirmed successfully! ',
		a2686: 'Continue to accept this task order? ',
		a2687: 'Successfully received an order',
		a2688: 'Additional charges have been submitted to the seller, pending confirmation from the seller! ',
		a2689: 'The message cannot be empty! ',
		a2690: 'Expand all',
		a2691: 'All folded',
		a2692: 'Modify picture',
		a2693: 'Seller Name',
		a2694: 'Independent inventory quantity',
		a2695: 'Configured packages',
		a2696: 'Save',
		a2697: 'Edit',
		a2698: 'Draft box',
		a2699: 'Product barcode/warehouse code scanning area',
		a2700: 'Total',
		a2701: 'Mother SKU',
		a2702: 'The total number of original warehouses',
		a2703: 'Total count',
		a2704: 'Save the current inventory record',
		a2705: 'Inventory completed',
		a2706: 'CUSCODE (barcode)',
		a2707: 'Originally stored in the warehouse',
		a2708: 'Actual inventory inventory',
		a2709: 'The reason for return for review is required! ',
		a2710: 'No order data! ',
		a2711: 'Resume',
		a2712: 'Inventory record',
		a2713: 'Warehouse inventory',
		a2714: 'The total number of this inventory:',
		a2715: 'Do you want to continue to complete the operation of stocktaking? After confirmation, the inventory will be modified accordingly, please check the inventory log for details! ',
		a2716: 'Yes, put into storage now',
		a2717: 'Successful storage! ',
		a2718: 'The current warehouse does not have this product! ',
		a2719: 'Print product barcode',
		a2720: 'Batch printing barcodes',
		a2721: 'Material cost multiple',
		a2722: 'Virtual warehouse',
		a2723: 'Cloud Warehouse',
		a2724: 'Self-built warehouse',
		a2725: "A transfer application has been initiated to the seller, waiting for the seller's confirmation! ",
		a2726: 'Please choose a seller! ',
		a2727: 'Please select the warehouse to transfer! ',
		a2728: 'Successful transfer! ',
		a2729: 'The multiple cannot be less than 1',
		a2730: 'Successfully modified! ',
		a2731: 'Please fill in the reason for modifying the inventory! ',
		a2732: 'These items have been successfully bound',
		a2733: 'Inventory Management',
		a2734: 'Combined library',
		a2735: 'Gift supplies library',
		a2736: 'Filter sellers',
		a2737: 'In-warehouse products are analyzed by intelligent algorithm based on multi-dimensional data such as outbound frequency and occupied funds: they are divided into important (category A), general important (category B), and unimportant (category C)',
		a2738: 'ABC intelligent classification',
		a2739: 'Size',
		a2740: 'The bound product must be greater than 0',
		a2741: 'The purchase order was created successfully, and the purchase order number is:',
		a2742: 'Submit new warehouse confirmation',
		a2743: 'After saving the current record, the previous inventory record will be overwritten, please confirm whether to continue the operation of saving the current inventory',
		a2744: 'After performing this operation, the transfer data will be submitted to the new warehouse for confirmation, and the data of this transfer order will no longer be modified later. Please confirm whether to continue? ',
		a2745: 'The confirmation is successful, and the new warehouse will be checked and put into storage! ',
		a2746: 'Executing this operating system will actually put into storage according to the current inventory of products, please confirm whether all the inventory has been completed? ',
		a2747: 'The confirmation is successful, and the storage has been completed! ',
		a2748: 'The quantity of this old warehouse inventory',
		a2749: 'And the actual inventory of the new warehouse',
		a2750: 'Old warehouse inventory',
		a2751: 'New warehouse inventory',
		a2752: 'Select transfer warehouse',
		a2753: 'Select the warehouse to transfer',
		a2754: 'Message from the seller (optional)',
		a2755: 'Transfer warehouse receipt number',
		a2756: 'Initiate warehouse',
		a2757: 'Message reminder',
		a2758: 'Transfer Warehouse',
		a2759: 'Confirm submission',
		a2760: 'Transfer transfer list',
		a2761: 'The transfer has been completed',
		a2762: 'Transferring positions',
		a2763: 'Initiate application',
		a2764: 'Seller confirmation',
		a2765: 'Old warehouse inventory',
		a2766: 'New warehouse inventory',
		a2767: 'Receiving warehouse',
		a2768: 'The transfer warehouse cannot be the same as the original warehouse! ',
		a2769: 'Warehouse, seller attribute cannot be empty! ',
		a2770: 'Create transfer order',
		a2771: 'Select seller',
		a2772: 'Warehouse message (optional)',
		a2773: 'Create',
		a2774: 'Inventory of old inventory',
		a2775: 'The current warehouse has no intelligent classification data',
		a2776: 'The current warehouse has no ABC and can only classify data',
		a2777: 'Class A: Quantity 5%~10%; Inbound and outbound frequency class accounted for: 60%~70%',
		a2778: 'Class B: Quantity 10~20%; Inbound and outbound frequency class accounted for: 20%~30%',
		a2779: 'Class C: 70%~80% of the quantity; the proportion of inbound and outbound frequency categories: 5%~10%',
		a2780: 'It is recommended to put out of the warehouse:',
		a2781: 'Class A: Convenient picking location (such as the door, the first row of shelves)',
		a2782: 'Class B: common position (such as middle position)',
		a2783: 'Category C: corner position (do not move around frequently, or consider combining and placing)',
		a2784: 'Create gifts or consumables',
		a2785: 'New warehouse sub-SKU',
		a2786: 'One-click release',
		a2787: 'Configured distribution selection',
		a2788: 'The current product has no binding templates, please bind the templates before continuing to publish? ',
		a2789: 'OK, new version',
		a2790: 'Binding Template',
		a2791: 'View the currently bound template',
		a2792: 'Distribute this product',
		a2793: 'The initiator of the selected product alliance warehouse currently distributed has not bound the release template of the product, you can remind the initiator to bind the template for this product, or you can continue to distribute the product, and then bind your own new model, Publish again! ',
		a2794: 'Continue to distribute the current product',
		a2795: 'Successfully distributed this product! ',
		a2796: 'Are you sure you want to distribute the current product? ',
		a2797: 'Alliance Warehouse Products',
		a2798: 'Distribution selection library',
		a2799: 'Distribution finished product library',
		a2800: 'Overview of distribution products',
		a2801: 'remaining total inventory',
		a2802: 'Number of Agents',
		a2803: 'You currently do not limit the number of proxies',
		a2804: 'Sku quantity',
		a2805: 'Product Management',
		a2806: 'Agent price control',
		a2807: 'Add required pending information',
		a2808: 'Commodity collection',
		a2809: 'One-click collection',
		a2810: 'Link collection',
		a2811: 'Currently only supports the collection of products on the shopee platform, please enter the link of the product details page! ',
		a2812: 'Add to product template center',
		a2813: 'Warehouse parent SKU',
		a2814: 'Parent product name',
		a2815: 'Warehouse sub-commodity name (optional)',
		a2816: 'Fill in the warehouse sub-sku',
		a2817: 'Warehouse Subcommodity Name',
		a2818: 'Length (optional)',
		a2819: 'Width (optional)',
		a2820: 'Height (optional)',
		a2821: 'Please enter the parent sku of the warehouse',
		a2822: 'No more than 80 characters',
		a2823: 'No more than 120 characters',
		a2824: 'Download original image',
		a2825: 'Replace property map',
		a2826: 'Does it support 3/7 staging',
		a2827: 'Commodity volume',
		a2828: 'Please upload a picture! ',
		a2829: 'Please upload pictures in editing state',
		a2830: 'The update was successful! ',
		a2831: 'Save picture',
		a2832: 'Does it support a customized POD',
		a2833: 'Participation',
		a2834: 'Do not participate',
		a2835: 'Free sample application',
		a2836: 'Submit application',
		a2837: 'Successfully submit the free sample application, check the application progress, please go forward: I am an agent - sample application module',
		a2838: 'Sample application',
		a2839: 'Time range',
		a2840: 'Application Status',
		a2841: 'To be shipped',
		a2842: 'To be returned',
		a2843: 'Application time',
		a2844: 'Applicant',
		a2845: 'Recipient',
		a2846: 'Return comments',
		a2847: 'Return Note',
		a2848: 'Audit comments',
		a2849: 'Review Remarks',
		a2850: 'The current courier information has not been updated yet, please wait patiently, if you have any questions, please contact the supplier',
		a2851: 'Express information',
		a2852: 'Sample feedback video/photo',
		a2853: 'The supplier is processing and will return the points later',
		a2854: 'Distribution platform APP: It can realize APP selection and distribution, and publish it to Shopee, Lazada, TikTok and other platforms, including order review, return management, simultaneous translation, etc.',
		a2855: 'Select the product imported into the distribution warehouse',
		a2856: 'Perfect product information',
		a2857: 'Previous step',
		a2858: 'Next',
		a2859: 'Searchable product cusCode, parent/child SKU, commodity name',
		a2860: 'Supply price (unit: RMB)',
		a2861: 'The supply price is the one-piece delivery price provided to the seller, the purchase cost that the seller needs to pay for each piece out of the warehouse',
		a2862: 'The actual income of the supplier after deduction of the system commission is received',
		a2863: 'Collected',
		a2864: 'Available for sale inventory',
		a2865: 'Represents the maximum inventory available for distribution in overseas warehouses or private warehouses',
		a2866: 'The allocated inventory can only be allocated from the actual inventory in the warehouse, so it does not exceed the actual inventory in the warehouse',
		a2867: 'Separate inventory',
		a2868: 'Please enter the product name! ',
		a2869: 'Please enter the parent sku of the product',
		a2870: 'The supply price is required! ',
		a2871: "The transferred inventory cannot be greater than the product's inventory in the warehouse! ",
		a2872: 'Confirm submission? ',
		a2873: 'Successfully create a distribution product, is executing the division of inventory, binding template operations, do not leave the current page',
		a2874: 'Successfully split the inventory! ',
		a2875: 'Add to pending',
		a2876: 'Added successfully and the original template has been saved',
		a2877: 'Default retail price calculation formula',
		a2878: 'Temporary draft box',
		a2879: 'The maximum number of characters in the specification name on the shelf cannot exceed 20! ',
		a2880: 'The number of characters in the product title must be greater than 20 and less than 100',
		a2881: 'After choosing to publish a store, the system will automatically obtain category information',
		a2882: 'Select category',
		a2883: 'Selected category',
		a2884: 'Confirm the category and continue to publish the product',
		a2885: 'Please select a category! ',
		a2886: 'Confirm the category and continue to publish shopee products',
		a2887: 'Publish TikTok products',
		a2888: 'Confirm the category and continue to publish TikTok products',
		a2889: 'Pending order quantity',
		a2890: 'Pending order quantity',
		a2891: 'Fixed gross profit margin',
		a2892: 'View binding link',
		a2893: 'After closing the fixed gross profit margin, the system will no longer automatically calculate the distribution supply price of each sku based on the bound online products, confirm to continue to close? ',
		a2894: 'The warehouse product has not been bound to an online link yet! ',
		a2895: 'The warehouse product has no sub-SKU information! ',
		a2896: 'The product has been removed from the distribution platform! ',
		a2897: 'Products with a fixed gross profit rate cannot change the distribution supply price! ',
		a2898: 'Successfully modify the supply price',
		a2899: 'Product name:',
		a2900: 'Mother sku:',
		a2901: 'Remove inventory',
		a2902: 'Save changes',
		a2903: 'Basic information',
		a2904: 'Product name:',
		a2905: 'Commodity description:',
		a2906: 'Price on behalf of one piece (local)',
		a2907: 'Add to the purchase intention list',
		a2908: 'Final logistics:',
		a2909: 'Commodity volume:',
		a2910: 'Commodity weight:',
		a2911: 'Purchase Intent List',
		a2912: 'There is no picture for this specification',
		a2913: 'Clear the "Purchase Intent"',
		a2914: 'To generate a purchase order',
		a2915: 'This product already exists in the purchase intention list and cannot be added again',
		a2916: 'The bound template has been updated',
		a2917: 'Commodity binding details',
		a2918: 'Can be automatically bound',
		a2919: 'Pre-sale status',
		a2920: 'Number of pre-sale days',
		a2921: 'Open all sold out to pre-sale',
		a2922: 'Close all sold out and transfer to pre-sale',
		a2923: 'Remaining inventory',
		a2924: 'Is it bound',
		a2925: 'Unbind',
		a2926: 'Binding',
		a2927: 'Add warehouse product information',
		a2928: 'Stock quantity',
		a2929: 'Please select the parent SKU of the warehouse to be replaced (the original binding and configuration relationship remains unchanged)',
		a2930: 'Searchable parent sku',
		a2931: "When the product is converted to pre-sale, if the product has participated in shopee's Bundle Deal, My shop`s Flash Sale, Top Picks product promotions, please withdraw from the above activities by yourself!",
		a2932: 'Application',
		a2933: 'Restore',
		a2934: 'Category attribute',
		a2935: 'Basic attributes',
		a2936: 'Confirm Release',
		a2937: 'Stock price',
		a2938: 'New version information',
		a2939: 'Choose a country',
		a2940: 'Fill in the template name',
		a2941: 'Site selection',
		a2942: 'Binding template',
		a2943: 'Return for review',
		a2944: 'Product creation time',
		a2945: 'Publish to',
		a2946: 'The product is abnormal, please re-agent! ',
		a2947: 'Successful return! ',
		a2948: 'Please choose a template to bind! ',
		a2949: 'Southeast Asia Overseas Warehouse System Solution',
		a2950: 'Self-built overseas warehouse system supports ERP/WMS at the same time, supports Shopee/Lazade and other platforms, inventory synchronization/one-click distribution/claim assistant/multi-store chat, etc.',
		a2951: 'Provide one-stop store management solutions',
		a2952: 'Free to use',
		a2953: '0 cost entry',
		a2954: 'No initial installation fee/no server/one-click creation',
		a2955: 'Professional team support',
		a2956: 'A complete set of overseas warehouse management system training and technical support assistance will allow your overseas warehouse business to take off quickly. ',
		a2957: 'Quick start',
		a2958: 'Simplified version of fool-like operation, multi-language system (Chinese, English, Thai and Vietnamese) is convenient for locals in Southeast Asia to quickly learn and get started. ',
		a2959: 'More income sources',
		a2960: "Quality freight forwarders who pass the audit can enjoy the same price, and support more dealers' first journey/multi-national overseas warehouse peer prices. ",
		a2961: 'The seller promptly discovers the order rejected by COD or lost by express delivery, so that the seller can claim compensation from the platform in time, recover the loss and increase your net profit',
		a2962: 'WeChat recognition QR code',
		a2963: 'Add customer service WeChat',
		a2964: 'Our advantages',
		a2965: 'Provide high-quality overseas warehousing services',
		a2966: '7*12 Hours considerate customer service',
		a2967: 'Server Cluster Distributed',
		a2968: 'Overseas server',
		a2969: 'WeChat scan code',
		a2970: 'Scan code to download',
		a2971: 'Warehouse App',
		a2972: 'Overseas warehouse system that focuses on serving local sellers in Southeast Asia',
		a2973: 'WMS system entry',
		a2974: 'Partner join',
		a2975: 'App download',
		a2976: 'Local seller',
		a2977: 'Anti-oversold',
		a2978: 'Multi-platform and multi-store automatic synchronization inventory',
		a2979: 'Overseas Warehouse Management',
		a2980: 'Easy to use',
		a2981: 'Sow WMS',
		a2982: 'Multilingual',
		a2983: 'Extremely simplified',
		a2984: 'Data security',
		a2985: 'System stable',
		a2986: 'Extreme Efficiency',
		a2987: 'Southeast Asia',
		a2988: 'Focus on localization services in Southeast Asia for many years',
		a2989: 'Experience now',
		a2990: 'Support',
		a2991: 'Please use IE10 or above, Chrome, Firefox to browse with the best resolution above 1440×900',
		a2992: 'Professional overseas warehouse system solutions in Southeast Asia',
		a2993: 'Southeast Asian Freight Forwarder',
		a2994: '0 Cost to create an overseas warehouse',
		a2995: 'Support franchised warehouses to settle in, easily manage and control overseas warehouse customers',
		a2996: 'Create Southeast Asia WMS online overseas warehouse for free',
		a2997: 'Simple version of fool-like operation, multilingual system (Chinese, English, Thai and Vietnamese)',
		a2998: 'It is convenient for locals in Southeast Asia to learn quickly. ',
		a2999: 'A complete set of overseas warehouse management system training and technical support assistance',
		a3000: 'Let your overseas warehouse business take off quickly. ',
		a3001: 'Self-built overseas warehouse system',
		a3002: 'Support ERP/WMS at the same time, support Shopee/Lazade and other platforms',
		a3003: 'Inventory synchronization/one-key distribution/claim assistant/multi-store chat, etc.',
		a3004: 'Spot distribution platform in Southeast Asia/Taiwan',
		a3005: 'Contact us, and we will immediately create an overseas warehouse system in Southeast Asia at zero cost! ',
		a3006: 'All sold out and transferred to pre-sale',
		a3007: 'Optional',
		a3008: 'Bind product accessories inventory',
		a3009: `Only when the finished product is composed of multiple accessories into one product SKU, for example: an alarm clock is composed of 1 clock body + 2 AA batteries<br/>
		A finished alarm clock SKU is sold to the outside world. Once a finished alarm clock is sold, 1 clock body accessory inventory and 2 AA battery accessory inventory will be deducted.<br/>
		And the inventory quantity of the finished alarm clock depends on the number of accessory combinations. `,
		a3010: 'Increase',
		a3011: 'Choose the shop Xiaosheng head route',
		a3012: 'Estimated weight',
		a3013: 'Estimated volume',
		a3014: 'Create and submit a storage order',
		a3015: 'All sub-SKUs have been selected',
		a3016: 'Only when the finished product is composed of multiple accessories to form a product SKU, for example: an alarm clock is composed of 1 clock body + 2 AA batteries and a finished alarm clock SKU is sold externally, once 1 alarm clock is sold For finished products, one inventory of clock body accessories and two inventory of AA battery accessories will be deducted, and the inventory quantity of finished alarm clocks depends on the number of accessory combinations. ',
		a3017: 'Delete this product successfully! ',
		a3018: 'Failed to delete the current item! ',
		a3019: 'Please select the warehouse product to be deleted! ',
		a3020: 'The number of pieces entered is at least equal to or greater than 1',
		a3021: 'Only upload files with Excel (that is, the suffix is .xlsx)',
		a3022: 'The file size must not exceed 10M',
		a3023: 'File uploaded successfully',
		a3024: 'Please select the product that needs to be created and stored',
		a3025: 'Warehouse code is',
		a3026: 'Update pictures in warehouse',
		a3027: 'Only upload jpg/png files',
		a3028: 'Add item in warehouse',
		a3029: 'Turn off automatic update in warehouse',
		a3030: 'Open automatic update in the warehouse',
		a3031: 'Estimated arrival time',
		a3032: 'Arrival date',
		a3033: 'Enter the freight (the freight will directly affect the calculation of the value of the goods, it is recommended to enter)',
		a3034: 'Introduction to the configuration of the combined package library',
		a3035: `<p style="color:red;font-weight:bold;font-size:16px">If your online store sells combination package products, you need to configure the combination package library (if there is no combination package, you can ignore it)</p>
		<br />
		<p>Step 1. Create a [Combined Package Library]: import online products through [Manual Creation] or [Import Products];</p>
		<p>Note that only one link needs to be imported, and the rest of the other online product links of the same model need to be bound to the warehouse product just imported.</p>
		<router-link :to="{path:'/userStoreItems/products'}">
			<p style="color:#409EFF;padding:10px 0;cursor:pointer">If the product you sell online is an in-warehouse item, please see the configuration introduction of the in-warehouse item library.</p>
		</router-link>
		
		<br />
		<p>Step 2. Configure [Combination Package]: Click [Configure Package] of the sub-SKU, and select configuration from the generated [In-Warehouse];</p>
		<br />
		<p>①You must first create [In-Warehouse Item Library] before you can configure the combination package, see "Introduction to Setting Up In-Ware Order Item Library" for details)</p>
		<p>②The single product and the package must be in the same warehouse (it is not possible to create a single product in an overseas warehouse in Malaysia, but configure a package in an overseas warehouse in Thailand)</p>
		<p>③Packages cannot be deleted in the following cases: when a single product has been configured (it needs to be unconfigured first), when it has been stored in transit (it needs to be completed or deleted first)</p>
		<br />
		<p>Step 3. Bind online links: associate and bind the products in the [Combined Package Library] with the products of each online store;</p>
		<br />
		<p>①Can be automatically associated and bound (provided that the parent SKU of each online store needs to be completely consistent)</p>
		<p>②Can be manually associated and bound (each sub-SKU is bound to the corresponding online product of the store)</p>
		<p>③You can intuitively edit the automatic association and binding status of all stores.</p>
		<br />
		<p>Step 4. Enable synchronization of online inventory: batch operation or click [Automatically update online inventory] of the sub-sku to start synchronizing the actual inventory of the online package;</p>
		<br />
		<p>1、The actual remaining inventory of the package depends on the inventory ratio of the items in the warehouse. For example, if the selling package is a set of 2 red pens, and there are 10 red pens left in the single product library, then according to the matching ratio, only 5 pieces of the package are left in stock.</p>
		<br />
		<p>2、The package inventory cannot be directly modified, and the warehouse only needs to take stock of the actual quantity of [in the warehouse order warehouse]. The package library is configured virtually, so the inventory depends on the actual items in the warehouse. The in and out of the warehouse are all carried out in [in the warehouse order warehouse].</p>`,
		a3036: 'No more reminders in the future',
		a3037: 'Switch update online inventory',
		a3038: 'Move into the single product library in batches',
		a3039: 'Replace parent SKUs in batches',
		a3040: 'Create package',
		a3041: 'Manually create',
		a3042: 'Online import',
		a3043: 'Bind all child SKUs',
		a3044: 'Manual association binding',
		a3045: 'Automatic association binding',
		a3046: 'Delete parent sku',
		a3047: 'Manually add warehouse sub-SKU',
		a3048: 'Import warehouse sub-SKU online',
		a3049: 'Edit binding online situation',
		a3050: 'Depends on the maximum inventory quantity that can be combined from the actual in-warehouse items configured in the package',
		a3051: 'The online inventory of the bound product will always be updated to the actual online inventory in the warehouse (except for pre-sale products)',
		a3052: 'Individually packaged goods',
		a3053: 'Individual packaging inventory',
		a3054: 'Move into single product library',
		a3055: 'Cancel independent packaging',
		a3056: 'Set independent packaging',
		a3057: 'Together this time',
		a3058: 'Products have been turned off auto-update and are in stock! ',
		a3059: 'The automatic update is turned off and stored in the warehouse! ',
		a3060: 'Products have turned on auto-update and are in stock! ',
		a3061: 'The automatic update is turned on and stored in the warehouse! ',
		a3062: 'A product will be added to the single product library, please confirm? ',
		a3063: 'Are you sure you want to move to the single product library?',
		a3064: 'It has been moved into the item library! ',
		a3065: "When it is set to automatic, the number of inventories that need to be locked will be set according to the seller's actual setting. The default lock is 0, that is, no lock. ",
		a3066: 'Please confirm whether it is set as an individually packaged product?',
		a3067: 'Please confirm whether to cancel the individually packaged product?',
		a3068: 'Cancel successfully! ',
		a3069: 'Enter the product bar',
		a3070: 'Please enter the barcode information',
		a3071: 'The total inventory of single items consumed by the package to be shipped',
		a3072: 'Configure the package of this item',
		a3073: 'Suit warehouse code',
		a3074: 'Number of package configurations',
		a3075: 'Order inventory',
		a3076: 'Number of packages to be shipped',
		a3077: 'Introduction to setting up warehouse item library',
		a3078: `			<p style="color:red;font-weight:bold;font-size:16px">Notice! There is only one product in the warehouse, and all online sub-SKUs of the same item must be bound to the same in-warehouse product in order to effectively update the inventory synchronously.</p>
		<br />
		<p>Step 1. Establish [In-Warehouse]: Import online products through [Manual Creation] or [Import Products];</p>
		<p>Note that only one link needs to be imported, and the rest of the other online product links of the same model need to be bound to the warehouse product just imported.</p>
		<router-link :to="{path:'/userStoreItems/accessories'}">
			<p style="color:#409EFF;padding:10px 0;cursor:pointer">If your online sales product has a combination package, please see the introduction to the configuration of the combination package. If there is no package, go to the second step.</p>
		</router-link>
		<br />
		<p>Step 2. Associate and bind the products in [Warehouse Item Library] with the products in each online store;</p>
		<br />
		<p>①Can be automatically associated and bound (provided that the parent SKU of each online store needs to be completely consistent)</p>
		<p>②Can be manually associated and bound (each sub-SKU is bound to the corresponding online product of the store)</p>
		<p>③You can intuitively edit the automatic association and binding status of all stores.</p>
		<br />
		<p>Step 3. Turn on the synchronization inventory, batch operation or click [Automatically update online inventory] of the sub-sku, and the online inventory will start to be synchronized.</p>
		<br />
		<p>1. Out of stock: 1 piece of inventory is sold for any item on the platform, and 1 piece of inventory will also be subtracted from all related products in the store</p>
		<p>2. Warehousing: Newly arrived goods, after confirmation by both the seller and the warehouse, the inventory will automatically increase the arrival quantity of the corresponding goods.</p>
		<p>3. Pre-occupation: Any product on the platform that participates in the Flash sale event can automatically pre-occupy the inventory in the warehouse, and release it for sale after the event starts</p>
		<br />
		<p>Notice! Multiple online product links of the same model cannot be directly imported to generate multiple warehouse products, because there is only one physical product. To synchronize inventory accurately, you must first create [In-Warehouse Single Product] or [Combined Package], through [In-Warehouse Product] or [Combined Package] To bind multiple online links of the same product (for example, online links of the same model in different stores on Shopee or Lazade), that is, multiple online sub-SKUs of the same model are bound to the same in-warehouse product.</p>`,
		a3079: 'Automatically predict out-of-stock products based on the stocking cycle, the default stocking cycle is 7 days (can be modified)',
		a3080: 'Create a single product',
		a3081: 'Full warehouse product copy',
		a3082: 'Whole warehouse export',
		a3083: 'Please check! ',
		a3084: 'Rejected remarks:',
		a3085: 'Rejected',
		a3086: 'Do you want to apply for a self-built order for this sample?',
		a3087: 'Batch upload status',
		a3088: 'Please wait while uploading the product. . . ',
		a3089: 'Upload status',
		a3090: 'Publish TikTok Shop products in batches',
		a3091: 'Reselect category',
		a3092: 'Product List',
		a3093: 'Calculate the retail price according to the set formula',
		a3094: 'No formula yet',
		a3095: 'Click to set! ',
		a3096: 'Set now',
		a3097: `Set the pricing formula of the retail price, from left to right: outbound fee, exchange rate, discount, and profit margin:
		<p>1.Outbound fee: At present, the outbound fee for Malay warehouses is 3 yuan, you can fill in 3</p>
		<p>2.Exchange rate: the exchange rate of RMB to local currency, such as 1rmb=1.5 MYR, namely: 0.667 exchange rate</p>
		<p>3.Profit rate: the gross profit rate you want to earn, such as 30%, set 30</p>
		<p>4.Discount: If you are going to set the sales price as 40% off the original price, that is: 40 off</p>`,
		a3098: 'Immediately release',
		a3099: 'Published successfully',
		a3100: 'All industry belts',
		a3101: 'There is no industrial zone',
		a3102: 'Clearance',
		a3103: 'Support 3/7 staging',
		a3104: 'Brand side video material',
		a3105: 'Category:',
		a3106: 'Select a customized POD product',
		a3107: 'How does the seller distribute the supply? ',
		a3108: 'Find parent sku',
		a3109: 'Find product name',
		a3110: 'Find warehouse code',
		a3111: 'Some products are free of delivery fee, others are charged according to the package according to overseas warehouse standards',
		a3112: 'Estimated gross profit margin',
		a3113: 'Price on behalf of one piece',
		a3114: 'Exit operation fee',
		a3115: 'Free',
		a3116: 'Local spot stock',
		a3117: 'Contact Distributor',
		a3118: 'Account period purchase',
		a3119: 'Please confirm whether to distribute the product?',
		a3120: 'The product has been successfully distributed as an agent, and you can continue to distribute the goods. You can view all the products that have been distributed in "I have already acted as an agent".',
		a3121: 'Search warehouse code',
		a3122: 'Search product parent sku',
		a3123: 'All industry belts',
		a3124: 'Agent',
		a3125: 'Agency Account',
		a3126: 'Agent Name',
		a3127: 'Distribution activities',
		a3128: 'Clearance reminder',
		a3129: 'Current supply price',
		a3130: 'Online lowest retail discounted price (RMB)',
		a3131: 'H5 sharing page link',
		a3132: 'A seller has already represented this product',
		a3133: 'Activity description',
		a3134: 'Level 1 rebate ratio',
		a3135: 'Level 2 rebate ratio',
		a3136: 'Minimum commodity inventory',
		a3137: 'Active commodity category',
		a3138: 'Sign up now',
		a3139: 'Three-level rebate ratio',
		a3140: 'Clearance goods: the gross profit rate must be greater than or equal to 80%, and the supply price is less than 50% of the current supply price',
		a3141: 'Not eligible',
		a3142: 'Clearance supply price',
		a3143: 'Multi-level rebates, distribution and customer expansion, active recruitment',
		a3144: 'Supplier Operation Guidelines',
		a3145: 'Generate "My Distribution Sharing Page"',
		a3146: 'Launch date',
		a3147: 'I want to clear the warehouse',
		a3148: 'clearance goods',
		a3149: 'Off-shelf distribution',
		a3150: 'The distribution product update is successful! ',
		a3151: 'The gross profit margin of clearance products must be greater than 80%',
		a3152: 'The clearance supply price should be less than 50% of the current supply price',
		a3153: 'Submitted! ',
		a3154: 'This product is currently shared',
		a3155: 'A seller is selling online, and the user is not allowed to remove the product from the distribution platform. If you need to force the product to be removed, please contact the platform customer service? Customer service WeChat ID: shopsbu001',
		a3156: 'Are you sure to continue to take off the shelves?',
		a3157: 'Supplier:',
		a3158: 'The product has been removed from the distribution platform:',
		a3159: ', If the agent has successfully put the product on the shelf, please change the status of the product by yourself!',
		a3160: 'Success',
		a3161: 'Are you sure to participate in the distribution and customer expansion activities? ',
		a3162: 'Order/warehouse code query',
		a3163: 'No order record',
		a3164: 'Total supply price',
		a3165: 'Supplier paid in full',
		a3166: 'Supply unit price',
		a3167: 'Order Status:',
		a3168: 'Pending',
		a3169: 'Order records, do you want to continue this operation? ',
		a3170: 'Return points',
		a3171: 'Reject points',
		a3172: 'Batch consent',
		a3173: 'Batch rejection',
		a3174: 'Batch self-built orders',
		a3175: 'Points have been refunded',
		a3176: 'Photo/Video',
		a3177: 'The following is the video material of the brand side, which can be used in TIKTOK and other videos, pay attention to the secondary editing, and remove the duplication!',
		a3178: 'Link',
		a3179: 'Extraction code',
		a3180: 'Fill out, place an order now',
		a3181: 'Select purchase quantity',
		a3182: 'Place an order now',
		a3183: 'Buy Now',
		a3184: 'Successfully submit the order! ',
		a3185: 'Password',
		a3186: 'Please enter the user ID or mobile phone number',
		a3187: 'Login',
		a3188: 'No account? Click Register',
		a3189: 'Spot distribution',
		a3190: 'Distribution Operation Guidelines',
		a3191: "Guidelines for the operation of distribution on shelves in China's testing warehouse",
		a3192: 'Guidelines for the operation of distribution on the shelves of suppliers',
		a3193: 'Guidelines for Agents to List Operations',
		a3194: "Express air freight from China's Shenzhen testing warehouse to Southeast Asia (3 days), excluding air freight",
		a3195: 'Go to China to purchase',
		a3196: "China's wholesale supply is sufficient, and free samples are supported. After the first batch order, the sample fee can be refunded. Click to purchase directly, or contact the customer service staff of Xiaosheng.",
		a3197: 'All regions',
		a3198: 'Guide',
		a3199: 'All countries',
		a3200: 'Failed to upload pictures',
		a3201: 'Are you sure you want to delete this session?',
		a3202: 'Session deleted successfully',
		a3203: 'Please select a session object! ',
		a3204: 'Refresh session',
		a3205: 'Distributor',
		a3206: 'Historical Release Record',
		a3207: 'Published store',
		a3208: 'Release time',
		a3209: 'Release status',
		a3210: 'Publish failed',
		a3211: 'Re-edit and publish',
		a3212: 'Batch upload to TIKTOK',
		a3213: 'Generate retail mall page',
		a3214: 'Agent Operation Guidelines',
		a3215: 'Partial removal',
		a3216: 'Product release',
		a3217: 'Successfully delete the record! ',
		a3218: 'Operate after checking the product',
		a3219: 'This operation will delete',
		a3220: 'A record, please confirm whether to continue? ',
		a3221: 'Add to cart',
		a3222: 'Business Consulting',
		a3223: 'Please enter content...',
		a3224: 'My supply',
		a3225: 'Issuing the order on behalf of the order',
		a3226: 'The location of the source',
		a3227: 'Refused to return remarks:',
		a3228: 'Refusal to return',
		a3229: 'Move into package library',
		a3230: 'Belonging package',
		a3231: 'Assorted gifts',
		a3232: 'Manually create the item sku in the warehouse order',
		a3233: 'Are you sure you want to move into the package library?',
		a3234: 'It has been moved into the package library! ',
		a3235: 'Retail original price - (local currency)',
		a3236: 'Supply price-(unit/¥)',
		a3237: 'Associated cusCode',
		a3238: 'Approved application',
		a3239: 'Upload photo/video',
		a3240: 'The application has been rejected',
		a3241: 'Successfully self-created order, please go to: my order module to view',
		a3242: 'Recharge & Quotation',
		a3243: 'Please upload pictures/videos',
		a3244: 'My application',
		a3245: 'Agent sample application',
		a3246: 'Warehouse rental fee',
		a3247: 'package fee',
		a3248: 'The brand attribute of the product is not selected',
		a3249: 'Duplicate sku sales attribute',
		a3250: 'Published successfully! ',
		a3251: 'The product attributes with red asterisks are required',
		a3252: 'System exception',
		a3253: 'The length of the sku name does not exceed 20 characters',
		a3254: 'The attribute of the red starry sky is required',
		a3255: 'The character length of the product title should be between 20 and 100 characters',
		a3256: 'A product with the same product title already exists in the current store! ',
		a3257: 'The retail price of sku, the maximum value divided by the minimum value cannot be greater than 7',
		a3258: 'Overseas Warehouse',
		a3259: 'Default printing face list & picking list',
		a3260: 'There is no bound warehouse',
		a3261: 'There is no bound store yet',
		a3262: 'Order delivery fee expenditure',
		a3263: 'Order delivery fee income',
		a3264: 'Storage order shelf fee expenditure',
		a3265: 'Revenue of shelf fee for storage order',
		a3266: 'Return processing fee expenditure',
		a3267: 'Return processing fee income',
		a3268: 'Platform deduction',
		a3269: 'Order delivery fee expenditure (P)',
		a3270: 'Order delivery fee income (P)',
		a3271: 'Storage order shelving fee expenditure (P)',
		a3272: 'Revenue of shelf fee for storage order (P)',
		a3273: 'Sample application fee payment',
		a3274: 'Sample application fee income',
		a3275: 'The description information of the product is between 2-3000 characters',
		a3276: 'Outgoing fee income',
		a3277: 'Listing Fee Income',
		a3278: 'Return revenue',
		a3279: 'Warehouse miscellaneous fee income',
		a3280: 'Warehouse rent fee income (P)',
		a3281: 'Platform deduction income',
		a3282: 'Platform deduction of expenses',
		a3283: 'Listing fee income (P)',
		a3284: 'Outgoing fee income (P)',
		a3285: 'Purchase Order',
		a3286: 'Full purchase',
		a3287: 'Deposit purchase',
		a3288: 'Deposit:',
		a3289: 'Final payment:',
		a3290: 'Final payment:',
		a3291: 'Reminder to pay the balance',
		a3292: 'The message has been successfully sent to provide the buyer with the balance payment',
		a3293: 'Product purchase fee income',
		a3294: 'Please upload the size chart',
		a3295: 'Size Chart',
		a3296: 'Product purchase fee expenditure',
		a3297: 'Returning points has been refused',
		a3298: 'Distribution platform agency fee expenditure',
		a3299: 'Distribution platform agency fee income',
		a3300: 'Currently insufficient points, please recharge and try again',
		a3301: 'Payssion recharge income',
		a3302: 'Payssion recharge expenditure',
		a3303: 'The distribution is successful, please go to "I am an agent" to check',
		a3304: 'Please confirm whether you want to distribute this product?',
		a3305: 'Scan to download APP',
		a3306: 'Distribution platform APP (Android)',
		a3307: 'Multi-level distribution products',
		a3308: 'Distributor Level 1 Rebate Expenditure',
		a3309: 'Distribution Level 1 Rebate Income',
		a3310: 'Distribution secondary rebate expenses',
		a3311: 'Distribution secondary rebate income',
		a3312: 'Distribution three-level rebate expenditure',
		a3313: 'Distribution three-level rebate income',
		a3314: 'Multilevel Distribution Statistics',
		a3315: 'General agent quantity',
		a3316: 'General agent purchase amount',
		a3317: 'Gross revenue commission',
		a3318: 'Search Agent Account',
		a3319: 'Agent level',
		a3320: 'Agent account',
		a3321: 'First-level promoter',
		a3322: 'Secondary Promoter',
		a3323: 'Third level promoter',
		a3324: 'Total purchase amount',
		a3325: 'Total commission',
		a3326: 'Proxy analysis',
		a3327: 'Purchase amount',
		a3328: 'Commission',
		a3329: 'Modify the store',
		a3330: 'Product Inventory Token',
		a3331: 'Token for US Region Order Shipment',
		a3332: 'European region order shipping token',
		a3333: 'Store Currency',
		a3334: 'Please fill in the store ID',
		a3335: 'Please fill in the store name',
		a3336: 'Please select store type',
		a3337: 'USA',
		a3338: 'UK',
		a3339: 'Germany',
		a3340: 'Italy',
		a3341: 'France',
		a3342: 'Spain',
		a3343: 'Semi hosted',
		a3344: 'Fully Managed',
		a3345: 'Local store',
		a3346: 'Hong Kong themed store',
		a3347: 'Non Hong Kong main store',
		a3348: 'Logistics status',
		a3349: 'Online order placed',
		a3350: 'No online order placed',
		a3351: 'Library Management',
		a3352: 'Custom Library',
		a3353: 'Create a board',
		a3354: 'No graphics available',
		a3355: 'Create a master',
		a3356: 'Page Name',
		a3357: 'Layout type',
		a3358: 'Layout model',
		a3359: 'Size and Model',
		a3360: 'Color Name',
		a3361: 'Size',
		a3362: 'Color',
		a3363: 'Please enter the layout name',
		a3364: 'Please select the layout type',
		a3365: 'Please enter the version model',
		a3366: 'Please upload a picture',
		a3367: 'Please enter size and model',
		a3368: 'Please enter the color name',
		a3369: '1、DiangXiaosheng - Provide cross-border localization of overseas warehouse and distribution solutions',
		a3370: '2、DiangXiaosheng - Focus on small and medium parts of the United States/Southeast Asia localization services',
		a3371: 'Please fill in the invitation code, currently only for internal invited users. You can contact customer service on WeChat: shopsbu001',
		a3372: 'Synchronize product links',
		a3373: 'Platform processing',
		a3374: 'Batch queries cannot exceed 200!',
		a3375: 'batch loading to TEMU',
		a3376: 'batch products to TEMU',
		a3377: 'download the import template',
		a3378: 'click to download the template of the bulk products to the TEMU background',
		a3379: 'import the product file on the shelf',
		a3380: `1、 This template is only applicable to non clothing categories. At present, only bathroom antiskid pads are open; Beach towel; Small cover blanket, lunch blanket; The above three categories. <br>
2、 There is a corresponding relationship between the goods category and the attribute template, which should be filled in according to the corresponding template rules. <br>
3、 Product title length verification: {A. length limit 100[cat1Id=1 (CD and vinyl record)] B. length limit 200[cat1Id=653 (office supplies), cat1Id=25,439 (toys and games)]
C、 The length limit is 500[cat1Id=2,542 (Electronic)] D. remove the above 4 categories, and the other length limit is 250}. <br>
4、 Product classification: A. bathroom antiskid pad [11,802] B. beach towel [11,809] C small cover blanket, lunch blanket [11,901] please copy the above classification to fill in. `,
		a3381: '[Important Note!!!] Please ensure that the table data you upload is accurate and error-free.',
		a3382: 'After submitting the batch listing form, the system will automatically process it and cannot be interrupted or cancelled.',
		a3383: 'Please be sure to carefully check the contents of the form and submit it only after confirmation to avoid losses caused by data errors.',
		a3384: 'The platform shall not be held responsible for any consequences arising from inaccurate data or operational errors.',
		a3385: 'Start importing',
		a3386: 'Import record',
		a3387: 'File name',
		a3388: 'Total number of files',
		a3389: 'Pending execution',
		a3390: 'In execution',
		a3391: 'Implemented',
		a3392: 'Stopped',
		a3393: 'Execution progress',
		a3394: 'Number of successful listings',
		a3395: 'Failed listing record',
		a3396: 'Start time',
		a3397: 'End time',
		a3398: 'Stop',
		a3399: 'Standard product image library',
		a3400: 'Platform heatmap',
		a3401: 'Select Group',
		a3402: 'Batch publish to platform gallery',
		a3403: 'Gallery Grouping',
		a3404: 'Create group',
		a3405: 'Please enter the group name',
		a3406: 'Customized content',
		a3407: 'uppercase',
		a3408: 'lowercase',
		a3409: 'Please upload a file with the suffix .xlsx! ',
		a3410: 'The file is currently being uploaded. Please do not close the page and wait for the system to indicate success! ',
		a3411: "Do you want to stop listing? Once stopped, you will not be able to continue listing and will need to resubmit the form.' ?",
		a3412: 'Do you want to stop listing and delete this table? ',
		a3413: 'This table has been successfully listed. Do you want to delete this record? ',
		a3414: 'Are you sure to delete this table? ',
		a3415: 'Number of exceptions after stock-out',
		a3416: 'Distributor price',
		a3417: 'Please enter the distribution price!',
		a3418: 'Download this single print drawing',
		a3419: 'Batch Download and Print Diagrams',
		a3420: 'Image generation in progress',
		a3421: 'No images to be downloaded temporarily.',
		a3422: 'The printing image requires a resolution of 150 DPI, and upon verification, the current printing image is',
		a3423: 'DPI, please resubmit!',
		a3424: 'Batch Download Waybill',
		a3425: 'Please wait a moment while the system automatically reviews the print resolution and logistics information. Please remain patient! ',
		a3426: 'If the POD product involves purchasing multiple items of the same model, code, and image, multiple warehouse products need to be added and multiple printed images provided. For example, if purchasing two items of the same model and code, one warehouse item needs to be added and two identical printed images need to be submitted. ',
	}

}

export default en
